import { useState, useEffect, useRef } from "react";
import { AuthService } from "./supabase_client";

// ─── STRIPE ──────────────────────────────────────────────────────────────────
const STRIPE_PK = "pk_test_51TD46RJBuc6jxPBP3eltatxBckoBNSy7Mc3Sn2IjTyH7K72Q6c5mZ15apn2YIxdP5UPP7DgHkFYy1vd5vBuZBQCQ00T4PrnA73";

let stripeLoaded = false;
function loadStripe() {
  return new Promise((resolve) => {
    if(window.Stripe) { resolve(window.Stripe(STRIPE_PK)); return; }
    if(stripeLoaded) { const w = setInterval(()=>{ if(window.Stripe){ clearInterval(w); resolve(window.Stripe(STRIPE_PK)); }},100); return; }
    stripeLoaded = true;
    const s = document.createElement("script");
    s.src = "https://js.stripe.com/v3/";
    s.onload = () => resolve(window.Stripe(STRIPE_PK));
    document.head.appendChild(s);
  });
}

// ─── SECURITY HELPERS ────────────────────────────────────────────────────────
const sanitize = (str) => {
  if(typeof str !== 'string') return '';
  return str.replace(/[<>"'`]/g, '').trim().slice(0, 200);
};
const sanitizePhone = (phone) => phone.replace(/[^0-9+\s\-()]/g, '').slice(0, 15);

// ─── REGIONS DATA (103 περιοχές από Excel) ────────────────────────────────────
const REGIONS_DATA = [
  {"line":"Γραμμή 1","region":"Πειραιάς","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 1","region":"Φάληρο","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 1","region":"Μοσχάτο","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Καλλιθέα","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Ταύρος","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Πετράλωνα","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Θησείο","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 1","region":"Μοναστηράκι","price":6.0,"user_earn":3.0},
  {"line":"Γραμμή 1","region":"Ομόνοια","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 1","region":"Βικτώρια","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 1","region":"Αττική","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 1","region":"Άγιος Νικόλαος","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Κ. Πατήσια","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Άγιος Ελευθέριος","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Α. Πατήσια","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Περισσός","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 1","region":"Πευκάκια","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 1","region":"Ν. Ιωνία","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 1","region":"Ηράκλειο","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 1","region":"Ειρήνη","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 1","region":"Νερατζιώτισσα","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 1","region":"Μαρούσι","price":4.5,"user_earn":2.25},
  {"line":"Γραμμή 1","region":"ΚΑΤ","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 1","region":"Κηφισιά","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 2","region":"Ανθούπολη","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Περιστέρι","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Άγ. Αντώνιος","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Σεπόλια","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Αττική","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Στ. Λαρίσης","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Μεταξουργείο","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 2","region":"Ομόνοια","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 2","region":"Πανεπιστήμιο","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 2","region":"Σύνταγμα","price":7.5,"user_earn":3.75},
  {"line":"Γραμμή 2","region":"Ακρόπολη","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 2","region":"Συγγρού-Φιξ","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 2","region":"Ν. Κόσμος","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Άγ. Ιωάννης","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Δάφνη","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Άγιος Δημήτριος","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 2","region":"Ηλιούπολη","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 2","region":"Άλιμος","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Αργυρούπολη","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 2","region":"Ελληνικό","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 3","region":"Δημοτικό Θέατρο","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 3","region":"Πειραιάς","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 3","region":"Μανιάτικα","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 3","region":"Νίκαια","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 3","region":"Κορυδαλλός","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 3","region":"Αγία Βαρβάρα","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 3","region":"Αιγάλεω","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 3","region":"Ελαιώνας","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 3","region":"Κεραμεικός","price":4.5,"user_earn":2.25},
  {"line":"Γραμμή 3","region":"Μοναστηράκι","price":6.0,"user_earn":3.0},
  {"line":"Γραμμή 3","region":"Σύνταγμα","price":6.0,"user_earn":3.0},
  {"line":"Γραμμή 3","region":"Ευαγγελισμός","price":6.0,"user_earn":3.0},
  {"line":"Γραμμή 3","region":"Μέγαρο Μουσικής","price":6.0,"user_earn":3.0},
  {"line":"Γραμμή 3","region":"Αμπελόκηποι","price":4.5,"user_earn":2.25},
  {"line":"Γραμμή 3","region":"Πανόρμου","price":4.5,"user_earn":2.25},
  {"line":"Γραμμή 3","region":"Κατεχάκη","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 3","region":"Ελληνορώσων","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 3","region":"Χολαργός","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 3","region":"Νομισματοκοπείο","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 3","region":"Αγ. Παρασκευή","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 3","region":"Χαλάνδρι","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 3","region":"Δουκίσσης Πλακεντίας","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 3","region":"Παιανία-Κάντζα","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 3","region":"Κορωπί","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 3","region":"Αεροδρόμιο","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 4","region":"Άλσος Βεΐκου","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 4","region":"Γαλάτσι","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 4","region":"Ελικώνος","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 4","region":"Κυψέλη","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 4","region":"Δικαστήρια","price":5.5,"user_earn":2.75},
  {"line":"Γραμμή 4","region":"Αλεξάνδρας","price":5.5,"user_earn":2.75},
  {"line":"Γραμμή 4","region":"Εξάρχεια","price":6.0,"user_earn":3.0},
  {"line":"Γραμμή 4","region":"Ακαδημία","price":6.0,"user_earn":3.0},
  {"line":"Γραμμή 4","region":"Κολωνάκι","price":8.0,"user_earn":4.0},
  {"line":"Γραμμή 4","region":"Ευαγγελισμός","price":6.0,"user_earn":3.0},
  {"line":"Γραμμή 4","region":"Καισαριανή","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 4","region":"Πανεπιστημιούπολη","price":4.0,"user_earn":2.0},
  {"line":"Γραμμή 4","region":"Ιλίσια","price":4.5,"user_earn":2.25},
  {"line":"Γραμμή 4","region":"Ζωγράφου","price":4.5,"user_earn":2.25},
  {"line":"Γραμμή 4","region":"Γουδή","price":3.5,"user_earn":1.75},
  {"line":"Χωρίς Μετρό","region":"Νέα Ερυθραία","price":4.0,"user_earn":2.0},
  {"line":"Χωρίς Μετρό","region":"Εκάλη","price":4.0,"user_earn":2.0},
  {"line":"Χωρίς Μετρό","region":"Βριλήσσια","price":3.0,"user_earn":1.5},
  {"line":"Χωρίς Μετρό","region":"Μελίσσια","price":3.0,"user_earn":1.5},
  {"line":"Χωρίς Μετρό","region":"Πεύκη","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Λυκόβρυση","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Παλλήνη","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Γέρακας","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Σπάτα","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Αρτέμιδα","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Βάρη","price":4.0,"user_earn":2.0},
  {"line":"Χωρίς Μετρό","region":"Βαρκίζα","price":4.0,"user_earn":2.0},
  {"line":"Χωρίς Μετρό","region":"Βουλιαγμένη","price":6.0,"user_earn":3.0},
  {"line":"Χωρίς Μετρό","region":"Λαγονήσι","price":3.0,"user_earn":1.5},
  {"line":"Χωρίς Μετρό","region":"Σαρωνίδα","price":3.0,"user_earn":1.5},
  {"line":"Χωρίς Μετρό","region":"Χαϊδάρι","price":3.0,"user_earn":1.5},
  {"line":"Χωρίς Μετρό","region":"Αχαρνές","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Σαλαμίνα","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Ελευσίνα","price":3.0,"user_earn":1.5},
];

// ─── ΘΕΣΣΑΛΟΝΙΚΗ DATA ────────────────────────────────────────────────────────
const THESSALONIKI_DATA = [
  {"line":"Γραμμή 1","region":"Νέος Σιδηροδρομικός Σταθμός","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 1","region":"Δημοκρατίας","price":3.5,"user_earn":1.75},
  {"line":"Γραμμή 1","region":"Βενιζέλου","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 1","region":"Αγίας Σοφίας","price":5.0,"user_earn":2.5},
  {"line":"Γραμμή 1","region":"Σιντριβάνι/Έκθεση","price":4.25,"user_earn":2.125},
  {"line":"Γραμμή 1","region":"Πανεπιστήμιο","price":4.25,"user_earn":2.125},
  {"line":"Γραμμή 1","region":"Παπάφη","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Ευκλείδης","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Φλέμινγκ","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"Ανάληψη","price":3.0,"user_earn":1.5},
  {"line":"Γραμμή 1","region":"25ης Μαρτίου","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 1","region":"Βούλγαρη","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 1","region":"Νέα Ελβετία","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 2","region":"Νομαρχία","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 2","region":"Καλαμαριά","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 2","region":"Αρετσού","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 2","region":"Νέα Κρήνη","price":2.5,"user_earn":1.25},
  {"line":"Γραμμή 2","region":"Μίκρα","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Λαδάδικα","price":6.0,"user_earn":3.0},
  {"line":"Χωρίς Μετρό","region":"Λευκός Πύργος / Παραλία","price":6.5,"user_earn":3.25},
  {"line":"Χωρίς Μετρό","region":"Άνω Πόλη","price":3.0,"user_earn":1.5},
  {"line":"Χωρίς Μετρό","region":"Τούμπα (Πλατεία)","price":3.5,"user_earn":1.75},
  {"line":"Χωρίς Μετρό","region":"Χαριλάου (Πάρκο)","price":3.0,"user_earn":1.5},
  {"line":"Χωρίς Μετρό","region":"Σταυρούπολη (Πλατεία)","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Εύοσμος (Πλατεία)","price":3.0,"user_earn":1.5},
  {"line":"Χωρίς Μετρό","region":"Πολίχνη","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Θέρμη (Κέντρο)","price":2.5,"user_earn":1.25},
  {"line":"Χωρίς Μετρό","region":"Πανόραμα (Κέντρο)","price":3.5,"user_earn":1.75},
];

// ─── CITIES ──────────────────────────────────────────────────────────────────
const LAMIA_DATA = [
  {"line":"Κέντρο","region":"Κέντρο Λαμίας","price":2.5,"user_earn":1.25},
  {"line":"Κέντρο","region":"Πλατεία Λαού - Όθωνος","price":2.25,"user_earn":1.125},
  {"line":"Κέντρο","region":"Οδός Λεωνίδα","price":2.0,"user_earn":1.0},
  {"line":"Προάστια","region":"Νέα Μαγνησία","price":1.0,"user_earn":0.5},
];

const CITIES = {
  "Αθήνα": REGIONS_DATA,
  "Θεσσαλονίκη": THESSALONIKI_DATA,
  "Λαμία": LAMIA_DATA,
};

const getRegionsForCity = (city) => CITIES[city] || REGIONS_DATA;
const getRegionsListForCity = (city) => [...new Set(getRegionsForCity(city).map(r=>r.region))].sort((a,b)=>a.localeCompare(b,'el'));
const ALL_REGIONS = [...new Set(REGIONS_DATA.map(r=>r.region))].sort((a,b)=>a.localeCompare(b,'el'));
const getR = (region, city="Αθήνα") => getRegionsForCity(city).find(r=>r.region===region)||null;
const LINE_COLORS = {"Γραμμή 1":"#00D4AA","Γραμμή 2":"#F59E0B","Γραμμή 3":"#0099FF","Γραμμή 4":"#A855F7","Χωρίς Μετρό":"#6B7A99","Κέντρο":"#00D4AA","Προάστια":"#6B7A99"};

// ─── DESIGN ────────────────────────────────────────────────────────────────────
const C={bg:"#0A0E1A",surface:"#111827",card:"#1A2235",accent:"#00C8C8",glow:"rgba(0,200,200,0.15)",warn:"#F59E0B",danger:"#EF4444",text:"#F0F4FF",muted:"#6B7A99",border:"#1E2D45",blue:"#1A2EAA"};
const CL={...C,bg:"#F0F4FF",surface:"#FFFFFF",card:"#F8FAFF",text:"#0A0E1A",muted:"#6B7A99",border:"#D1D9EE"};
const useT=(dark)=>dark?C:CL;
const DISCLAIMER="⚠️ Δεν πουλάμε δημόσιες θέσεις. Πουλάμε την πληροφορία — ποιος φεύγει και πότε.";
const PRIVACY_NOTE="🔒 Κανένα προσωπικό στοιχείο (τηλέφωνο, email, ονοματεπώνυμο) δεν κοινοποιείται μεταξύ χρηστών.";

// Υπολογισμός τιμής για Seeker με Stripe fees ενσωματωμένα
// Έτσι ο Giver και η ToParking παίρνουν καθαρά χρήματα
const seekerPrice = (price) => {
  if(!price) return 0;
  // Stripe EU: 1.4% + €0.25 → price_with_fee = (price + 0.25) / (1 - 0.014)
  return Math.ceil(((price + 0.25) / (1 - 0.014)) * 100) / 100;
};

// ─── COMPONENTS ────────────────────────────────────────────────────────────────
function Logo({size=28}){
  return <div style={{display:"flex",alignItems:"center",gap:8}}>
    <img src="/ToParking.png" alt="ToParking" style={{width:size*1.4,height:size*1.4,objectFit:"contain"}}/>
    <span style={{fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:size*0.85,color:"#1A2EAA",letterSpacing:-0.5}}>ToParking</span>
  </div>;
}
function Btn({children,onClick,variant="primary",style={},disabled=false}){
  const v={primary:{background:`linear-gradient(135deg,${C.accent},#1A2EAA)`,color:"#fff",boxShadow:`0 4px 20px ${C.glow}`},secondary:{background:C.card,color:C.text,border:`1px solid ${C.border}`},danger:{background:C.danger,color:"#fff"},ghost:{background:"transparent",color:C.accent,border:`1px solid ${C.accent}`},warn:{background:C.warn,color:"#fff"}};
  return <button style={{padding:"12px 24px",borderRadius:12,border:"none",cursor:disabled?"not-allowed":"pointer",fontFamily:"'Syne',sans-serif",fontWeight:700,fontSize:14,transition:"all 0.2s",opacity:disabled?0.5:1,...v[variant],...style}} onClick={disabled?undefined:onClick}>{children}</button>;
}
function Input({label,value,onChange,placeholder,type="text",options}){
  const s={width:"100%",padding:"11px 14px",borderRadius:10,border:`1px solid ${C.border}`,background:C.surface,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"'DM Sans',sans-serif"};
  return <div style={{marginBottom:14}}>
    {label&&<div style={{fontSize:12,color:C.muted,marginBottom:5,fontWeight:600}}>{label}</div>}
    {options?<select style={s} value={value} onChange={e=>onChange(e.target.value)}><option value="">Επιλογή...</option>{options.map(o=><option key={o} value={o}>{o}</option>)}</select>
    :<input style={s} type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}/>}
  </div>;
}
// ─── CUSTOM REGION MODAL ──────────────────────────────────────────────────────
function CustomRegionModal({regionName, onClose, onConfirm}){
  const [city, setCity] = useState(regionName||"");
  const [street, setStreet] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    if(!city.trim()) return;
    try {
      const { supabase } = await import("./supabase_client");
      const { data: authData } = await supabase.auth.getUser();
      const au = authData?.user;
      let userId = null;
      if(au) {
        const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).maybeSingle();
        userId = profile?.id || null;
      }
      // Έλεγξε αν υπάρχει ήδη αίτημα για αυτή την περιοχή
      const { data: existing } = await supabase
        .from('region_requests')
        .select('id, request_count')
        .eq('region_name', city.trim())
        .eq('status', 'pending')
        .maybeSingle();

      if(existing) {
        // Αύξηση request_count αν υπάρχει ήδη
        await supabase
          .from('region_requests')
          .update({ request_count: (existing.request_count || 1) + 1 })
          .eq('id', existing.id);
      } else {
        // Νέο αίτημα
        await supabase.from('region_requests').insert({
          user_id: userId,
          region_name: city.trim(),
          street: street.trim() || null,
          status: 'pending',
          request_count: 1,
        });
      }
    } catch(e) {
      console.error('Region request error:', e);
    }
    setSubmitted(true);
    setTimeout(()=>{ onConfirm(city.trim()); }, 2800);
  };

  const s = {width:"100%",padding:"11px 14px",borderRadius:10,border:`1px solid ${C.border}`,background:C.surface,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"'DM Sans',sans-serif"};

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:200,display:"flex",alignItems:"flex-end",justifyContent:"center",backdropFilter:"blur(3px)"}}>
      <div style={{background:C.card,borderRadius:"20px 20px 0 0",border:`1px solid ${C.border}`,borderBottom:"none",width:"100%",maxWidth:430,padding:24,paddingBottom:36}}>

        {!submitted ? <>
          {/* Header */}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:18}}>
            <div>
              <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:17}}>📍 Νέα Περιοχή</div>
              <div style={{color:C.muted,fontSize:12,marginTop:3}}>Η περιοχή δεν βρέθηκε στη λίστα μας</div>
            </div>
            <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:C.muted,fontSize:22,lineHeight:1}}>✕</button>
          </div>

          {/* Info box */}
          <div style={{background:"rgba(0,212,170,0.08)",border:`1px solid ${C.accent}33`,borderRadius:12,padding:12,marginBottom:18}}>
            <div style={{color:C.accent,fontWeight:700,fontSize:12,marginBottom:4}}>ℹ️ Πώς λειτουργεί;</div>
            <div style={{color:C.muted,fontSize:11,lineHeight:1.6}}>
              Αν η περιοχή δεν υπάρχει στη λίστα, μπορείς να τη συμπληρώσεις. Η ομάδα ToParking θα ενημερωθεί αυτόματα και θα αξιολογήσει τη ζήτηση για να την κοστολογήσει. <b style={{color:C.text}}>Θα λάβεις ενημέρωση σύντομα.</b>
            </div>
          </div>

          {/* Form */}
          <div style={{marginBottom:12}}>
            <div style={{fontSize:12,color:C.muted,marginBottom:5,fontWeight:600}}>Περιοχή / Δήμος *</div>
            <input style={s} value={city} onChange={e=>setCity(e.target.value)} placeholder="π.χ. Αιγάλεω, Νέα Σμύρνη..."/>
          </div>
          <div style={{marginBottom:20}}>
            <div style={{fontSize:12,color:C.muted,marginBottom:5,fontWeight:600}}>Οδός (προαιρετικό)</div>
            <input style={s} value={street} onChange={e=>setStreet(e.target.value)} placeholder="π.χ. Λεωφόρος Αθηνών"/>
          </div>

          <div style={{display:"flex",gap:10}}>
            <button onClick={onClose} style={{flex:1,padding:"12px",borderRadius:12,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,cursor:"pointer",fontWeight:700,fontSize:14,fontFamily:"'Syne',sans-serif"}}>Άκυρο</button>
            <button onClick={handleSubmit} disabled={!city.trim()} style={{flex:2,padding:"12px",borderRadius:12,border:"none",background:city.trim()?`linear-gradient(135deg,${C.accent},#1A2EAA)`:"#2a3550",color:city.trim()?"#fff":C.muted,cursor:city.trim()?"pointer":"not-allowed",fontWeight:700,fontSize:14,fontFamily:"'Syne',sans-serif",boxShadow:city.trim()?`0 4px 16px ${C.glow}`:"none"}}>
              📨 Αποστολή Αιτήματος
            </button>
          </div>
        </> : <>
          {/* ── Επιτυχία ── */}
          <div style={{textAlign:"center",padding:"10px 0"}}>
            <div style={{fontSize:52,marginBottom:12}}>✅</div>
            <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:17,marginBottom:10}}>Αίτημα Στάλθηκε!</div>

            {/* Εταιρία */}
            <div style={{background:"rgba(168,85,247,0.1)",border:"1px solid rgba(168,85,247,0.3)",borderRadius:12,padding:14,marginBottom:10,textAlign:"left"}}>
              <div style={{color:"#C084FC",fontWeight:700,fontSize:12,marginBottom:4}}>📬 Ειδοποίηση εταιρίας</div>
              <div style={{color:C.muted,fontSize:11,lineHeight:1.6}}>
                Η ομάδα <b style={{color:C.text}}>ToParking</b> έλαβε αίτημα για την περιοχή <b style={{color:"#C084FC"}}>"{city}"</b>. Θα αξιολογήσουμε τη ζήτηση και θα κοστολογήσουμε τη νέα ζώνη.
              </div>
            </div>

            {/* Χρήστης */}
            <div style={{background:"rgba(0,212,170,0.08)",border:`1px solid ${C.accent}33`,borderRadius:12,padding:14,textAlign:"left"}}>
              <div style={{color:C.accent,fontWeight:700,fontSize:12,marginBottom:4}}>📱 Ειδοποίηση σε εσένα</div>
              <div style={{color:C.muted,fontSize:11,lineHeight:1.6}}>
                Θα ενημερωθείς μόλις η περιοχή <b style={{color:C.text}}>"{city}"</b> ενταχθεί στο σύστημα. Εν τω μεταξύ, μπορείς να επιλέξεις μια γειτονική περιοχή.
              </div>
            </div>

            <div style={{color:C.muted,fontSize:10,marginTop:12}}>Κλείνει αυτόματα...</div>
          </div>
        </>}
      </div>
    </div>
  );
}

function SearchInput({label,value,onChange,city="Αθήνα"}){
  const [q,setQ]=useState("");
  const [showModal,setShowModal]=useState(false);
  const [pendingRegion,setPendingRegion]=useState("");
  const s={width:"100%",padding:"11px 14px",borderRadius:10,border:`1px solid ${C.border}`,background:C.surface,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"};
  const cityRegions = getRegionsListForCity(city);
  const filtered=q?cityRegions.filter(r=>r.toLowerCase().includes(q.toLowerCase())):[];
  const noResults = q.length>=2 && filtered.length===0;

  const handleCustomRegion = (regionName) => {
    setPendingRegion(regionName);
    setShowModal(true);
  };

  const handleConfirm = (regionName) => {
    onChange(`${regionName} (υπό έλεγχο)`);
    setQ("");
    setShowModal(false);
    setPendingRegion("");
  };

  return <>
    {showModal && <CustomRegionModal regionName={pendingRegion} onClose={()=>setShowModal(false)} onConfirm={handleConfirm}/>}
    <div style={{marginBottom:14,position:"relative"}}>
      {label&&<div style={{fontSize:12,color:C.muted,marginBottom:5,fontWeight:600}}>{label}</div>}
      <input style={s} value={value||q} onChange={e=>{setQ(e.target.value);if(!e.target.value)onChange("");}} placeholder="Αναζήτηση περιοχής..."/>
      {q&&!value&&<div style={{position:"absolute",left:0,right:0,top:"100%",background:C.card,border:`1px solid ${C.border}`,borderRadius:10,zIndex:50,maxHeight:220,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,0.4)"}}>
        {filtered.slice(0,8).map(r=><div key={r} onClick={()=>{onChange(r);setQ("");}} style={{padding:"9px 14px",cursor:"pointer",color:C.text,fontSize:13,borderBottom:`1px solid ${C.border}`}}
          onMouseEnter={e=>e.currentTarget.style.background=C.glow} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
          {r} <span style={{color:C.muted,fontSize:11}}>· {getRegionsForCity(city).find(x=>x.region===r)?.line}</span>
        </div>)}

        {/* Πάντα εμφανίζεται η επιλογή custom */}
        <div onClick={()=>handleCustomRegion(q)} style={{padding:"10px 14px",cursor:"pointer",borderTop:filtered.length>0?`1px solid ${C.border}`:"none",display:"flex",alignItems:"center",gap:10,background:"rgba(0,212,170,0.04)"}}
          onMouseEnter={e=>e.currentTarget.style.background=C.glow} onMouseLeave={e=>e.currentTarget.style.background="rgba(0,212,170,0.04)"}>
          <div style={{width:26,height:26,borderRadius:8,background:`${C.accent}22`,border:`1px solid ${C.accent}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,flexShrink:0}}>➕</div>
          <div>
            <div style={{color:C.accent,fontSize:12,fontWeight:700}}>
              {noResults ? `Αίτημα για "${q}"` : "Δεν βλέπεις την περιοχή σου;"}
            </div>
            <div style={{color:C.muted,fontSize:10,marginTop:1}}>Συμπλήρωσε νέα περιοχή — θα ελεγχθεί από την ToParking</div>
          </div>
        </div>

        {noResults&&<div style={{padding:"8px 14px",color:C.muted,fontSize:11,borderTop:`1px solid ${C.border}`,textAlign:"center"}}>
          Δεν βρέθηκε στη λίστα · Χρησιμοποίησε την παραπάνω επιλογή
        </div>}
      </div>}

      {/* Badge για "υπό έλεγχο" περιοχή */}
      {value && value.includes("υπό έλεγχο") && (
        <div style={{marginTop:8,background:"rgba(245,158,11,0.1)",border:`1px solid ${C.warn}44`,borderRadius:8,padding:"7px 12px",display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:14}}>⏳</span>
          <div style={{color:C.warn,fontSize:11,lineHeight:1.4}}>
            <b>Υπό έλεγχο από ToParking.</b> Θα ενημερωθείς μόλις ενταχθεί στο σύστημα.
          </div>
        </div>
      )}
    </div>
  </>;
}
function Card({children,style={}}){return <div style={{background:C.card,borderRadius:16,border:`1px solid ${C.border}`,padding:20,...style}}>{children}</div>;}
function Badge({children,color=C.accent}){return <span style={{background:color+"22",color,border:`1px solid ${color}44`,padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{children}</span>;}
function TopBar({title,onBack,rightEl,darkMode}){
  const T=useT(darkMode);
  return <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px 20px 10px",borderBottom:`1px solid ${T.border}`,background:T.surface,position:"sticky",top:0,zIndex:10}}>
    <div style={{display:"flex",alignItems:"center",gap:12}}>
      {onBack&&<button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.accent,fontSize:20}}>←</button>}
      {title==="logo"?<Logo size={22}/>:<span style={{fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:17,color:T.text}}>{title}</span>}
    </div>
    {rightEl}
  </div>;
}

// ─── AUTH: Supabase ────────────────────────────────────────────────────────────

// ─── SECURITY: AUTH SCREEN ────────────────────────────────────────────────────
function AuthScreen({onAuth}){
  const [mode,setMode]=useState("login");
  const [form,setForm]=useState({email:"",phone:"",password:"",username:""});
  const [attempts,setAttempts]=useState(0);
  const [locked,setLocked]=useState(false);
  const [lockTimer,setLockTimer]=useState(0);
  const [showReset,setShowReset]=useState(false);
  const [resetStep,setResetStep]=useState(1);
  const [resetMethod,setResetMethod]=useState(null);
  const [resetCode,setResetCode]=useState("");
  const [enteredCode,setEnteredCode]=useState("");
  const [securityAlert,setSecurityAlert]=useState(false);
  const [newPwd,setNewPwd]=useState("");
  const [regError,setRegError]=useState(null);   // duplicate-check error
  // Clear error when switching tabs
  const clearErrors = () => { setRegError(null); setLoginError && setLoginError(null); };
  const [phoneVerifStep,setPhoneVerifStep]=useState(false); // SMS OTP βήμα
  const [smsCode,setSmsCode]=useState("");
  const [smsEntered,setSmsEntered]=useState("");
  const timerRef=useRef(null);

  useEffect(()=>{
    if(locked&&lockTimer>0){
      timerRef.current=setInterval(()=>{
        setLockTimer(t=>{
          if(t<=1){clearInterval(timerRef.current);setLocked(false);setAttempts(0);return 0;}
          return t-1;
        });
      },1000);
      return ()=>clearInterval(timerRef.current);
    }
  },[locked,lockTimer]);

  const handleLogin=async()=>{
    if(locked) return;
    // Rate limiting — μικρή καθυστέρηση σε κάθε αποτυχία για brute force protection
    if(attempts > 0) await new Promise(r => setTimeout(r, attempts * 1000));
    const {data, error} = await AuthService.login({email:sanitize(form.email).toLowerCase(), password:form.password});
    if(error){
      const newAttempts=attempts+1;
      setAttempts(newAttempts);
      if(newAttempts>=5){ setLocked(true); setLockTimer(600); setSecurityAlert(true); }
      setRegError({field:"general", msg: "Λάθος email ή κωδικός."});
    } else {
      setAttempts(0);
      onAuth({username: data.profile?.username || form.email.split("@")[0] || "User", userId: data.profile?.id, email: form.email});
    }
  };

  // ── Έλεγχος για duplicate email / phone ──────────────────────────────────────
  const checkDuplicates = () => null; // Γίνεται server-side από το Supabase

  const handleRegisterStep1=async()=>{
    setRegError(null);
    if(!form.username||!form.email||!form.phone||!form.password){
      setRegError({field:"general", message:"Συμπλήρωσε όλα τα πεδία"});
      return;
    }
    const {data, error} = await AuthService.register({
      username: sanitize(form.username),
      email: sanitize(form.email).toLowerCase(),
      phone: sanitizePhone(form.phone),
      password: form.password,
    });
    if(error){
      setRegError(error);
    } else {
      // Εγγραφή επιτυχής — το Supabase στέλνει email επιβεβαίωσης
      setPhoneVerifStep(true); // χρησιμοποιούμε το state για να δείξουμε το success screen
    }
  };

  const handleRegisterFinalize=async()=>{}; // δεν χρησιμοποιείται πλέον

  const sendResetCode=async()=>{
    if(!form.email) return;
    try {
      const { supabase } = await import("./supabase_client");
      await supabase.auth.resetPasswordForEmail(form.email.toLowerCase(), {
        redirectTo: `${"https://toparking.app"}`,
      });
    } catch(e) { console.error(e); }
    setResetStep(2);
  };

  const verifyCode=()=>{ setResetStep(3); }; // δεν χρησιμοποιείται πλέον

  if(showReset) return (
    <div style={{minHeight:"100%",background:C.bg,display:"flex",flexDirection:"column"}}>
      <div style={{padding:"20px 20px 10px",borderBottom:`1px solid ${C.border}`,background:C.surface,display:"flex",alignItems:"center",gap:12}}>
        <button onClick={()=>{setShowReset(false);setResetStep(1);}} style={{background:"none",border:"none",cursor:"pointer",color:C.accent,fontSize:20}}>←</button>
        <span style={{fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:17,color:C.text}}>Ανάκτηση Λογαριασμού</span>
      </div>
      <div style={{padding:24,flex:1}}>
        {resetStep===1&&<>
          <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:8}}>Ανάκτηση Κωδικού</div>
          <div style={{color:C.muted,fontSize:13,marginBottom:20}}>Θα σου στείλουμε σύνδεσμο επαναφοράς κωδικού στο email σου.</div>
          <Input label="Email" value={form.email} onChange={v=>setForm({...form,email:v})} placeholder="you@email.com" type="email"/>
          <Btn style={{width:"100%"}} onClick={sendResetCode} disabled={!form.email}>Αποστολή Συνδέσμου →</Btn>
        </>}
        {resetStep===2&&<>
          <div style={{textAlign:"center",padding:"20px 0"}}>
            <div style={{fontSize:52,marginBottom:16}}>📧</div>
            <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:10}}>Email Απεστάλη!</div>
            <div style={{background:"rgba(0,212,170,0.08)",border:`1px solid ${C.accent}33`,borderRadius:12,padding:16,marginBottom:16,textAlign:"left"}}>
              <div style={{color:C.accent,fontWeight:700,fontSize:13,marginBottom:6}}>📬 Στείλαμε σύνδεσμο στο:</div>
              <div style={{color:C.text,fontWeight:800,fontSize:14,marginBottom:8}}>{form.email}</div>
              <div style={{color:C.muted,fontSize:12,lineHeight:1.6}}>
                Κλικ στον σύνδεσμο για να ορίσεις νέο κωδικό. Ο σύνδεσμος λήγει σε 1 ώρα.
              </div>
            </div>
            <div style={{background:"rgba(245,158,11,0.08)",border:`1px solid ${C.warn}33`,borderRadius:10,padding:12,marginBottom:16,textAlign:"left"}}>
              <div style={{color:C.warn,fontSize:11,lineHeight:1.6}}>
                ⚠️ Δεν το βρίσκεις; Έλεγξε τον φάκελο <b>Spam/Junk</b>.
              </div>
            </div>
            <button onClick={()=>{setShowReset(false);setResetStep(1);}}
              style={{width:"100%",padding:"12px",borderRadius:12,border:"none",background:`linear-gradient(135deg,${C.accent},#1A2EAA)`,color:"#fff",fontFamily:"'Syne',sans-serif",fontWeight:700,fontSize:14,cursor:"pointer"}}>
              → Πίσω στη Σύνδεση
            </button>
            <button onClick={sendResetCode} style={{width:"100%",marginTop:10,padding:"10px",background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:13}}>
              Επαναποστολή
            </button>
          </div>
        </>}
      </div>
    </div>
  );

  if(securityAlert) return (
    <div style={{minHeight:"100%",background:C.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24}}>
      <div style={{fontSize:64,marginBottom:16}}>🚨</div>
      <div style={{color:C.danger,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:20,textAlign:"center",marginBottom:12}}>Ύποπτη Δραστηριότητα!</div>
      <Card style={{width:"100%",marginBottom:16,border:`2px solid ${C.danger}44`}}>
        <div style={{color:C.text,fontWeight:700,marginBottom:8}}>Ανιχνεύθηκαν 5 αποτυχημένες προσπάθειες σύνδεσης</div>
        <div style={{color:C.muted,fontSize:13,marginBottom:12}}>Ο λογαριασμός σου κλειδώθηκε για <span style={{color:C.warn,fontWeight:700}}>10 λεπτά</span> για λόγους ασφαλείας.</div>
        <div style={{color:C.muted,fontSize:12,lineHeight:1.6}}>📍 IP: 192.168.x.x · 🕐 {new Date().toLocaleTimeString('el')}</div>
      </Card>
      <div style={{color:C.text,fontWeight:700,marginBottom:16,fontSize:15}}>Ήταν εσύ αυτός που προσπαθούσε;</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,width:"100%",marginBottom:20}}>
        <Btn variant="ghost" onClick={()=>{setSecurityAlert(false);setShowReset(true);}}>Ναι, ήμουν εγώ 😅</Btn>
        <Btn variant="danger" onClick={()=>setSecurityAlert(false)}>Όχι, ασφάλιση! 🔒</Btn>
      </div>
      <div style={{color:C.muted,fontSize:12,textAlign:"center"}}>Αν δεν ήταν εσύ, θα λάβεις email με οδηγίες ασφαλείας για την προστασία του λογαριασμού σου.</div>
    </div>
  );

  return (
    <div style={{minHeight:"100%",background:C.bg,display:"flex",flexDirection:"column"}}>
      <div style={{background:`radial-gradient(ellipse at 50% 0%,rgba(0,212,170,0.18) 0%,transparent 70%)`,padding:"44px 24px 28px",textAlign:"center"}}>
        <Logo size={36}/>
        <div style={{color:C.muted,marginTop:8,fontSize:13}}>Έξυπνη στάθμευση στην πόλη</div>
      </div>
      <div style={{padding:"0 24px 40px",flex:1}}>
        <div style={{display:"flex",background:C.card,borderRadius:12,padding:4,marginBottom:24}}>
          {["login","signup"].map(m=>(
            <button key={m} onClick={()=>{setMode(m);setRegError(null);}} style={{flex:1,padding:"10px 0",borderRadius:9,border:"none",cursor:"pointer",background:mode===m?C.accent:"transparent",color:mode===m?"#fff":C.muted,fontFamily:"'Syne',sans-serif",fontWeight:700,fontSize:14}}>
              {m==="login"?"Σύνδεση":"Εγγραφή"}
            </button>
          ))}
        </div>

        {locked&&<div style={{background:"rgba(239,68,68,0.1)",border:`1px solid ${C.danger}44`,borderRadius:12,padding:14,marginBottom:16}}>
          <div style={{color:C.danger,fontWeight:800,marginBottom:4}}>🔒 Λογαριασμός κλειδωμένος</div>
          <div style={{color:C.muted,fontSize:13}}>Δοκίμασε ξανά σε <span style={{color:C.warn,fontWeight:700}}>{Math.floor(lockTimer/60)}:{String(lockTimer%60).padStart(2,"0")}</span></div>
        </div>}

        {!locked&&attempts>0&&attempts<5&&<div style={{background:"rgba(245,158,11,0.1)",border:`1px solid ${C.warn}44`,borderRadius:10,padding:12,marginBottom:14}}>
          <div style={{color:C.warn,fontSize:13,fontWeight:600}}>⚠️ Λάθος στοιχεία · {5-attempts} απόπειρες απομένουν</div>

        </div>}

        {/* ── LOGIN form ── */}
        {mode==="login"&&<>
          <Input label="Email" value={form.email} onChange={v=>setForm({...form,email:v})} placeholder="you@email.com" type="email"/>
          <Input label="Κωδικός" value={form.password} onChange={v=>setForm({...form,password:v})} placeholder="••••••••" type="password"/>
          <Btn style={{width:"100%",marginTop:4}} onClick={handleLogin} disabled={locked}>{locked?"🔒 Κλειδωμένο":"Σύνδεση →"}</Btn>
          <button onClick={()=>setShowReset(true)} style={{width:"100%",marginTop:12,padding:"10px",background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:13}}>
            Ξέχασες τον κωδικό ή username; <span style={{color:C.accent}}>Ανάκτηση →</span>
          </button>
        </>}

        {/* ── SIGNUP form ── */}
        {mode==="signup"&&!phoneVerifStep&&<>
          <Input label="Username" value={form.username} onChange={v=>{setForm({...form,username:v});setRegError(null);}} placeholder="π.χ. alex_athens"/>
          <Input label="Email" value={form.email} onChange={v=>{setForm({...form,email:v});setRegError(null);}} placeholder="you@email.com" type="email"/>

          {/* Τηλέφωνο */}
          <div style={{marginBottom:14}}>
            <div style={{fontSize:12,color:C.muted,marginBottom:5,fontWeight:600}}>Τηλέφωνο *</div>
            <div style={{position:"relative"}}>
              <div style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:C.muted,fontSize:13,pointerEvents:"none"}}>+30</div>
              <input
                style={{width:"100%",padding:"11px 14px 11px 46px",borderRadius:10,border:`1px solid ${regError?.field==="phone"||regError?.field==="both"?C.danger:C.border}`,background:C.surface,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}
                value={form.phone} onChange={e=>{setForm({...form,phone:e.target.value});setRegError(null);}}
                placeholder="69X XXX XXXX" type="tel"/>
            </div>
          </div>

          <Input label="Κωδικός" value={form.password} onChange={v=>setForm({...form,password:v})} placeholder="Τουλάχιστον 8 χαρακτήρες" type="password"/>

          {/* Duplicate error banner */}
          {regError&&<div style={{background:"rgba(239,68,68,0.1)",border:`1px solid ${C.danger}44`,borderRadius:10,padding:12,marginBottom:14,display:"flex",gap:10,alignItems:"flex-start"}}>
            <span style={{fontSize:18}}>🚫</span>
            <div>
              <div style={{color:C.danger,fontWeight:700,fontSize:13,marginBottom:3}}>
                {regError.field==="email"?"Email ήδη χρησιμοποιείται":regError.field==="phone"?"Τηλέφωνο ήδη χρησιμοποιείται":"Στοιχεία ήδη καταχωρημένα"}
              </div>
              <div style={{color:C.muted,fontSize:12,lineHeight:1.5}}>{regError.msg}</div>
              {(regError.field==="email"||regError.field==="both")&&
                <button onClick={()=>{setMode("login");setRegError(null);}} style={{background:"none",border:"none",color:C.accent,cursor:"pointer",fontSize:12,padding:"4px 0",fontWeight:700}}>
                  → Σύνδεση με αυτόν τον λογαριασμό
                </button>}
            </div>
          </div>}

          {/* Ενημέρωση ότι τα στοιχεία είναι μοναδικά */}
          <div style={{background:"rgba(0,212,170,0.06)",border:`1px solid ${C.accent}22`,borderRadius:10,padding:10,marginBottom:14}}>
            <div style={{color:C.muted,fontSize:10,lineHeight:1.6}}>
              🔒 Κάθε email και τηλέφωνο αντιστοιχεί σε <b style={{color:C.text}}>έναν μόνο λογαριασμό</b>. Δεν επιτρέπεται επανεγγραφή με ήδη χρησιμοποιημένα στοιχεία.
            </div>
          </div>

          <Btn style={{width:"100%",marginTop:4}}
            disabled={!form.username||!form.email||!form.phone||!form.password}
            onClick={handleRegisterStep1}>
            Εγγραφή →
          </Btn>
        </>}

        {/* ── Email Επιβεβαίωση ── */}
        {mode==="signup"&&phoneVerifStep&&<>
          <div style={{textAlign:"center",padding:"20px 0"}}>
            <div style={{fontSize:52,marginBottom:16}}>📧</div>
            <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:10}}>Έλεγξε το Email σου!</div>
            <div style={{background:"rgba(0,212,170,0.08)",border:`1px solid ${C.accent}33`,borderRadius:12,padding:16,marginBottom:16,textAlign:"left"}}>
              <div style={{color:C.accent,fontWeight:700,fontSize:13,marginBottom:6}}>📬 Στείλαμε email επιβεβαίωσης στο:</div>
              <div style={{color:C.text,fontWeight:800,fontSize:14,marginBottom:8}}>{form.email}</div>
              <div style={{color:C.muted,fontSize:12,lineHeight:1.6}}>
                Κλικ στον σύνδεσμο που σου στείλαμε για να ενεργοποιήσεις τον λογαριασμό σου. Μετά μπορείς να συνδεθείς κανονικά.
              </div>
            </div>
            <div style={{background:"rgba(245,158,11,0.08)",border:`1px solid ${C.warn}33`,borderRadius:10,padding:12,marginBottom:16,textAlign:"left"}}>
              <div style={{color:C.warn,fontSize:11,lineHeight:1.6}}>
                ⚠️ Δεν το βρίσκεις; Έλεγξε τον φάκελο <b>Spam/Junk</b>.
              </div>
            </div>
            <button onClick={()=>{setPhoneVerifStep(false);setMode("login");}}
              style={{width:"100%",padding:"12px",borderRadius:12,border:"none",background:`linear-gradient(135deg,${C.accent},#1A2EAA)`,color:"#fff",fontFamily:"'Syne',sans-serif",fontWeight:700,fontSize:14,cursor:"pointer"}}>
              → Πήγαινε στη Σύνδεση
            </button>
            <button onClick={()=>setPhoneVerifStep(false)} style={{width:"100%",marginTop:10,padding:"10px",background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:12}}>
              ← Πίσω
            </button>
          </div>
        </>}

        <div style={{background:C.glow,borderRadius:10,padding:10,marginTop:16,textAlign:"center"}}>
          <div style={{color:C.muted,fontSize:10,lineHeight:1.6}}>{DISCLAIMER}</div>
        </div>
      </div>
    </div>
  );
}

// ─── GOOGLE MAPS COMPONENT ────────────────────────────────────────────────────
function DemoMapView({phase, onDistanceUpdate}){
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef({});
  const circleRef = useRef(null);
  const routeRendererRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [mapError, setMapError] = useState(false);

  // Αθήνα - Κολωνάκι coordinates
  const SEEKER_POS = { lat: 37.9802, lng: 23.7351 }; // Βρίσκομαι εδώ
  // Ο giver κινείται σιμουλαρισμένα
  const GIVER_POSITIONS = [
    { lat: 37.9845, lng: 23.7409 }, // phase 0-1: μακριά (350μ)
    { lat: 37.9825, lng: 23.7390 }, // phase 2: 200μ
    { lat: 37.9812, lng: 23.7366 }, // phase 3: ~100μ - αποκάλυψη!
    { lat: 37.9808, lng: 23.7358 }, // phase 4: deal ολοκλήρωση
  ];

  const giverPos = GIVER_POSITIONS[Math.min(phase, GIVER_POSITIONS.length-1)];
  const revealed = phase >= 3;

  // Φόρτωση Google Maps API
  useEffect(()=>{
    if(window.google && window.google.maps){ setMapLoaded(true); return; }
    const existingScript = document.getElementById('gmaps-script');
    if(existingScript){ existingScript.addEventListener('load', ()=>setMapLoaded(true)); return; }
    const script = document.createElement('script');
    script.id = 'gmaps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY&libraries=geometry`;
    script.async = true;
    script.onload = () => setMapLoaded(true);
    script.onerror = () => setMapError(true);
    document.head.appendChild(script);
  },[]);

  // Αρχικοποίηση χάρτη
  useEffect(()=>{
    if(!mapLoaded || !mapRef.current || mapInstanceRef.current) return;
    try {
      const map = new window.google.maps.Map(mapRef.current, {
        center: SEEKER_POS,
        zoom: 16,
        disableDefaultUI: false,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: [
          {elementType:"geometry",stylers:[{color:"#1d2c4d"}]},
          {elementType:"labels.text.fill",stylers:[{color:"#8ec3b9"}]},
          {elementType:"labels.text.stroke",stylers:[{color:"#1a3646"}]},
          {featureType:"road",elementType:"geometry",stylers:[{color:"#304a7d"}]},
          {featureType:"road",elementType:"geometry.stroke",stylers:[{color:"#255763"}]},
          {featureType:"road",elementType:"labels.text.fill",stylers:[{color:"#98a5be"}]},
          {featureType:"water",elementType:"geometry",stylers:[{color:"#0e1626"}]},
          {featureType:"poi",elementType:"geometry",stylers:[{color:"#283d6a"}]},
          {featureType:"transit",elementType:"geometry",stylers:[{color:"#2f3948"}]},
        ],
      });
      mapInstanceRef.current = map;

      // Seeker marker (εγώ - μπλε)
      markersRef.current.seeker = new window.google.maps.Marker({
        position: SEEKER_POS,
        map,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: "#0099FF",
          fillOpacity: 1,
          strokeColor: "#fff",
          strokeWeight: 2,
        },
        title: "Εγώ",
        zIndex: 10,
      });

      // Label "Εγώ"
      markersRef.current.seekerLabel = new window.google.maps.InfoWindow({
        content: '<div style="background:#0099FF;color:#fff;padding:3px 8px;border-radius:6px;font-size:11px;font-weight:700;font-family:sans-serif">Εγώ 📍</div>',
        disableAutoPan: true,
      });
      markersRef.current.seekerLabel.open(map, markersRef.current.seeker);

    } catch(e){ setMapError(true); }
  }, [mapLoaded]);

  // Ενημέρωση χάρτη ανά phase
  useEffect(()=>{
    if(!mapInstanceRef.current || !window.google) return;
    const map = mapInstanceRef.current;

    // Υπολογισμός απόστασης
    let distM = 999;
    if(window.google.maps.geometry){
      distM = Math.round(window.google.maps.geometry.spherical.computeDistanceBetween(
        new window.google.maps.LatLng(SEEKER_POS.lat, SEEKER_POS.lng),
        new window.google.maps.LatLng(giverPos.lat, giverPos.lng)
      ));
    }
    if(onDistanceUpdate) onDistanceUpdate(distM);

    // Καθαρισμός παλαιών markers giver
    if(markersRef.current.giver){ markersRef.current.giver.setMap(null); }
    if(markersRef.current.giverLabel){ markersRef.current.giverLabel.close(); }
    if(circleRef.current){ circleRef.current.setMap(null); }

    if(phase === 0){
      // Κανένας marker - δεν έχει ξεκινήσει
      return;
    }

    if(phase >= 1){
      // Κύκλος ακτίνας γύρω από κρυφή τοποθεσία
      circleRef.current = new window.google.maps.Circle({
        center: giverPos,
        radius: revealed ? 15 : 120,
        map,
        strokeColor: revealed ? "#A855F7" : "#F59E0B",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: revealed ? "#A855F7" : "#F59E0B",
        fillOpacity: revealed ? 0.15 : 0.08,
      });
    }

    if(!revealed && phase >= 1){
      // ❓ pin - κρυφή τοποθεσία
      markersRef.current.giver = new window.google.maps.Marker({
        position: giverPos,
        map,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: "#F59E0B",
          fillOpacity: 0.4,
          strokeColor: "#F59E0B",
          strokeWeight: 2,
        },
        zIndex: 5,
      });
      markersRef.current.giverLabel = new window.google.maps.InfoWindow({
        content: '<div style="background:rgba(0,0,0,0.75);color:#F59E0B;padding:3px 8px;border-radius:6px;font-size:11px;font-weight:700;font-family:sans-serif">🔒 Κρυφό</div>',
        disableAutoPan: true,
      });
      markersRef.current.giverLabel.open(map, markersRef.current.giver);

      // Route: μπλε διαδρομή
      if(routeRendererRef.current){ routeRendererRef.current.setMap(null); }
      const directionsService = new window.google.maps.DirectionsService();
      const directionsRenderer = new window.google.maps.DirectionsRenderer({
        suppressMarkers: true,
        polylineOptions:{ strokeColor:"#00D4AA", strokeWeight:4, strokeOpacity:0.7 },
      });
      directionsRenderer.setMap(map);
      routeRendererRef.current = directionsRenderer;
      directionsService.route({
        origin: SEEKER_POS,
        destination: giverPos,
        travelMode: window.google.maps.TravelMode.DRIVING,
      }, (result, status)=>{ if(status==="OK") directionsRenderer.setDirections(result); });

    } else if(revealed){
      // 📍 pin ορατός - αποκάλυψη!
      if(routeRendererRef.current){ routeRendererRef.current.setMap(null); }
      markersRef.current.giver = new window.google.maps.Marker({
        position: giverPos,
        map,
        icon: {
          path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
          fillColor: "#A855F7",
          fillOpacity: 1,
          strokeColor: "#fff",
          strokeWeight: 1,
          scale: 1.6,
          anchor: new window.google.maps.Point(12, 22),
        },
        animation: window.google.maps.Animation.BOUNCE,
        zIndex: 10,
      });
      markersRef.current.giverLabel = new window.google.maps.InfoWindow({
        content: '<div style="background:#A855F7;color:#fff;padding:3px 8px;border-radius:6px;font-size:11px;font-weight:700;font-family:sans-serif">🚗 Toyota Corolla · Ασημί</div>',
        disableAutoPan: true,
      });
      markersRef.current.giverLabel.open(map, markersRef.current.giver);

      // Zoom in για αποκάλυψη
      map.panTo(giverPos);
      map.setZoom(18);
    }

    // Pan/zoom ανά phase
    if(phase === 1){ map.setZoom(16); map.panTo({lat:(SEEKER_POS.lat+giverPos.lat)/2, lng:(SEEKER_POS.lng+giverPos.lng)/2}); }
    if(phase === 2){ map.setZoom(17); }

  }, [phase, mapLoaded]);

  if(mapError){
    return (
      <div style={{background:"linear-gradient(135deg,#0D1B2A,#0F2235)",borderRadius:14,height:240,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",border:`1px solid ${C.border}`,gap:8}}>
        <div style={{fontSize:32}}>🗺️</div>
        <div style={{color:C.muted,fontSize:12,textAlign:"center",padding:"0 20px"}}>Χάρτης μη διαθέσιμος<br/><span style={{fontSize:10}}>Απαιτείται σύνδεση & Google Maps API Key</span></div>
      </div>
    );
  }

  return (
    <div style={{position:"relative",borderRadius:14,overflow:"hidden",border:`1px solid ${C.border}`}}>
      <div ref={mapRef} style={{height:240,width:"100%"}}/>
      {!mapLoaded && (
        <div style={{position:"absolute",inset:0,background:"#0D1B2A",display:"flex",alignItems:"center",justifyContent:"center",gap:10}}>
          <div style={{width:20,height:20,border:`2px solid ${C.accent}`,borderTopColor:"transparent",borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/>
          <span style={{color:C.muted,fontSize:13}}>Φόρτωση χάρτη...</span>
        </div>
      )}
      {/* Privacy overlay — κρύβει pin όταν > 100μ */}
      {phase>=1 && phase<3 && (
        <div style={{position:"absolute",top:10,left:10,background:"rgba(0,0,0,0.75)",backdropFilter:"blur(4px)",border:`1px solid ${C.warn}44`,borderRadius:8,padding:"5px 10px",display:"flex",alignItems:"center",gap:6}}>
          <span style={{fontSize:12}}>🔒</span>
          <span style={{color:C.warn,fontSize:11,fontWeight:700}}>Pin κρυφό — απόσταση >500μ.</span>
        </div>
      )}
      {phase>=3 && phase<4 && (
        <div style={{position:"absolute",top:10,left:10,background:"rgba(168,85,247,0.85)",backdropFilter:"blur(4px)",borderRadius:8,padding:"5px 10px",display:"flex",alignItems:"center",gap:6}}>
          <span style={{fontSize:12}}>👁️</span>
          <span style={{color:"#fff",fontSize:11,fontWeight:700}}>Αποκαλύφθηκε στα 500μ.!</span>
        </div>
      )}
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

// ─── NAVIGATION DEMO SCREEN ───────────────────────────────────────────────────
function NavDemoScreen({onBack}){
  const [phase,setPhase]=useState(0);
  const [progress,setProgress]=useState(0);
  const [liveDistance, setLiveDistance]=useState(null);
  const intervalRef=useRef(null);

  const GIVER={name:"Άγνωστος Οδηγός",vehicle:"Toyota Corolla",color:"Ασημί",year:"2019",region:"Κολωνάκι",address:"Σκουφά 12"};

  const PHASES=[
    {title:"🔍 Βρέθηκε Match!",desc:"Υπάρχει διαθέσιμη θέση στην περιοχή Κολωνάκι · ~8 λεπτά πεζή",color:C.accent,icon:"🎯"},
    {title:"🧭 Πλοήγηση προς περιοχή",desc:"Κατεύθυνση: Πανεπιστημίου → Κηφισίας → Σκουφά",color:"#1A2EAA",icon:"🗺️"},
    {title:"📍 Στην περιοχή — ~200μ. μακριά",desc:"Συνέχισε ευθεία · Θέση κοντά · Pin ακόμα κρυφό 🔒",color:C.warn,icon:"📍"},
    {title:"👁️ ~500μ. — Αποκάλυψη Οχήματος!",desc:"Toyota Corolla · Ασημί · 2019\nΘέση: αριστερά στον δρόμο",color:"#A855F7",icon:"🚗"},
    {title:"✅ Ανταλλαγή Θέσης!",desc:"Και οι δύο επιβεβαίωσαν · Πληρωμή €8.31 · Deal ολοκληρώθηκε!",color:C.accent,icon:"🎉"},
  ];

  useEffect(()=>{
    if(phase>=1&&phase<=3){
      setProgress(0);
      intervalRef.current=setInterval(()=>setProgress(p=>{
        if(p>=100){clearInterval(intervalRef.current);return 100;}
        return p+2;
      }),80);
      return ()=>clearInterval(intervalRef.current);
    }
  },[phase]);

  const TurnByTurn=[
    {step:"Κατεύθυνση Β. στην Πανεπιστημίου",dist:"400μ.",icon:"⬆️"},
    {step:"Στρίψε αριστερά στην Κηφισίας",dist:"200μ.",icon:"↰"},
    {step:"Στρίψε δεξιά στην Σκουφά",dist:"80μ.",icon:"↱"},
    {step:"Φτάνεις στην περιοχή Κολωνάκι",dist:"",icon:"📍"},
  ];

  return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Demo: Πλοήγηση" onBack={onBack}/>
      <div style={{padding:20}}>

        {/* Phase indicator */}
        <div style={{display:"flex",gap:4,marginBottom:16}}>
          {PHASES.map((_,i)=><div key={i} style={{flex:1,height:4,borderRadius:4,background:phase>i?C.accent:phase===i?"#0099FF":C.border,transition:"all 0.4s"}}/>)}
        </div>

        {/* Status card */}
        <div style={{background:`linear-gradient(135deg,${PHASES[Math.min(phase,4)].color}22,${PHASES[Math.min(phase,4)].color}08)`,border:`2px solid ${PHASES[Math.min(phase,4)].color}44`,borderRadius:16,padding:16,marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
            <span style={{fontSize:24}}>{PHASES[Math.min(phase,4)].icon}</span>
            <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:15}}>{PHASES[Math.min(phase,4)].title}</div>
          </div>
          <div style={{color:C.muted,fontSize:13,lineHeight:1.5,whiteSpace:"pre-line"}}>{PHASES[Math.min(phase,4)].desc}</div>
          {liveDistance!==null && phase>=1 && phase<=3 && (
            <div style={{marginTop:8,display:"flex",alignItems:"center",gap:6}}>
              <span style={{color:liveDistance<=100?"#A855F7":C.warn,fontWeight:800,fontSize:13}}>
                📏 Απόσταση: ~{liveDistance}μ.
              </span>
              {liveDistance<=100 && <Badge color="#A855F7">Αποκάλυψη ενεργή!</Badge>}
            </div>
          )}
        </div>

        {/* Google MAP */}
        <DemoMapView phase={phase} onDistanceUpdate={setLiveDistance}/>

        {/* 100m Privacy info */}
        <div style={{background:"rgba(168,85,247,0.08)",border:`1px solid rgba(168,85,247,0.25)`,borderRadius:10,padding:10,marginTop:12,display:"flex",gap:8,alignItems:"flex-start"}}>
          <span style={{fontSize:14}}>🛡️</span>
          <div style={{color:C.muted,fontSize:11,lineHeight:1.5}}>
            Η ακριβής τοποθεσία και τα στοιχεία οχήματος παραμένουν <b style={{color:C.text}}>κρυφά</b> μέχρι να πλησιάσεις εντός <b style={{color:"#A855F7"}}>500 μέτρων</b>. Τότε ο χάρτης Google αποκαλύπτει αυτόματα το pin.
          </div>
        </div>

        {/* Turn-by-turn (phases 1-3) */}
        {phase>=1&&phase<=3&&<Card style={{marginTop:14}}>
          <div style={{color:C.accent,fontWeight:800,marginBottom:10,fontSize:13}}>🧭 Οδηγίες Βήμα-Βήμα (Google Navigation)</div>
          {TurnByTurn.map((t,i)=>(
            <div key={i} style={{display:"flex",gap:10,marginBottom:8,alignItems:"center",opacity:progress/100>i*0.25?1:0.3,transition:"opacity 0.5s"}}>
              <div style={{width:28,height:28,borderRadius:14,background:progress/100>i*0.25?C.glow:C.border,border:`1px solid ${progress/100>i*0.25?C.accent:C.border}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,flexShrink:0}}>{t.icon}</div>
              <div style={{flex:1}}><div style={{color:C.text,fontSize:13}}>{t.step}</div>{t.dist&&<div style={{color:C.muted,fontSize:11}}>{t.dist}</div>}</div>
            </div>
          ))}
          <div style={{marginTop:10}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
              <span style={{color:C.muted,fontSize:11}}>Πρόοδος πλοήγησης</span>
              <span style={{color:C.accent,fontSize:11,fontWeight:700}}>{progress}%</span>
            </div>
            <div style={{background:C.border,borderRadius:4,height:6}}>
              <div style={{background:C.accent,borderRadius:4,height:6,width:`${progress}%`,transition:"width 0.1s"}}/>
            </div>
          </div>
        </Card>}

        {/* Vehicle reveal (phase 3+) */}
        {phase>=3&&<Card style={{marginTop:14,border:`2px solid #A855F744`}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <div style={{fontSize:40}}>🚗</div>
            <div style={{flex:1}}>
              <div style={{color:C.text,fontWeight:800,fontSize:15}}>{GIVER.vehicle}</div>
              <div style={{color:C.muted,fontSize:12}}>{GIVER.color} · {GIVER.year}</div>
              <div style={{display:"flex",gap:6,marginTop:6,flexWrap:"wrap"}}>
                <Badge color="#A855F7">Αποκαλύφθηκε στα 500μ.</Badge>
                <Badge color={C.accent}>Live GPS</Badge>
              </div>
            </div>
          </div>
          <div style={{background:"rgba(239,68,68,0.08)",border:`1px solid ${C.danger}22`,borderRadius:10,padding:10,marginTop:12}}>
            <div style={{color:C.muted,fontSize:11,lineHeight:1.5}}>{PRIVACY_NOTE}</div>
          </div>
        </Card>}

        {/* Swap confirmation (phase 4) */}
        {phase===4&&<Card style={{marginTop:14,border:`2px solid ${C.accent}44`}}>
          <div style={{textAlign:"center",padding:"10px 0"}}>
            <div style={{fontSize:48}}>🎉</div>
            <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginTop:8}}>Deal Ολοκληρώθηκε!</div>
  
          </div>
        </Card>}

        {/* Controls */}
        <div style={{display:"flex",gap:10,marginTop:16}}>
          {phase>0&&<Btn variant="secondary" style={{flex:1}} onClick={()=>setPhase(p=>Math.max(0,p-1))}>← Πίσω</Btn>}
          {phase<4&&<Btn style={{flex:phase>0?1:undefined,width:phase===0?"100%":undefined}} onClick={()=>setPhase(p=>Math.min(4,p+1))}>
            {phase===0?"🚀 Ξεκίνα Demo":phase===4?"✓ Τέλος":"Επόμενο βήμα →"}
          </Btn>}
          {phase===4&&<Btn style={{flex:1}} onClick={()=>{setPhase(0);setProgress(0);}}>🔄 Επανάληψη</Btn>}
        </div>
        <div style={{color:C.muted,fontSize:10,textAlign:"center",marginTop:12}}>{DISCLAIMER}</div>
      </div>
    </div>
  );
}

// ─── WALLET SCREEN (Stripe + Reloadly info) ───────────────────────────────────
function WalletScreen({onBack,darkMode}){
  const [balance,setBalance]=useState(null);
  const [history,setHistory]=useState([]);
  const [tab,setTab]=useState("wallet");
  const [showStripeInfo,setShowStripeInfo]=useState(false);
  const [showReloadlyInfo,setShowReloadlyInfo]=useState(false);

  useEffect(()=>{
    import("./supabase_client").then(async({supabase})=>{
      const { data:{user:au} } = await supabase.auth.getUser();
      if(!au) return;
      const { data:profile } = await supabase.from('users').select('id,wallet_balance').eq('auth_id',au.id).single();
      if(profile) setBalance(profile.wallet_balance||0);
      const { data:deals } = await supabase
        .from('deals')
        .select('*')
        .or(`giver_id.eq.${profile.id},seeker_id.eq.${profile.id}`)
        .order('created_at',{ascending:false})
        .limit(20);
      if(deals) setHistory(deals.map(d=>({
        type: d.giver_id===profile.id ? 'earned' : 'paid',
        desc: (d.giver_id===profile.id ? 'Θέση δόθηκε' : 'Θέση ελήφθη') + ' · ' + d.region,
        amount: d.giver_id===profile.id ? `+€${(d.giver_earn||0).toFixed(2)}` : `-€${(d.price||0).toFixed(2)}`,
        date: new Date(d.created_at).toLocaleDateString('el-GR'),
        isEarned: d.giver_id===profile.id,
      })));
    });
  },[]);

  return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Πορτοφόλι" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:20}}>
        <div style={{background:"linear-gradient(135deg,#00D4AA,#0099FF)",borderRadius:20,padding:28,marginBottom:20,textAlign:"center"}}>
          <div style={{color:"rgba(255,255,255,0.7)",fontSize:13}}>Διαθέσιμο Υπόλοιπο</div>
          <div style={{color:"#fff",fontFamily:"'Syne',sans-serif",fontWeight:900,fontSize:44,marginTop:4}}>{balance===null?"...":"€"+balance.toFixed(2)}</div>
          <div style={{color:"rgba(255,255,255,0.6)",fontSize:11,marginTop:4}}>Stripe Connect · 1.5% + €0.25 ανά deal</div>
        </div>
        <div style={{display:"flex",background:C.card,borderRadius:10,padding:4,marginBottom:18}}>
          {["wallet","integration"].map(t=>(
            <button key={t} onClick={()=>setTab(t)} style={{flex:1,padding:"9px 0",borderRadius:8,border:"none",cursor:"pointer",background:tab===t?C.accent:"transparent",color:tab===t?"#fff":C.muted,fontWeight:700,fontSize:11}}>
              {t==="wallet"?"💳 Τράπεζα":"🔧 API"}
            </button>
          ))}
        </div>

        {tab==="wallet"&&<>
          <Card style={{marginBottom:12}}>
            <div style={{color:C.text,fontWeight:800,marginBottom:12}}>Ανάληψη μέσω Stripe</div>
            <Input label="Ποσό (€)" placeholder="0.00" type="number" value="" onChange={()=>{}}/>
            <div style={{color:C.muted,fontSize:11,marginBottom:12}}>Via Stripe Connect · 1-3 εργάσιμες · Min €1.00</div>
            <Btn style={{width:"100%"}}>Ανάληψη στην Τράπεζα →</Btn>
          </Card>
          <div onClick={()=>setShowStripeInfo(!showStripeInfo)} style={{background:"rgba(99,102,241,0.1)",border:"1px solid rgba(99,102,241,0.3)",borderRadius:12,padding:14,cursor:"pointer",marginBottom:12}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:20}}>💳</span>
                <div style={{color:"#818CF8",fontWeight:700,fontSize:13}}>Πώς λειτουργεί η Stripe;</div>
              </div>
              <span style={{color:C.muted}}>{showStripeInfo?"▲":"▼"}</span>
            </div>
            {showStripeInfo&&<div style={{color:C.muted,fontSize:12,marginTop:10,lineHeight:1.7}}>
              <div style={{marginBottom:6}}>• <b style={{color:C.text}}>Stripe Connect</b>: Κάθε χρήστης δημιουργεί Stripe Connected Account</div>
              <div style={{marginBottom:6}}>• Τα χρήματα από κάθε deal μεταφέρονται αυτόματα στο πορτοφόλι</div>
              <div style={{marginBottom:6}}>• Ανάληψη σε τραπεζικό λογαριασμό εντός 1-3 εργάσιμων ημερών</div>
              <div style={{marginBottom:6}}>• <b style={{color:C.warn}}>Κόστος:</b> 1.5% + €0.25 ανά συναλλαγή (χρεώνεται στον αγοραστή)</div>
              <div>• <b style={{color:C.accent}}>Endpoint:</b> POST /v1/transfers, /v1/payouts</div>
            </div>}
          </div>
          <Card>
            <div style={{color:C.text,fontWeight:800,marginBottom:10}}>📋 Ιστορικό</div>
            {history.length===0 ? <div style={{color:C.muted,fontSize:13,textAlign:"center",padding:16}}>Δεν υπάρχουν συναλλαγές ακόμα</div> : history.map((h,i)=>(
              <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${C.border}`}}>
                <div><div style={{color:C.text,fontWeight:700,fontSize:13}}>{h.desc}</div><div style={{color:C.muted,fontSize:11}}>{h.date}</div></div>
                <div style={{color:h.isEarned?C.accent:C.danger,fontWeight:800}}>{h.amount}</div>
              </div>
            ))}
          </Card>
        </>}



        {tab==="integration"&&<>
          <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:16,marginBottom:16}}>🔧 Οδηγός Ενσωμάτωσης</div>

          <Card style={{marginBottom:12,border:`1px solid rgba(99,102,241,0.3)`}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
              <span style={{fontSize:24}}>💳</span>
              <div style={{color:"#818CF8",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:15}}>Stripe Connect</div>
            </div>
            {[{n:"1",t:"Δημιουργία Stripe Account",d:"stripe.com/register → Enable Connect"},{n:"2",t:"Environment Variables",d:"STRIPE_SECRET_KEY, STRIPE_PUBLISHABLE_KEY"},{n:"3",t:"Connected Accounts",d:"POST /v1/accounts per user (type: express)"},{n:"4",t:"Payment Intents",d:"POST /v1/payment_intents για κάθε deal"},{n:"5",t:"Transfers",d:"POST /v1/transfers → χρήστης λαμβάνει 50%"},{n:"6",t:"Payouts",d:"POST /v1/payouts → ανάληψη σε τράπεζα"}].map(s=>(
              <div key={s.n} style={{display:"flex",gap:10,marginBottom:8,alignItems:"flex-start"}}>
                <div style={{width:22,height:22,borderRadius:11,background:"rgba(99,102,241,0.2)",border:"1px solid rgba(99,102,241,0.4)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:"#818CF8",flexShrink:0,fontWeight:700}}>{s.n}</div>
                <div><div style={{color:C.text,fontSize:12,fontWeight:600}}>{s.t}</div><div style={{color:C.muted,fontSize:11}}>{s.d}</div></div>
              </div>
            ))}
          </Card>

          <Card style={{marginBottom:12,border:`1px solid rgba(16,185,129,0.3)`}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
              <span style={{fontSize:24}}>⛽</span>
              <div style={{color:"#10B981",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:15}}>Reloadly API</div>
            </div>
            {[{n:"1",t:"Εγγραφή στη Reloadly",d:"reloadly.com → API credentials"},{n:"2",t:"OAuth Token",d:"POST /auth/token (client_credentials)"},{n:"3",t:"Gift Card Products",d:"GET /giftcards/products?countryCode=GR"},{n:"4",t:"Αγορά Κουπονιού",d:"POST /giftcards/transactions (productId, amount)"},{n:"5",t:"Delivery",d:"Email/SMS αυτόματα από Reloadly"}].map(s=>(
              <div key={s.n} style={{display:"flex",gap:10,marginBottom:8,alignItems:"flex-start"}}>
                <div style={{width:22,height:22,borderRadius:11,background:"rgba(16,185,129,0.2)",border:"1px solid rgba(16,185,129,0.4)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:"#10B981",flexShrink:0,fontWeight:700}}>{s.n}</div>
                <div><div style={{color:C.text,fontSize:12,fontWeight:600}}>{s.t}</div><div style={{color:C.muted,fontSize:11}}>{s.d}</div></div>
              </div>
            ))}
          </Card>

          <div style={{background:"rgba(245,158,11,0.1)",border:`1px solid ${C.warn}44`,borderRadius:12,padding:14}}>
            <div style={{color:C.warn,fontWeight:700,marginBottom:8}}>⚠️ Σημαντικό για ασφάλεια</div>
            <div style={{color:C.muted,fontSize:12,lineHeight:1.6}}>
              • Ποτέ μην αποθηκεύεις API keys στο frontend<br/>
              • Χρησιμοποίησε backend (Node.js/Python) για API calls<br/>
              • Stripe Webhooks για επιβεβαίωση πληρωμών<br/>
              • Κρυπτογράφησε τα στοιχεία πληρωμής (PCI DSS)
            </div>
          </div>
        </>}
      </div>
    </div>
  );
}

// ─── ACTIVE DEAL BANNER ───────────────────────────────────────────────────────
function ActiveDealBanner({ activeDeal, onResume, onCancel }) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [penaltyInfo, setPenaltyInfo] = useState(null);

  if(!activeDeal) return null;

  const region = activeDeal.listings?.region || "Αθήνα";
  const statusLabel = {
    waiting: "Αγγελία ενεργή · Αναμένεις Seeker",
    matched: "Deal ενεργό · Κατευθύνσου στη θέση",
    seeker_ready: "Seeker έφτασε · Αναμένει αναχώρηση",
    giver_departed: "Giver αναχώρησε · Παρκάρισε τώρα!",
    spot_accepted: "Seeker αποδέχτηκε θέση · Βγες τώρα!",
  }[activeDeal.status] || "Deal ενεργό";

  const handleCancel = async () => {
    setCancelling(true);
    try {
      const { supabase } = await import("./supabase_client");

      // Αν είναι απλό listing (όχι deal ακόμα), απλά το κατεβάζουμε χωρίς ποινή
      if(activeDeal.isListing) {
        await supabase.from('listings').update({ status: 'cancelled' }).eq('id', activeDeal.listing_id);
        setCancelling(false);
        setShowConfirm(false);
        if(onCancel) onCancel();
        return;
      }

      const cancellerRole = activeDeal.role; // 'giver' ή 'seeker'
      const newStatus = cancellerRole === 'giver' ? 'cancelled_by_giver' : 'cancelled_by_seeker';

      // 1. Ενημέρωση deal + listing
      await supabase.from('deals').update({ 
        status: newStatus,
        giver_lat: null, giver_lng: null,
        seeker_lat: null, seeker_lng: null
      }).eq('id', activeDeal.id);
      await supabase.from('listings').update({ status: 'cancelled' }).eq('id', activeDeal.listing_id);

      // 2. Βρες IDs αδικημένου και κακού
      const cancellerId = cancellerRole === 'giver' ? activeDeal.giver_id : activeDeal.seeker_id;
      const victimId    = cancellerRole === 'giver' ? activeDeal.seeker_id : activeDeal.giver_id;

      // 3. Μέτρα ακυρώσεις του κακού στον ίδιο ρόλο εντός 2 εβδομάδων
      const twoWeeksAgo = new Date(Date.now() - 14*24*60*60*1000).toISOString();
      const roleField = cancellerRole === 'giver' ? 'giver_id' : 'seeker_id';
      const { data: recentCancels } = await supabase
        .from('deals')
        .select('id')
        .eq(roleField, cancellerId)
        .in('status', ['cancelled_by_giver','cancelled_by_seeker'])
        .gte('updated_at', twoWeeksAgo);

      const cancelCount = (recentCancels?.length || 0); // τώρα μετράει + την τρέχουσα

      // 4. Penalty level
      let penaltyLevel = cancelCount >= 3 ? 3 : cancelCount >= 2 ? 2 : 1;
      const banField = cancellerRole === 'giver' ? 'ban_give_until' : 'ban_take_until';
      const banUntil = penaltyLevel === 3
        ? new Date(Date.now() + 21*24*60*60*1000).toISOString()
        : null;

      // 5. Αποθήκευση penalty
      await supabase.from('penalties').insert({
        user_id: cancellerId,
        deal_id: activeDeal.id,
        type: `cancelled_as_${cancellerRole}`,
        penalty_level: penaltyLevel,
        ban_type: penaltyLevel === 3 ? cancellerRole : null,
        ban_until: banUntil,
      });

      // 6. Αν ban → ενημέρωση users table
      if(banUntil) {
        await supabase.from('users').update({ [banField]: banUntil }).eq('id', cancellerId);
      }

      // 7. Voucher 50% στον αδικημένο
      const voucherExpiry = new Date(Date.now() + 90*24*60*60*1000).toISOString();
      await supabase.from('vouchers').insert({
        user_id: victimId,
        deal_id: activeDeal.id,
        type: 'cancellation_compensation',
        discount_percent: 50,
        is_used: false,
        expires_at: voucherExpiry,
        description: 'Αποζημίωση ακύρωσης — 50% έκπτωση στο επόμενο deal',
      });

      // 8. Notification στον κακό
      const penaltyMsg = penaltyLevel === 1
        ? '⚠️ Μπήκες στη Λίστα 1 κακόβουλων χρηστών. Προσοχή!'
        : penaltyLevel === 2
        ? '⚠️ Μπήκες στη Λίστα 2. Την επόμενη ακύρωση θα έχεις ban 3 εβδομάδων!'
        : `🚫 Ban 3 εβδομάδων! Δεν μπορείς να ${cancellerRole==='giver'?'δίνεις':'παίρνεις'} θέσεις μέχρι ${new Date(banUntil).toLocaleDateString('el-GR')}.`;

      await supabase.from('notifications').insert([
        { user_id: cancellerId, type: 'penalty', message: penaltyMsg, is_read: false },
        { user_id: victimId, type: 'compensation', message: '🎁 Λάβατε 50% έκπτωση για το επόμενο deal σας λόγω ακύρωσης από τον άλλο χρήστη.', is_read: false },
      ]);

      // 9. Ενημέρωση UI με το penalty level
      setPenaltyInfo({ level: penaltyLevel, ban: !!banUntil, role: cancellerRole });

    } catch(e) { console.error("Cancel deal error:", e); }
    setCancelling(false);
  };

  if(showConfirm) return (
    <div style={{background:"rgba(239,68,68,0.1)",border:"2px solid rgba(239,68,68,0.5)",borderRadius:16,padding:16,marginBottom:16}}>
      {penaltyInfo ? (
        // Οθόνη αποτελέσματος penalty
        <>
          <div style={{textAlign:"center",marginBottom:12}}>
            <div style={{fontSize:36,marginBottom:8}}>{penaltyInfo.ban ? "🚫" : "⚠️"}</div>
            <div style={{color:"#EF4444",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:15,marginBottom:8}}>
              {penaltyInfo.ban ? `Ban ${penaltyInfo.role==='giver'?'Giver':'Seeker'} 3 εβδομάδων` : `Λίστα ${penaltyInfo.level} Κακόβουλων`}
            </div>
            <div style={{color:C.muted,fontSize:12,lineHeight:1.6,marginBottom:4}}>
              {penaltyInfo.level===1 && "Αυτή είναι η 1η ακύρωσή σου. Προσοχή στις επόμενες."}
              {penaltyInfo.level===2 && "2η ακύρωση εντός 2 εβδομάδων. Την επόμενη θα έχεις ban!"}
              {penaltyInfo.level===3 && "3η ακύρωση. Δεν μπορείς πλέον να συνεχίσεις ως " + (penaltyInfo.role==='giver'?'Giver':'Seeker') + " για 3 εβδομάδες."}
            </div>
            <div style={{background:"rgba(0,212,170,0.08)",border:`1px solid ${C.accent}33`,borderRadius:10,padding:10,marginTop:8}}>
              <div style={{color:C.accent,fontSize:11}}>🎁 Ο άλλος χρήστης έλαβε 50% έκπτωση για το επόμενο deal του.</div>
            </div>
          </div>
          <button onClick={()=>{setShowConfirm(false);setPenaltyInfo(null);if(onCancel)onCancel();}} style={{width:"100%",padding:"10px",borderRadius:10,border:"none",background:C.accent,color:"#fff",cursor:"pointer",fontWeight:700,fontSize:13}}>
            Κατανοητό
          </button>
        </>
      ) : (
        <>
          <div style={{color:"#EF4444",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:14,marginBottom:6}}>⚠️ Ακύρωση Deal;</div>
          <div style={{color:C.muted,fontSize:12,marginBottom:10,lineHeight:1.5}}>
            {activeDeal.isListing
              ? 'Η αγγελία σου θα κατεβεί. Δεν υπάρχει ποινή γιατί δεν έχει γίνει ακόμα match.'
              : activeDeal.role === 'giver' ? 'ο Seeker θα ειδοποιηθεί και δεν θα πληρωθείς.' : 'ο Giver θα ειδοποιηθεί και θα χάσεις τη θέση.'}
          </div>
          {!activeDeal.isListing && <div style={{background:"rgba(239,68,68,0.08)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:10,marginBottom:14}}>
            <div style={{color:"#EF4444",fontSize:11,lineHeight:1.6}}>
              🚨 <b>Συνέπειες ακύρωσης:</b><br/>
              • 1η ακύρωση: Λίστα 1 κακόβουλων<br/>
              • 2η εντός 2 εβδομάδων: Λίστα 2 + προειδοποίηση<br/>
              • 3η εντός 2 εβδομάδων: Ban 3 εβδομάδων ως {activeDeal.role==='giver'?'Giver':'Seeker'}
            </div>
          </div>}
          <div style={{display:"flex",gap:10}}>
            <button onClick={()=>setShowConfirm(false)} style={{flex:1,padding:"10px",borderRadius:10,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,cursor:"pointer",fontWeight:700,fontSize:13}}>Πίσω</button>
            <button onClick={handleCancel} disabled={cancelling} style={{flex:1,padding:"10px",borderRadius:10,border:"none",background:"#EF4444",color:"#fff",cursor:"pointer",fontWeight:700,fontSize:13}}>
              {cancelling ? "⏳..." : "Ναι, Ακύρωση"}
            </button>
          </div>
        </>
      )}
    </div>
  );

  return (
    <div style={{
      background:"linear-gradient(135deg,rgba(0,212,170,0.2),rgba(0,153,255,0.15))",
      border:"2px solid rgba(0,212,170,0.6)",
      borderRadius:16,padding:14,marginBottom:16,
      animation:"pulse 2s infinite"
    }}>
      <div style={{display:"flex",alignItems:"center",gap:12,cursor:"pointer"}} onClick={onResume}>
        <div style={{width:40,height:40,borderRadius:20,background:"rgba(0,212,170,0.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>🔴</div>
        <div style={{flex:1}}>
          <div style={{color:C.accent,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:13}}>Active Deal · {region}</div>
          <div style={{color:C.muted,fontSize:11,marginTop:2}}>{statusLabel}</div>
        </div>
        <div style={{color:C.accent,fontSize:13,fontWeight:700}}>Επιστροφή →</div>
      </div>
      {activeDeal.distance > 100 || activeDeal.distance === undefined ? (
        <button onClick={(e)=>{e.stopPropagation();setShowConfirm(true);}} style={{marginTop:10,width:"100%",padding:"8px",borderRadius:10,border:"1px solid rgba(239,68,68,0.4)",background:"rgba(239,68,68,0.08)",color:"#EF4444",cursor:"pointer",fontWeight:700,fontSize:12}}>
          ✕ Ακύρωση Deal
        </button>
      ) : (
        <div style={{marginTop:10,padding:"8px",borderRadius:10,border:"1px solid rgba(245,158,11,0.3)",background:"rgba(245,158,11,0.08)",textAlign:"center"}}>
          <span style={{color:"#F59E0B",fontSize:12,fontWeight:700}}>🔒 Ακύρωση απαγορεύεται — είσαι &lt;500μ από τη θέση</span>
        </div>
      )}
    </div>
  );
}

// ─── MAIN SCREEN ───────────────────────────────────────────────────────────────
function MainScreen({user,onNavigate,darkMode,activeDeal,onResumeDeal}){
  const T=useT(darkMode);
  const [activeUsers, setActiveUsers] = useState(null);
  const [liveListings, setLiveListings] = useState([]);

  useEffect(()=>{
    const loadLive = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const now = new Date().toISOString();
        const tenMinsAgo = new Date(Date.now()-10*60*1000).toISOString();

        // Πραγματικές ενεργές αγγελίες
        const { data: listings } = await supabase
          .from('listings')
          .select('region,price')
          .eq('status','active')
          .gt('expires_at', now)
          .order('created_at',{ascending:false})
          .limit(5);
        if(listings) setLiveListings(listings);

        // Ενεργοί χρήστες = χρήστες που έχουν στείλει heartbeat τελευταία 60 δευτερόλεπτα
        const oneMinAgo = new Date(Date.now()-60*1000).toISOString();
        const { count: onlineCount } = await supabase
          .from('users')
          .select('id', {count:'exact', head:true})
          .gte('last_seen', oneMinAgo);
        setActiveUsers(onlineCount || 0);
      } catch(e) { console.error(e); }
    };
    loadLive();
    const interval = setInterval(loadLive, 30000);
    return () => clearInterval(interval);
  },[]);

  return (
    <div style={{background:T.bg,minHeight:"100%"}}>
      <TopBar title="logo" darkMode={darkMode} rightEl={
        <div style={{display:"flex",gap:10}}>
          <button onClick={()=>onNavigate("settings")} style={{background:"none",border:"none",cursor:"pointer",fontSize:20}}>⚙️</button>
          <button onClick={()=>onNavigate("chat")} style={{background:"none",border:"none",cursor:"pointer",fontSize:20}}>💬</button>
        </div>
      }/>
      <div style={{padding:"20px 20px 100px"}}>
        <div style={{marginBottom:20}}>
          <div style={{color:T.muted,fontSize:13}}>Καλώς ήρθες,</div>
          <div style={{color:T.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:22}}>@{user.username}</div>
        </div>

        {/* 🔴 Active Deal Banner */}
        <ActiveDealBanner activeDeal={activeDeal} onResume={onResumeDeal} onCancel={()=>onNavigate("main")}/>

        {/* Nav demo banner */}
        <div onClick={()=>onNavigate("navDemo")} style={{background:"linear-gradient(135deg,rgba(168,85,247,0.2),rgba(0,153,255,0.2))",border:"2px solid rgba(168,85,247,0.5)",borderRadius:16,padding:14,marginBottom:20,cursor:"pointer",display:"flex",alignItems:"center",gap:12}}>
          <span style={{fontSize:30}}>🗺️</span>
          <div>
            <div style={{color:"#C084FC",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:14}}>Demo: Πλοήγηση σε Θέση</div>
            <div style={{color:C.muted,fontSize:12,marginTop:2}}>Δες πώς λειτουργεί η πλοήγηση μεταξύ χρηστών →</div>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:20}}>
          {[{icon:"👤",label:"Προφίλ",nav:"profile"},{icon:"🚗",label:"Οχήματα",nav:"vehicles"},{icon:"💳",label:"Πορτοφόλι",nav:"wallet"}].map(({icon,label,nav})=>(
            <div key={nav} onClick={()=>onNavigate(nav)} style={{background:T.card,borderRadius:14,border:`1px solid ${T.border}`,padding:14,textAlign:"center",cursor:"pointer"}}>
              <div style={{fontSize:24}}>{icon}</div>
              <div style={{color:T.text,fontSize:12,fontWeight:700,marginTop:4}}>{label}</div>
            </div>
          ))}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:24}}>
          <div onClick={()=>onNavigate("giveSpace")} style={{background:`linear-gradient(135deg,#00D4AA22,#00D4AA08)`,border:`2px solid ${C.accent}`,borderRadius:18,padding:20,cursor:"pointer",textAlign:"center"}}>
            <div style={{fontSize:34}}>🅿️</div>
            <div style={{color:C.accent,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:15,marginTop:8}}>Δώσε Θέση</div>
            <div style={{color:C.muted,fontSize:11,marginTop:4}}>Κέρδισε χρήματα</div>
          </div>
          <div onClick={()=>onNavigate("takeSpace")} style={{background:`linear-gradient(135deg,#0099FF22,#0099FF08)`,border:`2px solid #1A2EAA`,borderRadius:18,padding:20,cursor:"pointer",textAlign:"center"}}>
            <div style={{fontSize:34}}>🔍</div>
            <div style={{color:"#1A2EAA",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:15,marginTop:8}}>Βρες Θέση</div>
            <div style={{color:C.muted,fontSize:11,marginTop:4}}>Βρες parking</div>
          </div>
        </div>
        <div style={{marginBottom:14}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{color:T.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:15}}>🔴 Live τώρα</div>
            {activeUsers !== null && (
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <div style={{width:8,height:8,borderRadius:4,background:"#EF4444",animation:"pulse 2s infinite"}}/>
                <span style={{color:C.muted,fontSize:12}}>{activeUsers} ενεργοί χρήστες</span>
              </div>
            )}
          </div>
          {liveListings.length === 0 ? (
            <div style={{background:T.card,borderRadius:14,border:`1px solid ${T.border}`,padding:20,textAlign:"center"}}>
              <div style={{color:C.muted,fontSize:13}}>Δεν υπάρχουν ενεργές αγγελίες αυτή τη στιγμή.</div>
              <div style={{color:C.muted,fontSize:11,marginTop:4}}>Δήλωσε εσύ τη θέση σου →</div>
            </div>
          ) : liveListings.map((d,i)=>(
            <div key={i} style={{background:T.card,borderRadius:14,border:`1px solid ${T.border}`,padding:"12px 16px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{color:T.text,fontWeight:700,fontSize:14}}>📍 {d.region}</div>
                <div style={{color:C.muted,fontSize:11,marginTop:2}}>Διαθέσιμο τώρα</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{color:C.accent,fontWeight:800,fontSize:15}}>€{seekerPrice(d.price).toFixed(2)}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{background:C.glow,borderRadius:12,padding:12,border:`1px solid ${C.accent}22`,marginBottom:10,textAlign:"center"}}>
          <div style={{color:C.muted,fontSize:10,lineHeight:1.6}}>{PRIVACY_NOTE}</div>
        </div>
        <div style={{background:C.glow,borderRadius:12,padding:12,border:`1px solid ${C.accent}22`,textAlign:"center"}}>
          <div style={{color:C.muted,fontSize:10,lineHeight:1.6}}>{DISCLAIMER}</div>
        </div>
      </div>
    </div>
  );
}

// ─── GIVE SPACE ────────────────────────────────────────────────────────────────
// ─── LIVE MATCH WATCHER (Giver περιμένει Seeker) ──────────────────────────────
function LiveMatchWatcher({ region, listingId, onDepart, onDone }) {
  const [status, setStatus] = useState("waiting");
  const [departed, setDeparted] = useState(false);
  const [seekerArrived, setSeekerArrived] = useState(false);
  const [dealCompleted, setDealCompleted] = useState(false);
  const [dots, setDots] = useState(".");
  const [currentDealId, setCurrentDealId] = useState(null);
  const [listingAddress, setListingAddress] = useState("");
  const [spotAcceptedBySeeker, setSpotAcceptedBySeeker] = useState(false);
  const { myPos, otherPos, distance } = useGPSTracker(currentDealId, 'giver');
  const showGiverMap = distance !== null && distance <= 500;
  const giverRevealed = distance !== null && distance <= 500;
  const [seekerVehicle, setSeekerVehicle] = useState(null);
  // Warning dialog όταν ο Giver πατά "Αναχώρησα" πριν ο Seeker πατήσει "Έφτασα"
  const [showEarlyWarning, setShowEarlyWarning] = useState(false);
  // GPS check μετά από "Ακύρωση" στο warning
  const [cancelCheckStatus, setCancelCheckStatus] = useState(null); // null | 'checking' | 'clear' | 'caught'

  // Φόρτωση οχήματος Seeker όταν <100μ
  useEffect(()=>{
    if(!giverRevealed || !currentDealId || seekerVehicle) return;
    const load = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const { data: deal } = await supabase.from('deals').select('seeker_id').eq('id', currentDealId).single();
        if(!deal) return;
        const { data } = await supabase.from('vehicles').select('brand,model,color').eq('user_id', deal.seeker_id).limit(1).maybeSingle();
        if(data) setSeekerVehicle(`${data.brand} ${data.model} — ${data.color}`);
      } catch(e) {}
    };
    load();
  },[giverRevealed, currentDealId]);

  // Εκτέλεση πρόωρης αναχώρησης (μετά επιβεβαίωση ή GPS catch)
  const executeEarlyDepart = async () => {
    setDeparted(true);
    setShowEarlyWarning(false);
    try {
      const { supabase } = await import("./supabase_client");
      const { data: deal } = await supabase
        .from('deals').select('id,status')
        .eq('listing_id', listingId)
        .in('status', ['matched','seeker_ready','spot_accepted','giver_warned'])
        .order('created_at', {ascending: false})
        .limit(1).maybeSingle();
      if(deal) {
        await supabase.from('deals')
          .update({ status: 'giver_departed', giver_departed_at: new Date().toISOString() })
          .eq('id', deal.id);
      }
    } catch(e) { console.error("executeEarlyDepart error:", e); }
    if(onDepart) onDepart();
  };

  // Κανονική αναχώρηση (μετά από "Έφτασα" του Seeker)
  const executeNormalDepart = async () => {
    setDeparted(true);
    try {
      const { supabase } = await import("./supabase_client");
      const { data: deal } = await supabase
        .from('deals').select('id,status')
        .eq('listing_id', listingId)
        .in('status', ['matched','seeker_ready','spot_accepted','giver_warned'])
        .order('created_at', {ascending: false})
        .limit(1).maybeSingle();
      if(deal) {
        await supabase.from('deals')
          .update({ status: 'giver_departed', giver_departed_at: new Date().toISOString() })
          .eq('id', deal.id);
        console.log("giver_departed set for deal:", deal.id);
      }
    } catch(e) { console.error("Depart error:", e); }
    if(onDepart) onDepart();
  };

  // Κουμπί "Αναχώρησα" — έλεγχος αν ο Seeker έχει φτάσει
  const handleDepart = () => {
    if(seekerArrived) {
      // Κανονική αναχώρηση — ο Seeker έχει φτάσει
      executeNormalDepart();
    } else {
      // Πρόωρη — δείξε warning
      setShowEarlyWarning(true);
    }
  };

  // Ο Giver επιβεβαιώνει ότι φεύγει νωρίς
  const handleConfirmEarlyDepart = () => {
    executeEarlyDepart();
  };

  // Ο Giver πατά "Ακύρωση" στο warning — GPS check για 1 λεπτό
  const handleCancelEarlyDepart = () => {
    setShowEarlyWarning(false);
    setCancelCheckStatus('checking');
    const startPos = myPos ? { ...myPos } : null;
    // Έλεγχος GPS μετά από 5 λεπτά
    setTimeout(async () => {
      if(!startPos) { setCancelCheckStatus('clear'); return; }
      navigator.geolocation?.getCurrentPosition(async (pos) => {
        const curLat = pos.coords.latitude;
        const curLng = pos.coords.longitude;
        const dist = Math.sqrt(
          Math.pow((curLat - startPos.lat) * 111000, 2) +
          Math.pow((curLng - startPos.lng) * 111000, 2)
        );
        if(dist > 30) {
          // Έφυγε — τιμωρία
          setCancelCheckStatus('caught');
          await executeEarlyDepart();
        } else {
          // Είναι ακόμα εκεί — κανένα πρόβλημα
          setCancelCheckStatus('clear');
          setTimeout(() => setCancelCheckStatus(null), 3000);
        }
      }, () => {
        // GPS απέτυχε — αθώος
        setCancelCheckStatus('clear');
        setTimeout(() => setCancelCheckStatus(null), 3000);
      }, { enableHighAccuracy: true, timeout: 15000 });
    }, 5 * 60 * 1000); // 5 λεπτά
  };

  // GPS auto-detection: αν ο giver κινηθεί >50μ από την αρχική θέση
  useEffect(() => {
    if(status !== "matched" || departed) return;
    let startPos = null;
    const watchId = navigator.geolocation?.watchPosition((pos) => {
      if(!startPos) { startPos = pos.coords; return; }
      const dist = Math.sqrt(
        Math.pow((pos.coords.latitude - startPos.latitude) * 111000, 2) +
        Math.pow((pos.coords.longitude - startPos.longitude) * 111000, 2)
      );
      if(dist > 50) handleDepart();
    }, null, { enableHighAccuracy: true });
    return () => navigator.geolocation?.clearWatch(watchId);
  }, [status, departed]);

  // Animation για τις τελείες
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(d => d.length >= 3 ? "." : d + ".");
    }, 600);
    return () => clearInterval(interval);
  }, []);

  // Real-time παρακολούθηση + polling για seeker_ready
  useEffect(() => {
    if(!listingId) return;
    let alive = true;
    let pollInterval = null;
    let channel = null;

    const start = async () => {
      let sb;
      try {
        const mod = await import("./supabase_client");
        sb = mod.supabase;
      } catch(e) { console.error("Supabase import error:", e); return; }

      // Real-time για listing status (matched)
      channel = sb
        .channel(`listing_match_${listingId}`)
        .on('postgres_changes', {
          event: 'UPDATE', schema: 'public', table: 'listings',
          filter: `id=eq.${listingId}`,
        }, (payload) => {
          if(payload.new.status === 'matched') setStatus("matched");
        })
        .subscribe();

      // Βρες profile μία φορά — captured στο closure
      const { data: authData } = await sb.auth.getUser();
      const au = authData?.user;
      if(!au || !alive) return;
      const { data: profile } = await sb.from('users').select('id').eq('auth_id', au.id).single();
      if(!profile || !alive) return;

      // Polling για seeker_ready — άμεση πρώτη εκτέλεση + κάθε 3 δευτερόλεπτα
      const doPoll = async () => {
        if(!alive) return;
        try {
          // Βρες το deal μέσω listing_id — με status filter και ordering για αξιοπιστία
          const query = listingId
            ? sb.from('deals')
                .select('id,status,listings(address)')
                .eq('listing_id', listingId)
                .in('status', ['matched','seeker_ready','giver_departed','completed','spot_accepted','cancelled_early_departure'])
                .order('created_at', {ascending: false})
                .limit(1).maybeSingle()
            : sb.from('deals').select('id,status,listings(address)')
                .eq('giver_id', profile.id)
                .in('status', ['matched','seeker_ready','giver_departed','completed','spot_accepted'])
                .order('created_at', {ascending: false})
                .limit(1).maybeSingle();
          const { data, error } = await query;
          if(error) { console.error("Giver poll error:", error); return; }
          if(!data) return;
          console.log("Giver poll status:", data.status);
          if(data.id) setCurrentDealId(data.id);
          if(data.listings?.address) setListingAddress(data.listings.address);
          if(data.status === 'seeker_ready' || data.status === 'spot_accepted') setSeekerArrived(true);
          // Αλλαγή οθόνης σε όλα τα ενεργά statuses — όχι μόνο 'matched'
          if(['matched','seeker_ready','spot_accepted','giver_departed'].includes(data.status)) setStatus("matched");
          if(data.status === 'giver_departed') setDeparted(true);
          if(data.status === 'completed') { setStatus("matched"); setDealCompleted(true); }
          if(data.status === 'spot_accepted' && !departed) setSpotAcceptedBySeeker(true);
        } catch(e) { console.error("Giver poll exception:", e); }
      };
      doPoll(); // άμεση εκτέλεση χωρίς αναμονή
      pollInterval = setInterval(doPoll, 1500); // κάθε 1.5 δευτερόλεπτα
    };

    start();
    return () => {
      alive = false;
      if(pollInterval) clearInterval(pollInterval);
      if(channel) import("./supabase_client").then(({supabase:sb})=>sb.removeChannel(channel));
    };
  }, [listingId]);

  // Auto-close 3 δευτερόλεπτα μετά ολοκλήρωση
  useEffect(()=>{
    if(!dealCompleted) return;
    const t = setTimeout(()=>{ if(onDone) onDone(); }, 3000);
    return ()=>clearTimeout(t);
  },[dealCompleted]);

  if(dealCompleted) return (
    <div style={{background:"rgba(0,212,170,0.08)",border:`1px solid ${C.accent}44`,borderRadius:12,padding:20,marginBottom:16,textAlign:"center"}}>
      <div style={{fontSize:48,marginBottom:8}}>🎉</div>
      <div style={{color:C.accent,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:16,marginBottom:4}}>Deal Ολοκληρώθηκε!</div>
      <div style={{color:C.muted,fontSize:12,marginBottom:12}}>Τα χρήματα πιστώθηκαν στο πορτοφόλι σου.</div>
      <button onClick={()=>{ if(onDone) onDone(); }} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"10px 24px",fontWeight:800,fontSize:13,cursor:"pointer"}}>
        Επιστροφή →
      </button>
    </div>
  );

  return (
    <div style={{
      background: status === "matched" ? "rgba(0,212,170,0.1)" : "rgba(245,158,11,0.06)",
      border: `1px solid ${status === "matched" ? C.accent : C.warn}33`,
      borderRadius: 12, padding: 16, marginBottom: 16,
      display: "flex", alignItems: "center", gap: 12
    }}>

      {/* ── Warning dialog: πρόωρη αναχώρηση ── */}
      {showEarlyWarning && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",zIndex:300,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
          <div style={{background:C.card,borderRadius:20,padding:24,width:"100%",maxWidth:360,border:`1px solid ${C.warn}44`}}>
            <div style={{textAlign:"center",marginBottom:16}}>
              <div style={{fontSize:44,marginBottom:10}}>⚠️</div>
              <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:17,marginBottom:8}}>Φεύγεις νωρίς!</div>
              <div style={{color:C.muted,fontSize:13,lineHeight:1.6}}>
                Ο Seeker δεν έχει φτάσει ακόμα. Αν αναχωρήσεις τώρα θα <b style={{color:"#EF4444"}}>τιμωρηθείς</b> και ο Seeker θα λάβει αποζημίωση.
              </div>
            </div>
            <div style={{display:"flex",gap:10}}>
              <button
                onClick={handleCancelEarlyDepart}
                style={{flex:1,padding:"12px",borderRadius:12,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,cursor:"pointer",fontWeight:700,fontSize:13}}
              >Μείνε εκεί</button>
              <button
                onClick={handleConfirmEarlyDepart}
                style={{flex:1,padding:"12px",borderRadius:12,border:"none",background:"rgba(239,68,68,0.9)",color:"#fff",cursor:"pointer",fontWeight:800,fontSize:13}}
              >Φεύγω τώρα</button>
            </div>
          </div>
        </div>
      )}

      {/* ── GPS check status ── */}
      {cancelCheckStatus === 'checking' && (
        <div style={{position:"fixed",bottom:80,left:"50%",transform:"translateX(-50%)",background:"rgba(245,158,11,0.95)",borderRadius:12,padding:"10px 18px",zIndex:200,display:"flex",alignItems:"center",gap:8,boxShadow:"0 4px 20px rgba(0,0,0,0.3)"}}>
          <span style={{fontSize:16}}>🔍</span>
          <span style={{color:"#fff",fontWeight:700,fontSize:12}}>GPS check σε εξέλιξη... (5 λεπτά)</span>
        </div>
      )}
      {cancelCheckStatus === 'clear' && (
        <div style={{position:"fixed",bottom:80,left:"50%",transform:"translateX(-50%)",background:"rgba(0,212,170,0.95)",borderRadius:12,padding:"10px 18px",zIndex:200,display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:16}}>✅</span>
          <span style={{color:"#fff",fontWeight:700,fontSize:12}}>GPS επιβεβαίωσε — είσαι εκεί!</span>
        </div>
      )}
      {cancelCheckStatus === 'caught' && (
        <div style={{position:"fixed",bottom:80,left:"50%",transform:"translateX(-50%)",background:"rgba(239,68,68,0.95)",borderRadius:12,padding:"10px 18px",zIndex:200,display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:16}}>🚫</span>
          <span style={{color:"#fff",fontWeight:700,fontSize:12}}>GPS εντόπισε αναχώρηση — τιμωρία!</span>
        </div>
      )}
      {status === "waiting" ? <>
        <div style={{
          width: 36, height: 36, borderRadius: 18,
          background: "rgba(245,158,11,0.15)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 18, flexShrink: 0
        }}>⏳</div>
        <div>
          <div style={{ color: C.warn, fontWeight: 700, fontSize: 13 }}>
            Αναμονή Seeker{dots}
          </div>
          <div style={{ color: C.muted, fontSize: 11, marginTop: 3 }}>
            Η αγγελία σου είναι ενεργή στο {region}. Θα ειδοποιηθείς άμεσα όταν κάποιος αποδεχτεί.
          </div>
        </div>
      </> : <>
        <div style={{ fontSize: 32 }}>🎉</div>
        <div style={{flex:1}}>
          <div style={{ color: C.accent, fontWeight: 700, fontSize: 13 }}>Match! Seeker σε δρόμο</div>
          <div style={{ color: C.muted, fontSize: 11, marginTop: 3 }}>Ξεκίνα να κατευθύνεσαι στο όχημά σου.</div>
          {!departed && spotAcceptedBySeeker && <div style={{color:C.accent,fontSize:13,marginTop:6,marginBottom:8,fontWeight:800}}>🚗 Ο Seeker αποδέχτηκε τη θέση — Βγες τώρα!</div>}
          {!departed && seekerArrived && !spotAcceptedBySeeker && <div style={{color:"#1A2EAA",fontSize:12,marginTop:6,marginBottom:8,fontWeight:700}}>📍 Ο Seeker έφτασε και σε περιμένει!</div>}
          {!departed && !seekerArrived && <div style={{color:C.muted,fontSize:11,marginTop:6,marginBottom:8}}>⏳ Πάτα "Αναχώρησα" όταν είσαι έτοιμος να φύγεις.</div>}
          {!departed && <button onClick={handleDepart} style={{background: spotAcceptedBySeeker ? "#F59E0B" : C.accent,color:"#fff",border:"none",borderRadius:10,padding:"10px 20px",fontWeight:800,fontSize:13,cursor:"pointer",width:"100%"}}>🚗 Αναχώρησα</button>}
          {departed && <div style={{color:C.accent,fontSize:12,marginTop:8,fontWeight:700}}>✅ Αναμονή επιβεβαίωσης από Seeker...</div>}
          {showGiverMap && (
            <GoogleMapView myPos={myPos} otherPos={otherPos} role="giver" showOther={true} dealAddress={listingAddress} revealed={giverRevealed} otherVehicle={seekerVehicle}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  {seekerVehicle && <div style={{color:"#A855F7",fontSize:12,fontWeight:700}}>🚗 Seeker: {seekerVehicle}</div>}
                  {distance!==null && <div style={{color:"#1A2EAA",fontSize:11,marginTop:2}}>🔵 Απόσταση: {distance}μ</div>}
                </div>
                {!departed && <button onClick={handleDepart} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"10px 20px",fontWeight:800,fontSize:13,cursor:"pointer"}}>🚗 Αναχώρησα</button>}
                {departed && <div style={{color:C.accent,fontSize:13,fontWeight:700}}>✅ Αναμονή Seeker...</div>}
              </div>
            </GoogleMapView>
          )}
        </div>
      </>}
    </div>
  );
}


const VEHICLE_SIZE = {
  "Scooter": "small", "Μοτοσυκλέτα": "small",
  "Αυτοκίνητο": "medium", "SUV": "large",
  "Βαν": "large", "Φορτηγό": "large"
};
const SIZE_LABEL = { small: "Μικρή (Scooter/Μοτο)", medium: "Κανονική (Αυτοκίνητο)", large: "Μεγάλη (SUV/Βαν)" };

function GiveSpaceScreen({onBack,darkMode,user,resumeDealId,resumeListingId}){
  const [step,setStep]=useState(resumeListingId ? 3 : 1);
  const [region,setRegion]=useState("");
  const [selectedCity, setSelectedCity]=useState(()=>localStorage.getItem('toparking_city')||"Αθήνα");
  const handleCityChange = (city) => { setSelectedCity(city); localStorage.setItem('toparking_city', city); setRegion(""); };
  const [addr,setAddr]=useState({address:"",number:""});
  const [timing,setTiming]=useState(null);
  const [waitTime,setWaitTime]=useState(null);
  const [date,setDate]=useState("");
  const [time,setTime]=useState("");
  const [loading,setLoading]=useState(false);
  const [listingId,setListingId]=useState(resumeListingId||null);
  const [cancelling,setCancelling]=useState(false);
  const [banInfo,setBanInfo]=useState(null);
  const [noVehicleLength,setNoVehicleLength]=useState(false);
  const rd=getR(region, selectedCity);

  const [noVehicle, setNoVehicle] = useState(false);

  useEffect(()=>{
    const checkBan = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const { data: authData } = await supabase.auth.getUser();
        const au = authData?.user; if(!au) return;
        // Έλεγχος επιβεβαίωσης email
        if(!au.email_confirmed_at) {
          setBanInfo("email_not_verified");
          return;
        }
        const { data: profile } = await supabase.from('users').select('id,ban_give_until').eq('auth_id', au.id).single();
        if(profile?.ban_give_until && new Date(profile.ban_give_until) > new Date()) {
          setBanInfo(new Date(profile.ban_give_until).toLocaleDateString('el-GR'));
        }
        // Έλεγχος αν έχει όχημα με μήκος
        if(profile) {
          const { data: vehicle } = await supabase.from('vehicles').select('id,brand,model,length_m').eq('user_id', profile.id).limit(1).maybeSingle();
          if(!vehicle) { setNoVehicle(true); return; }
          if(!vehicle.length_m) {
            const len = await getVehicleLength(vehicle.brand, vehicle.model);
            if(len) {
              await supabase.from('vehicles').update({length_m: len}).eq('id', vehicle.id);
            } else {
              setNoVehicle(true);
            }
          }
        }
      } catch(e) {}
    };
    checkBan();
  },[]);

  if(noVehicle) return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Δώσε Θέση" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:40,textAlign:"center"}}>
        <div style={{fontSize:64,marginBottom:16}}>🚗</div>
        <div style={{color:"#F59E0B",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:12}}>Απαιτείται Όχημα</div>
        <div style={{color:C.muted,fontSize:13,lineHeight:1.7,marginBottom:20}}>
          Για να δίνεις θέση πρέπει να έχεις προσθέσει το όχημά σου με <b style={{color:C.text}}>γνωστό μήκος</b>.
        </div>
        <button onClick={onBack} style={{background:C.accent,color:"#fff",border:"none",borderRadius:12,padding:"12px 24px",fontWeight:800,fontSize:14,cursor:"pointer"}}>
          → Πήγαινε στα Οχήματα
        </button>
      </div>
    </div>
  );

  if(banInfo === "email_not_verified") return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Δώσε Θέση" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:40,textAlign:"center"}}>
        <div style={{fontSize:64,marginBottom:16}}>📧</div>
        <div style={{color:C.warn,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:12}}>Απαιτείται Επιβεβαίωση Email</div>
        <div style={{background:"rgba(245,158,11,0.08)",border:`1px solid ${C.warn}44`,borderRadius:12,padding:16,marginBottom:20,textAlign:"left"}}>
          <div style={{color:C.muted,fontSize:13,lineHeight:1.7}}>
            Για να δίνεις θέσεις πρέπει να επιβεβαιώσεις το email σου.<br/><br/>
            Έλεγξε τα εισερχόμενά σου για email από <b style={{color:C.text}}>ToParking</b> και κλικ στον σύνδεσμο επιβεβαίωσης.
          </div>
        </div>
        <div style={{color:C.muted,fontSize:12,marginBottom:16}}>Δεν το βρίσκεις; Έλεγξε τον φάκελο Spam/Junk.</div>
        <button onClick={onBack} style={{background:C.accent,color:"#fff",border:"none",borderRadius:12,padding:"12px 24px",fontWeight:800,fontSize:14,cursor:"pointer"}}>
          ← Πίσω
        </button>
      </div>
    </div>
  );

  if(banInfo) return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Δώσε Θέση" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:40,textAlign:"center"}}>
        <div style={{fontSize:64,marginBottom:16}}>🚫</div>
        <div style={{color:"#EF4444",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:12}}>Ban Giver</div>
        <div style={{color:C.muted,fontSize:13,lineHeight:1.7}}>
          Δεν μπορείς να δίνεις θέσεις μέχρι <b style={{color:C.text}}>{banInfo}</b> λόγω επαναλαμβανόμενων ακυρώσεων.
        </div>
      </div>
    </div>
  );

  const handlePublish = async () => {
    if(loading) return;
    setLoading(true);
    try {
      const { ListingsService, supabase } = await import("./supabase_client");
      const { data: authData } = await supabase.auth.getUser();
      const au = authData?.user;
      let maxLength = null;
      if(au) {
        const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
        if(profile) {
          // Έλεγχος αν υπάρχει ήδη ενεργή αγγελία ή deal
          const now = new Date().toISOString();
          const { data: activeListing } = await supabase
            .from('listings')
            .select('id')
            .eq('giver_id', profile.id)
            .eq('status', 'active')
            .gt('expires_at', now)
            .limit(1)
            .maybeSingle();
          const { data: activeGiverDeal } = await supabase
            .from('deals')
            .select('id')
            .eq('giver_id', profile.id)
            .in('status', ['matched','seeker_ready','giver_departed','spot_accepted'])
            .limit(1)
            .maybeSingle();
          if(activeListing || activeGiverDeal) {
            setLoading(false);
            alert("Έχεις ήδη μία ενεργή αγγελία ή deal. Ολοκλήρωσέ τη πρώτα πριν δημοσιεύσεις νέα.");
            return;
          }
          const { data: vehicle } = await supabase.from('vehicles').select('brand,model,length_m').eq('user_id', profile.id).limit(1).maybeSingle();
          if(vehicle?.length_m) maxLength = vehicle.length_m;
          else if(vehicle) maxLength = await getVehicleLength(vehicle.brand, vehicle.model);
        }
      }
      // Για scheduled listing, δημιούργησε scheduledAt timestamp
      const scheduledAt = timing === 'later' && date && time 
        ? new Date(`${date}T${time}`).toISOString() 
        : null;
      const { data } = await ListingsService.createListing({
        region,
        address: `${sanitize(addr.address)} ${sanitize(addr.number)}`,
        timing,
        waitMinutes: timing==="now" ? parseInt(waitTime) : null,
        price: rd?.price,
        giver_earn: rd?.user_earn,
        company_earn: rd?.price && rd?.user_earn ? Math.round((rd.price - rd.user_earn) * 100) / 100 : null,
        max_vehicle_length: maxLength,
        scheduledAt,
      });
      if(data?.id) setListingId(data.id);
    } catch(e) {
      console.error("Listing error:", e);
    }
    setLoading(false);
    setStep(3);
  };

  const handleCancelListing = async () => {
    if(!listingId || cancelling) return;
    setCancelling(true);
    try {
      const { ListingsService, supabase } = await import("./supabase_client");
      await ListingsService.cancelListing(listingId);

      // Ποινή Giver για ακύρωση αγγελίας πριν έρθει Seeker
      try {
        const { data: authData } = await supabase.auth.getUser();
        const au = authData?.user;
        if(au) {
          const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
          if(profile) {
            const twoWeeksAgo = new Date(Date.now() - 14*24*60*60*1000).toISOString();
            const { data: recent } = await supabase.from('penalties')
              .select('id').eq('user_id', profile.id).gte('created_at', twoWeeksAgo);
            const level = Math.min((recent?.length || 0) + 1, 3);
            const banUntil = level === 3
              ? new Date(Date.now() + 21*24*60*60*1000).toISOString()
              : null;

            await supabase.from('penalties').insert({
              user_id: profile.id,
              listing_id: listingId,
              type: 'cancelled_listing',
              penalty_level: level,
              ban_type: level === 3 ? 'giver' : null,
              ban_until: banUntil,
            });

            if(banUntil) {
              await supabase.from('users').update({ ban_give_until: banUntil }).eq('id', profile.id);
            }

            const msg = level === 1
              ? '⚠️ Λίστα 1 — Ακύρωσες αγγελία. Προσοχή στις επόμενες!'
              : level === 2
              ? '⚠️ Λίστα 2 — 2η ακύρωση αγγελίας. Την επόμενη θα έχεις ban!'
              : `🚫 Ban Giver 3 εβδομάδων — επαναλαμβανόμενες ακυρώσεις αγγελιών.`;

            await supabase.from('notifications').insert({
              user_id: profile.id, type: 'penalty', message: msg, is_read: false,
            });
          }
        }
      } catch(e) { console.error("Penalty error:", e); }

    } catch(e) {
      console.error("Cancel error:", e);
    }
    setCancelling(false);
    onBack();
  };
  return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Δώσε Θέση" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:20}}>
        <div style={{display:"flex",gap:6,marginBottom:24}}>{[1,2,3].map(s=><div key={s} style={{flex:1,height:4,borderRadius:4,background:step>=s?C.accent:C.border}}/>)}</div>
        {step===1&&<>
          <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:18}}>Πού είναι η θέση σου;</div>
          {/* City selector */}
          <div style={{marginBottom:14}}>
            <div style={{fontSize:12,color:C.muted,marginBottom:8,fontWeight:600}}>🏙️ Πόλη</div>
            <div style={{display:"flex",gap:8}}>
              {Object.keys(CITIES).map(city=>(
                <button key={city} onClick={()=>handleCityChange(city)}
                  style={{flex:1,padding:"10px",borderRadius:10,border:`2px solid ${selectedCity===city?C.accent:C.border}`,background:selectedCity===city?`${C.accent}15`:"transparent",color:selectedCity===city?C.accent:C.muted,fontWeight:700,fontSize:14,cursor:"pointer",transition:"all 0.2s"}}>
                  {city}
                </button>
              ))}
            </div>
          </div>
          <SearchInput label="Περιοχή" value={region} onChange={setRegion} city={selectedCity}/>
          <Input label="Οδός" value={addr.address} onChange={v=>setAddr({...addr,address:v})} placeholder="π.χ. Ερμού"/>
          <Input label="Αριθμός" value={addr.number} onChange={v=>setAddr({...addr,number:v})} placeholder="π.χ. 24"/>
          {region&&rd&&<Card style={{marginBottom:14,border:`1px solid ${C.accent}33`}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{color:C.muted,fontSize:12}}>Περιοχή</span><span style={{color:C.text,fontWeight:700}}>{region}</span></div>
            <div style={{background:C.glow,borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between"}}><span style={{color:C.muted,fontSize:12}}>💰 Κερδίζεις</span><span style={{color:C.accent,fontWeight:800,fontSize:18}}>€{rd.user_earn.toFixed(2)}</span></div>
          </Card>}
          {region&&<div style={{color:C.muted,fontSize:11,textAlign:"center",marginBottom:14,lineHeight:1.5}}>📍 Εμφανίζεται μόνο η περιοχή. Οι ακριβείς συντεταγμένες αποκαλύπτονται ΜΟΝΟ όταν ο άλλος χρήστης είναι 500μ. μακριά.</div>}
          <Btn style={{width:"100%"}} disabled={!region||!addr.address||!addr.number} onClick={()=>setStep(2)}>Επιβεβαίωση →</Btn>
        </>}
        {step===2&&<>
          <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:18}}>Πότε φεύγεις;</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:20}}>
            {["now","later"].map(t=><div key={t} onClick={()=>setTiming(t)} style={{border:`2px solid ${timing===t?C.accent:C.border}`,borderRadius:14,padding:20,cursor:"pointer",textAlign:"center",background:timing===t?C.glow:C.card}}>
              <div style={{fontSize:32}}>{t==="now"?"⚡":"📅"}</div>
              <div style={{color:C.text,fontWeight:700,marginTop:8}}>{t==="now"?"Τώρα":"Αργότερα"}</div>
            </div>)}
          </div>
          {timing==="now"&&<><div style={{color:C.muted,fontSize:13,marginBottom:12}}>Πόσο μπορείς να περιμένεις;</div><div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
            {[{v:"15",tip:"Κανονικό"},{v:"30",tip:"+€1.00 tip"}].map(({v,tip})=><div key={v} onClick={()=>setWaitTime(v)} style={{border:`2px solid ${waitTime===v?C.accent:C.border}`,borderRadius:12,padding:14,cursor:"pointer",textAlign:"center",background:waitTime===v?C.glow:C.card}}>
              <div style={{color:C.text,fontWeight:800,fontSize:16}}>{v} λεπτά</div><div style={{color:v==="30"?C.accent:C.muted,fontSize:12,fontWeight:700}}>{tip}</div>
            </div>)}
          </div>
          <div style={{background:"rgba(245,158,11,0.08)",border:`1px solid ${C.warn}33`,borderRadius:10,padding:"10px 14px",marginBottom:20}}>
            <div style={{color:C.warn,fontSize:11,lineHeight:1.6}}>
              ⚠️ <b>Αν ο seeker αργήσει</b> πάνω από 15 λεπτά, χρεώνεται αυτόματα <b>+15%</b> επιπλέον. Αν δεν εμφανιστεί, λαμβάνει παράβαση και εσύ παίρνεις <b>50% έκπτωση</b> στο επόμενο deal.
            </div>
          </div></>}
          {timing==="later"&&<><Input label="Ημερομηνία" value={date} onChange={setDate} type="date"/><Input label="Ώρα" value={time} onChange={setTime} type="time"/></>}
          <Btn style={{width:"100%"}} disabled={!timing||(timing==="now"&&!waitTime)||(timing==="later"&&(!date||!time))} onClick={handlePublish}>{loading?"⏳ Δημοσίευση...":"Συνέχεια →"}</Btn>
        </>}
        {step===3&&<>
          <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:18}}>✅ Αγγελία Δημοσιεύθηκε!</div>
          <Card style={{marginBottom:16}}>
            {[["Περιοχή",region],["Διεύθυνση",`${addr.address} ${addr.number}`]].map(([k,v])=><div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{color:C.muted,fontSize:13}}>{k}</span><span style={{color:C.text,fontWeight:700}}>{v}</span></div>)}
            {rd&&<div style={{background:C.glow,borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",marginTop:4}}><span style={{color:C.muted,fontSize:12}}>💰 Κερδίζεις</span><span style={{color:C.accent,fontWeight:800,fontSize:18}}>€{rd.user_earn.toFixed(2)}</span></div>}
          </Card>

          {/* Live status */}
          <LiveMatchWatcher region={region} listingId={listingId} onDone={onBack}/>

          <div style={{background:"rgba(239,68,68,0.08)",border:`1px solid ${C.danger}22`,borderRadius:12,padding:12,marginBottom:12}}>
            <div style={{color:C.muted,fontSize:11,lineHeight:1.6}}>{PRIVACY_NOTE}</div>
          </div>
          <div style={{color:C.muted,fontSize:10,textAlign:"center",marginBottom:16}}>{DISCLAIMER}</div>
          <div style={{display:"flex",gap:10}}>
            <Btn variant="danger" style={{flex:1}} onClick={handleCancelListing} disabled={cancelling}>
              {cancelling?"⏳ Ακύρωση...":"❌ Ακύρωση Αγγελίας"}
            </Btn>
            <Btn style={{flex:1}} onClick={onBack}>Αρχική</Btn>
          </div>
        </>}
      </div>
    </div>
  );
}

// ─── TAKE SPACE ────────────────────────────────────────────────────────────────
// ─── STRIPE PAYMENT SCREEN ───────────────────────────────────────────────────
// ─── STRIPE PAYMENT SCREEN ───────────────────────────────────────────────────
// Αντικατέστησε ολόκληρη τη συνάρτηση StripePaymentScreen στο ToParking.jsx

const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlnd3RuYXVlY2pwbmpmZXZybXZ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMwMzgxNjYsImV4cCI6MjA4ODYxNDE2Nn0.ZnDzUxmJm3bDIL59McVabdoHhlCMkiUqXEtjX6HdDnY";
const EDGE_FUNCTION_URL = "https://igwtnauecjpnjfevrmvw.supabase.co/functions/v1/hyper-function";

function StripePaymentScreen({onBack, onSuccess, listingId, dealId, price, region, darkMode}) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [totalAmount, setTotalAmount] = useState(null);
  const [stripeFee, setStripeFee] = useState(null);
  const cardRef = useRef(null);
  const stripeRef = useRef(null);
  const elementsRef = useRef(null);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      setError(null);
      try {
        // Χρησιμοποιούμε το anon key — ΟΧΙ το session token που μπορεί να λείπει
        const res = await fetch(EDGE_FUNCTION_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "apikey": SUPABASE_ANON_KEY,
            "Authorization": `Bearer ${SUPABASE_ANON_KEY}`,
          },
          body: JSON.stringify({
            action: "create_payment_intent",
            listingId,
            dealId,
          }),
        });

        if (!res.ok) {
          const errText = await res.text();
          throw new Error(`Edge Function error ${res.status}: ${errText}`);
        }

        const data = await res.json();

        if (data.error) {
          throw new Error(data.error);
        }

        if (!data.clientSecret) {
          throw new Error("Δεν ελήφθη clientSecret από τον server");
        }

        setClientSecret(data.clientSecret);
        setTotalAmount(data.amount);
        setStripeFee(data.stripeFee);

        // Φόρτωση Stripe + δημιουργία Payment Element
        const stripe = await loadStripe();
        stripeRef.current = stripe;

        const elements = stripe.elements({
          clientSecret: data.clientSecret,
          appearance: {
            theme: "night",
            variables: {
              colorPrimary: "#00D4AA",
              colorBackground: "#111827",
              colorText: "#F0F4FF",
              colorDanger: "#EF4444",
              fontFamily: "'DM Sans', sans-serif",
              borderRadius: "10px",
            },
          },
        });
        elementsRef.current = elements;

        const paymentElement = elements.create("payment");

        // Περίμενε το DOM να είναι έτοιμο
        await new Promise((resolve) => setTimeout(resolve, 150));

        if (cardRef.current) {
          paymentElement.mount(cardRef.current);
        }

      } catch (e) {
        console.error("Stripe init error:", e);
        setError(e.message);
      }
      setLoading(false);
    };

    init();
  }, [listingId, dealId]);

  const handlePay = async () => {
    if (!stripeRef.current || !elementsRef.current || processing) return;
    setProcessing(true);
    setError(null);

    try {
      const { error: stripeError, paymentIntent } = await stripeRef.current.confirmPayment({
        elements: elementsRef.current,
        confirmParams: {
          return_url: window.location.href,
        },
        redirect: "if_required",
      });

      if (stripeError) {
        setError(stripeError.message);
        setProcessing(false);
        return;
      }

      if (paymentIntent && (paymentIntent.status === "succeeded" || paymentIntent.status === "requires_capture")) {
        onSuccess();
      } else {
        setError("Η πληρωμή δεν ολοκληρώθηκε. Δοκίμασε ξανά.");
        setProcessing(false);
      }
    } catch (e) {
      setError(e.message);
      setProcessing(false);
    }
  };

  return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Πληρωμή" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:20}}>

        {/* Deal summary */}
        <Card style={{marginBottom:16}}>
          <div style={{color:C.text,fontWeight:800,fontSize:15,marginBottom:12}}>📋 Σύνοψη Deal</div>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
            <span style={{color:C.muted,fontSize:13}}>Θέση parking</span>
            <span style={{color:C.text,fontWeight:700}}>Περιοχή: {region}</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
            <span style={{color:C.muted,fontSize:13}}>Τιμή</span>
            <span style={{color:C.text,fontWeight:700}}>€{(price||0).toFixed(2)}</span>
          </div>
          {stripeFee != null && (
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
              <span style={{color:C.muted,fontSize:13}}>Χρέωση συναλλαγής</span>
              <span style={{color:C.muted,fontSize:13}}>€{(stripeFee/100).toFixed(2)}</span>
            </div>
          )}
          {totalAmount != null && (
            <div style={{display:"flex",justifyContent:"space-between",paddingTop:8,borderTop:`1px solid ${C.border}`}}>
              <span style={{color:C.text,fontWeight:800}}>Σύνολο</span>
              <span style={{color:C.accent,fontWeight:900,fontSize:18}}>€{(totalAmount/100).toFixed(2)}</span>
            </div>
          )}
        </Card>

        {/* Card input */}
        <Card style={{marginBottom:16}}>
          <div style={{color:C.text,fontWeight:800,fontSize:14,marginBottom:12}}>💳 Στοιχεία Πληρωμής</div>

          {loading && (
            <div style={{textAlign:"center",padding:24,color:C.muted}}>
              <div style={{width:24,height:24,border:`2px solid ${C.accent}`,borderTopColor:"transparent",borderRadius:"50%",animation:"spin 0.8s linear infinite",margin:"0 auto 10px"}}/>
              Φόρτωση φόρμας πληρωμής...
            </div>
          )}

          {/* Το Stripe Payment Element mount-άρεται εδώ */}
          <div
            ref={cardRef}
            style={{
              display: loading ? "none" : "block",
              minHeight: 44,
            }}
          />

          {error && (
            <div style={{
              color:"#EF4444",
              fontSize:12,
              marginTop:10,
              background:"rgba(239,68,68,0.1)",
              border:"1px solid rgba(239,68,68,0.3)",
              borderRadius:8,
              padding:"8px 12px",
            }}>
              ❌ {error}
            </div>
          )}
        </Card>

        {/* Test mode notice */}
        <div style={{
          background:"rgba(245,158,11,0.1)",
          border:"1px solid rgba(245,158,11,0.3)",
          borderRadius:10,
          padding:12,
          marginBottom:16,
        }}>
          <div style={{color:"#F59E0B",fontSize:11,lineHeight:1.6}}>
            🧪 <b>Test mode</b> — Χρησιμοποίησε κάρτα:<br/>
            <b>4242 4242 4242 4242</b><br/>
            Ημ/νία: οποιαδήποτε μελλοντική &nbsp;·&nbsp; CVC: οποιοδήποτε 3ψήφιο
          </div>
        </div>

        <button
          onClick={handlePay}
          disabled={loading || processing || !clientSecret}
          style={{
            width:"100%",
            padding:"14px",
            borderRadius:14,
            border:"none",
            background:(loading || processing || !clientSecret)
              ? C.border
              : `linear-gradient(135deg,${C.accent},#1A2EAA)`,
            color:"#fff",
            fontFamily:"'Syne',sans-serif",
            fontWeight:800,
            fontSize:15,
            cursor:(loading || processing || !clientSecret) ? "not-allowed" : "pointer",
            boxShadow:(loading || processing || !clientSecret)
              ? "none"
              : `0 4px 20px ${C.glow}`,
            transition:"all 0.2s",
          }}
        >
          {processing
            ? "⏳ Επεξεργασία..."
            : loading
            ? "⏳ Φόρτωση..."
            : `💳 Πλήρωσε €${totalAmount ? (totalAmount/100).toFixed(2) : (price||0).toFixed(2)} →`}
        </button>

        <div style={{textAlign:"center",marginTop:12}}>
          <span style={{color:C.muted,fontSize:11}}>🔒 Ασφαλής πληρωμή μέσω Stripe</span>
        </div>
      </div>
    </div>
  );
}

function TakeSpaceScreen({onBack,darkMode,user,resumeDeal}){
  const [step,setStep]=useState(resumeDeal ? 4 : 1);
  const [region,setRegion]=useState(resumeDeal?.listings?.region||"");
  const [selectedCity, setSelectedCity]=useState(()=>localStorage.getItem('toparking_city')||"Αθήνα");
  const handleCityChange = (city) => { setSelectedCity(city); localStorage.setItem('toparking_city', city); setRegion(""); };
  const [addr,setAddr]=useState({address:"",number:""});
  const [timing,setTiming]=useState(null);
  const [arrival,setArrival]=useState(null);
  const [date,setDate]=useState("");
  const [time,setTime]=useState("");
  const [loading,setLoading]=useState(false);
  const [matchedListing,setMatchedListing]=useState(null);
  const [dealId,setDealId]=useState(resumeDeal?.id||null);
  const [banInfo,setBanInfo]=useState(null);
  const [showPayment,setShowPayment]=useState(false);

  const [noVehicle,setNoVehicle]=useState(false);
  const [walkingEta,setWalkingEta]=useState(null); // λεπτά πεζή από parking → προορισμό

  useEffect(()=>{
    if(resumeDeal) return; // αν κάνουμε resume δεν ελέγχουμε ban
    const checkBan = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const { data: authData } = await supabase.auth.getUser();
        const au = authData?.user; if(!au) return;
        // Έλεγχος επιβεβαίωσης email
        if(!au.email_confirmed_at) {
          setBanInfo("email_not_verified");
          return;
        }
        const { data: profile } = await supabase.from('users').select('id,ban_take_until').eq('auth_id', au.id).single();
        if(profile?.ban_take_until && new Date(profile.ban_take_until) > new Date()) {
          setBanInfo(new Date(profile.ban_take_until).toLocaleDateString('el-GR'));
        }
        if(profile) {
          const { data: vehicle } = await supabase.from('vehicles').select('id,brand,model,length_m').eq('user_id', profile.id).limit(1).maybeSingle();
          if(!vehicle) { setNoVehicle(true); return; }
          if(!vehicle.length_m) {
            const len = await getVehicleLength(vehicle.brand, vehicle.model);
            if(len) await supabase.from('vehicles').update({length_m: len}).eq('id', vehicle.id);
            else setNoVehicle(true);
          }
        }
      } catch(e) {}
    };
    checkBan();
  },[]);

  if(noVehicle) return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Βρες Θέση" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:40,textAlign:"center"}}>
        <div style={{fontSize:64,marginBottom:16}}>🚗</div>
        <div style={{color:"#F59E0B",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:12}}>Απαιτείται Όχημα</div>
        <div style={{color:C.muted,fontSize:13,lineHeight:1.7,marginBottom:20}}>
          Για να βρεις θέση πρέπει να έχεις προσθέσει το όχημά σου με <b style={{color:C.text}}>γνωστό μήκος</b>.
        </div>
        <button onClick={onBack} style={{background:"#0099FF",color:"#fff",border:"none",borderRadius:12,padding:"12px 24px",fontWeight:800,fontSize:14,cursor:"pointer"}}>
          → Πήγαινε στα Οχήματα
        </button>
      </div>
    </div>
  );

  if(banInfo === "email_not_verified") return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Βρες Θέση" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:40,textAlign:"center"}}>
        <div style={{fontSize:64,marginBottom:16}}>📧</div>
        <div style={{color:C.warn,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:12}}>Απαιτείται Επιβεβαίωση Email</div>
        <div style={{background:"rgba(245,158,11,0.08)",border:`1px solid ${C.warn}44`,borderRadius:12,padding:16,marginBottom:20,textAlign:"left"}}>
          <div style={{color:C.muted,fontSize:13,lineHeight:1.7}}>
            Για να βρεις θέση πρέπει να επιβεβαιώσεις το email σου.<br/><br/>
            Έλεγξε τα εισερχόμενά σου για email από <b style={{color:C.text}}>ToParking</b> και κλικ στον σύνδεσμο επιβεβαίωσης.
          </div>
        </div>
        <div style={{color:C.muted,fontSize:12,marginBottom:16}}>Δεν το βρίσκεις; Έλεγξε τον φάκελο Spam/Junk.</div>
        <button onClick={onBack} style={{background:"#0099FF",color:"#fff",border:"none",borderRadius:12,padding:"12px 24px",fontWeight:800,fontSize:14,cursor:"pointer"}}>
          ← Πίσω
        </button>
      </div>
    </div>
  );

  if(banInfo) return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Βρες Θέση" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:40,textAlign:"center"}}>
        <div style={{fontSize:64,marginBottom:16}}>🚫</div>
        <div style={{color:"#EF4444",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:12}}>Ban Seeker</div>
        <div style={{color:C.muted,fontSize:13,lineHeight:1.7}}>
          Δεν μπορείς να αναζητάς θέσεις μέχρι <b style={{color:C.text}}>{banInfo}</b> λόγω επαναλαμβανόμενων ακυρώσεων.
        </div>
      </div>
    </div>
  );
  const rd=getR(region, selectedCity);

  const handleSearch = async () => {
    if(loading) return;
    setLoading(true);
    try {
      const { ListingsService, supabase } = await import("./supabase_client");
      // Βρες το μήκος οχήματος του Seeker
      let seekerLength = null;
      const { data: authData } = await supabase.auth.getUser();
      if(authData?.user) {
        const { data: profile } = await supabase.from('users').select('id').eq('auth_id', authData.user.id).single();
        if(profile) {
          const { data: vehicle } = await supabase.from('vehicles').select('brand,model,length_m').eq('user_id', profile.id).limit(1).maybeSingle();
          if(vehicle?.length_m) seekerLength = vehicle.length_m;
          else if(vehicle) seekerLength = await getVehicleLength(vehicle.brand, vehicle.model);
        }
      }
      const { data } = await ListingsService.searchListings(region, null, seekerLength);
      if(data && data.length > 0) {
        setMatchedListing(data[0]);
        // Υπολογισμός πεζής απόστασης από parking → προορισμό Seeker
        // (μόνο αν έχουμε διεύθυνση seeker και διεύθυνση listing)
        const seekerDest = addr?.address ? `${addr.address} ${addr.number || ''}, ${region}, Αθήνα` : null;
        const parkingAddr = data[0]?.address ? `${data[0].address}, ${region}, Αθήνα` : null;
        if(seekerDest && parkingAddr && window.google?.maps) {
          try {
            const ds = new window.google.maps.DirectionsService();
            ds.route(
              { origin: parkingAddr, destination: seekerDest, travelMode: window.google.maps.TravelMode.WALKING },
              (result, status) => {
                if(status === 'OK') {
                  const secs = result.routes[0]?.legs[0]?.duration?.value || 0;
                  setWalkingEta(Math.max(1, Math.ceil(secs / 60)));
                } else {
                  // Fallback: εκτίμηση από distance_meters αν υπάρχει
                  setWalkingEta(Math.max(1, Math.round((data[0]?.distance_meters || 400) / 80)));
                }
              }
            );
          } catch(e) {
            setWalkingEta(Math.max(1, Math.round((data[0]?.distance_meters || 400) / 80)));
          }
        } else {
          setWalkingEta(Math.max(1, Math.round((data[0]?.distance_meters || 400) / 80)));
        }
      } else {
        setMatchedListing(null);
        setWalkingEta(null);
      }
    } catch(e) {
      console.error("Search error:", e);
    }
    setLoading(false);
    setStep(3);
  };

  const handleAccept = async () => {
    if(!matchedListing) { onBack(); return; }
    setShowPayment(true);
  };

  const handlePaymentSuccess = async () => {
    setShowPayment(false);
    setLoading(true);
    try {
      const { DealsService } = await import("./supabase_client");
      const { data, error } = await DealsService.createDeal({ listingId: matchedListing.id });
      console.log("Deal created:", data, "Error:", error);
      if(data?.id) {
        setDealId(data.id);
        setStep(4);
      } else {
        console.error("No deal id returned:", error);
        // Προσπάθησε ξανά μια φορά
        await new Promise(r => setTimeout(r, 1000));
        const { data: data2 } = await DealsService.createDeal({ listingId: matchedListing.id });
        if(data2?.id) setDealId(data2.id);
        setStep(4);
      }
    } catch(e) { 
      console.error("Deal error:", e);
      setStep(4); // Πήγαινε στο step 4 ακόμα και αν αποτύχει
    }
    setLoading(false);
  };

  if(showPayment && matchedListing) return (
    <StripePaymentScreen
      onBack={()=>setShowPayment(false)}
      onSuccess={handlePaymentSuccess}
      listingId={matchedListing.id}
      dealId={dealId}
      price={seekerPrice(matchedListing.price)}
      region={matchedListing.region || region}
      darkMode={darkMode}
    />
  );

  return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Βρες Θέση" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:20}}>
        <div style={{display:"flex",gap:6,marginBottom:24}}>{[1,2,3,4].map(s=><div key={s} style={{flex:1,height:4,borderRadius:4,background:step>=s?"#0099FF":C.border}}/>)}</div>
        {step===1&&<>
          <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:18}}>Πού θέλεις να παρκάρεις;</div>
          {/* City selector */}
          <div style={{marginBottom:14}}>
            <div style={{fontSize:12,color:C.muted,marginBottom:8,fontWeight:600}}>🏙️ Πόλη</div>
            <div style={{display:"flex",gap:8}}>
              {Object.keys(CITIES).map(city=>(
                <button key={city} onClick={()=>handleCityChange(city)}
                  style={{flex:1,padding:"10px",borderRadius:10,border:`2px solid ${selectedCity===city?"#1A2EAA":C.border}`,background:selectedCity===city?"rgba(26,46,170,0.1)":"transparent",color:selectedCity===city?"#1A2EAA":C.muted,fontWeight:700,fontSize:14,cursor:"pointer",transition:"all 0.2s"}}>
                  {city}
                </button>
              ))}
            </div>
          </div>
          <SearchInput label="Περιοχή" value={region} onChange={setRegion} city={selectedCity}/>
          <Input label="Οδός" value={addr.address} onChange={v=>setAddr({...addr,address:v})} placeholder="π.χ. Πατησίων"/>
          <Input label="Αριθμός" value={addr.number} onChange={v=>setAddr({...addr,number:v})} placeholder="π.χ. 10"/>
          {region&&rd&&<Card style={{marginBottom:14,border:"1px solid rgba(0,153,255,0.3)"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{color:C.muted,fontSize:12}}>Γραμμή</span><Badge color={LINE_COLORS[rd.line]||C.muted}>{rd.line}</Badge></div>
            <div style={{background:"rgba(0,153,255,0.1)",borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",marginBottom:4}}><span style={{color:C.muted,fontSize:12}}>💳 Πληρώνεις</span><span style={{color:"#1A2EAA",fontWeight:800,fontSize:18}}>€{seekerPrice(rd.price).toFixed(2)}</span></div>
            <div style={{color:C.muted,fontSize:10,textAlign:"right"}}>✓ Συμπεριλαμβάνει χρέωση συναλλαγής</div>
          </Card>}
          <Btn style={{width:"100%",background:"linear-gradient(135deg,#00C8C8,#1A2EAA)"}} disabled={!region||!addr.address||!addr.number} onClick={()=>setStep(2)}>Αναζήτηση →</Btn>
        </>}
        {step===2&&<>
          <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:18}}>Πότε τη χρειάζεσαι;</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:20}}>
            {["now","later"].map(t=><div key={t} onClick={()=>setTiming(t)} style={{border:`2px solid ${timing===t?"#0099FF":C.border}`,borderRadius:14,padding:20,cursor:"pointer",textAlign:"center",background:timing===t?"rgba(0,153,255,0.1)":C.card}}>
              <div style={{fontSize:32}}>{t==="now"?"⚡":"📅"}</div><div style={{color:C.text,fontWeight:700,marginTop:8}}>{t==="now"?"Αμέσως":"Προγραμματισμός"}</div>
            </div>)}
          </div>
          {timing==="now"&&<><div style={{color:C.muted,fontSize:13,marginBottom:12}}>Σε πόση ώρα φτάνεις;</div><div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
            {[{v:"15",note:"Χωρίς έξτρα"},{v:"30",note:"+€1.00 extra"}].map(({v,note})=><div key={v} onClick={()=>setArrival(v)} style={{border:`2px solid ${arrival===v?"#0099FF":C.border}`,borderRadius:12,padding:14,cursor:"pointer",textAlign:"center",background:arrival===v?"rgba(0,153,255,0.1)":C.card}}>
              <div style={{color:C.text,fontWeight:800,fontSize:15}}>{v} λεπτά</div><div style={{color:v==="30"?C.warn:C.accent,fontSize:11,fontWeight:700}}>{note}</div>
            </div>)}
          </div>
          <div style={{background:"rgba(245,158,11,0.08)",border:`1px solid ${C.warn}33`,borderRadius:10,padding:"10px 14px",marginBottom:20}}>
            <div style={{color:C.warn,fontSize:11,lineHeight:1.6}}>
              ⚠️ <b>Χρέωση καθυστέρησης:</b> Αν αργήσεις πάνω από 15 λεπτά από τη συμφωνημένη ώρα, χρεώνεσαι <b>+15%</b> επιπλέον. Αν δεν εμφανιστείς, λαμβάνεις παράβαση και ο giver παίρνει <b>50% έκπτωση</b> στο επόμενο deal.
            </div>
          </div></>}
          {timing==="later"&&<>
            <div style={{color:C.muted,fontSize:13,marginBottom:12}}>Για ποια ημερομηνία και ώρα;</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
              <div>
                <div style={{fontSize:11,color:C.muted,marginBottom:5,fontWeight:600}}>Ημερομηνία</div>
                <input type="date" value={date} onChange={e=>setDate(e.target.value)}
                  min={new Date().toISOString().split("T")[0]}
                  style={{width:"100%",padding:"10px 12px",borderRadius:10,border:`1px solid ${C.border}`,background:C.surface,color:C.text,fontSize:13,outline:"none",boxSizing:"border-box"}}/>
              </div>
              <div>
                <div style={{fontSize:11,color:C.muted,marginBottom:5,fontWeight:600}}>Ώρα</div>
                <input type="time" value={time} onChange={e=>setTime(e.target.value)}
                  style={{width:"100%",padding:"10px 12px",borderRadius:10,border:`1px solid ${C.border}`,background:C.surface,color:C.text,fontSize:13,outline:"none",boxSizing:"border-box"}}/>
              </div>
            </div>
          </>}
          <Btn style={{width:"100%",background:"linear-gradient(135deg,#00C8C8,#1A2EAA)"}} disabled={!timing||(timing==="now"&&!arrival)||(timing==="later"&&(!date||!time))} onClick={handleSearch}>{loading?"⏳ Αναζήτηση...":"Εύρεση Match →"}</Btn>
        </>}
        {step===3&&<>
          {matchedListing||rd ? <>
          <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:18}}>
            {matchedListing?"🎯 Match Βρέθηκε! · Ξεκίνα πλοήγηση":"⏳ Δεν βρέθηκε match ακόμα"}
          </div>
          {matchedListing ? <>
          <Card style={{marginBottom:14,border:"2px solid rgba(0,153,255,0.3)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}><span style={{color:C.text,fontWeight:800}}>Θέση στο {region}</span><Badge color="#0099FF">Match</Badge></div>
            <div style={{background:"rgba(0,153,255,0.1)",borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{color:C.muted,fontSize:12}}>💳 Πληρώνεις</span><span style={{color:"#1A2EAA",fontWeight:800,fontSize:16}}>€{seekerPrice(matchedListing.price||rd?.price||0).toFixed(2)}</span></div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              <Badge color={C.muted}>🚶 ~{walkingEta != null ? walkingEta : Math.max(1,Math.round((matchedListing?.distance_meters||400)/80))} λεπτά πεζή</Badge>
              <Badge color={C.accent}>Διαθέσιμο τώρα</Badge>
            </div>
          </Card>
          <div style={{background:"rgba(239,68,68,0.08)",border:`1px solid ${C.danger}22`,borderRadius:12,padding:12,marginBottom:14}}>
            <div style={{color:C.muted,fontSize:11,lineHeight:1.6}}>{PRIVACY_NOTE}<br/>🚗 Το όχημα αποκαλύπτεται μόνο στα 500μ.</div>
          </div>
          <div style={{display:"flex",gap:10}}>
            <Btn variant="ghost" style={{flex:1}} onClick={()=>setStep(2)}>Άκυρο</Btn>
            <Btn style={{flex:1,background:"linear-gradient(135deg,#00C8C8,#1A2EAA)"}} onClick={handleAccept}>Αποδοχή + Πλοήγηση ✓</Btn>
          </div>
          </> : <>
          <Card style={{marginBottom:14,textAlign:"center",padding:30}}>
            <div style={{fontSize:48,marginBottom:12}}>🔍</div>
            <div style={{color:C.text,fontWeight:700,marginBottom:8}}>Δεν υπάρχει διαθέσιμη θέση στο {region} αυτή τη στιγμή.</div>
            <div style={{color:C.muted,fontSize:12}}>Δοκίμασε ξανά σε λίγο ή επέλεξε άλλη περιοχή.</div>
          </Card>
          <Btn style={{width:"100%"}} onClick={()=>setStep(1)}>← Αλλαγή περιοχής</Btn>
          </>}
          </> : null}
        </>}

        {step===4&&<SeekerConfirmScreen dealId={dealId} region={region} matchedListing={matchedListing} onDone={onBack} darkMode={darkMode}/>}

      </div>
    </div>
  );
}

// ─── SEEKER CONFIRM SCREEN ──────────────────────────────────────────────────
function SeekerConfirmScreen({dealId: initialDealId, region, matchedListing, onDone, darkMode}){
  const [dealId, setDealId] = useState(initialDealId);
  
  // Αν δεν έχουμε dealId, προσπάθησε να το βρεις από τη βάση
  useEffect(()=>{
    if(dealId || !matchedListing?.id) return;
    const retry = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const { data: au } = await supabase.auth.getUser();
        if(!au?.user) return;
        const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.user.id).single();
        if(!profile) return;
        // Ψάξε για deal που μόλις δημιουργήθηκε για αυτό το listing
        const { data: deal } = await supabase.from('deals')
          .select('id').eq('listing_id', matchedListing.id)
          .eq('seeker_id', profile.id)
          .order('created_at', {ascending: false})
          .limit(1).maybeSingle();
        if(deal?.id) { console.log("Found deal on retry:", deal.id); setDealId(deal.id); }
      } catch(e) { console.error("Deal retry error:", e); }
    };
    // Δοκίμασε κάθε 2 δευτερόλεπτα για 10 δευτερόλεπτα
    const interval = setInterval(retry, 2000);
    setTimeout(() => clearInterval(interval), 10000);
    retry();
    return () => clearInterval(interval);
  },[matchedListing?.id]);
  const [giverDeparted, setGiverDeparted] = useState(false);
  const [seekerReady, setSeekerReady] = useState(false);
  const [timeLeft, setTimeLeft] = useState(90);
  const [timerActive, setTimerActive] = useState(false);
  const [status, setStatus] = useState("waiting");
  const { myPos, otherPos, distance } = useGPSTracker(dealId, 'seeker');
  const [otherVehicle, setOtherVehicle] = useState(null);
  const revealed = distance !== null && distance <= 500;
  const [spotChoice, setSpotChoice] = useState(null);
  const [spotReportDone, setSpotReportDone] = useState(false);
  // Early departure state
  const [earlyDeparture, setEarlyDeparture] = useState(false);
  const [earlyDepartureLoading, setEarlyDepartureLoading] = useState(false);
  const [altListing, setAltListing] = useState(null);
  const [altWalkMins, setAltWalkMins] = useState(null);
  const [altSearchDone, setAltSearchDone] = useState(false);
  const [altAccepting, setAltAccepting] = useState(false); // loading κατά τη δημιουργία νέου deal
  const [altDealCreated, setAltDealCreated] = useState(false); // επιτυχής δημιουργία νέου deal
  const seekerReadyRef = useRef(false);
  seekerReadyRef.current = seekerReady;

  // Φόρτωση οχήματος Giver όταν <100μ
  useEffect(()=>{
    if(!revealed || !matchedListing?.giver_id || otherVehicle) return;
    const load = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const giverId = matchedListing.giver_id;
        const { data } = await supabase.from('vehicles').select('brand,model,color').eq('user_id', giverId).limit(1).maybeSingle();
        if(data) setOtherVehicle(`${data.brand} ${data.model} — ${data.color}`);
      } catch(e) {}
    };
    load();
  },[revealed, matchedListing]);

  // Geocode destination address
  const [destPos, setDestPos] = useState(null);
  const dealAddress = matchedListing?.address || "";

  // Αν δεν έχουμε matchedListing αλλά έχουμε dealId, φόρτωσε τη διεύθυνση από τη βάση
  useEffect(() => {
    const geocode = (addr) => {
      if(!addr) return;
      loadGoogleMaps().then(() => {
        const geocoder = new window.google.maps.Geocoder();
        const fullAddress = `${addr}, ${region}, Αθήνα, Ελλάδα`;
        geocoder.geocode({ address: fullAddress }, (results, status) => {
          if(status === 'OK' && results[0]) {
            const loc = results[0].geometry.location;
            setDestPos({ lat: loc.lat(), lng: loc.lng() });
          }
        });
      });
    };

    if(dealAddress) { geocode(dealAddress); return; }

    // Fallback: φόρτωσε από Supabase αν δεν έχουμε matchedListing
    if(!dealId) return;
    const loadFromDB = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const { data } = await supabase.from('deals')
          .select('listings(address,region)').eq('id', dealId).single();
        const addr = data?.listings?.address;
        const reg = data?.listings?.region || region;
        if(addr) geocode(addr);
      } catch(e) {}
    };
    loadFromDB();
  }, [dealAddress, dealId]);

  // Χρόνος πεζή σε λεπτά
  const walkMins = destPos && myPos && window.google?.maps?.geometry
    ? Math.max(1, Math.round(window.google.maps.geometry.spherical.computeDistanceBetween(
        new window.google.maps.LatLng(myPos.lat, myPos.lng),
        new window.google.maps.LatLng(destPos.lat, destPos.lng)
      ) / 80))
    : null;

  // Polling για αλλαγές στο deal (κάθε 3 δευτερόλεπτα)
  useEffect(() => {
    let active = true;
    let poll = null;

    const startPolling = async () => {
      let sb;
      try {
        const mod = await import("./supabase_client");
        sb = mod.supabase;
      } catch(e) { console.error("Supabase import error:", e); return; }

      // Βρες πρώτα τον seeker profile
      const { data: authData } = await sb.auth.getUser();
      const au = authData?.user;
      if(!au) return;
      const { data: profile } = await sb.from('users').select('id').eq('auth_id', au.id).single();
      if(!profile) return;

      // supabase (sb) και profile είναι captured στο closure — δεν χάνονται
      // Χρησιμοποιούμε captured dealId ref για αξιόπιστο polling
      let capturedDealId = dealId || initialDealId;

      poll = setInterval(async () => {
        if(!active) return;
        try {
          let query;
          if(capturedDealId) {
            // Αν έχουμε dealId, ψάχνουμε απευθείας
            query = sb.from('deals').select('id,status,giver_lat,giver_lng').eq('id', capturedDealId).single();
          } else {
            query = sb.from('deals').select('id,status,giver_lat,giver_lng')
              .eq('seeker_id', profile.id)
              .in('status', ['matched','seeker_ready','giver_departed','completed','spot_accepted','giver_warned'])
              .order('created_at', {ascending: false})
              .limit(1).maybeSingle();
          }
          const { data, error } = await query;
          if(error) { console.error("Poll error:", error); return; }
          if(!data) return;
          if(data.id) { setDealId(data.id); capturedDealId = data.id; }
          console.log("Seeker poll status:", data.status);
          if(data.status === 'giver_departed' || data.status === 'giver_warned') {
            // Αν ο Seeker ΔΕΝ έχει πατήσει "Έφτασα" → πρόωρη αναχώρηση
            if(!seekerReadyRef.current) {
              setEarlyDeparture(true);
              handleEarlyDepartureFn(capturedDealId);
            } else {
              setGiverDeparted(true);
              setTimerActive(false);
            }
          }
          if(data.status === 'completed') {
            setStatus("completed");
            // Κάνε το listing inactive ώστε να μην εμφανίζεται στο banner
            try {
              await sb.from('listings').update({ status: 'completed' })
                .eq('id', matchedListing?.id || data.listing_id || '');
            } catch(e) {}
          }
          if(data.giver_lat && data.giver_lng) setGiverGPS({lat: data.giver_lat, lng: data.giver_lng});
        } catch(e) { console.error("Poll exception:", e); }
      }, 2000);
    };

    startPolling();
    return () => { active = false; if(poll) clearInterval(poll); };
  }, []);

  // ── No-show detection: αν ο Seeker δεν πατήσει "Έφτασα" εντός wait_minutes ──
  useEffect(() => {
    if(!matchedListing?.id) return;
    let noShowTimer = null;

    const setupNoShowTimer = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        // Φόρτωσε wait_minutes από το listing
        const { data: listing } = await supabase
          .from('listings')
          .select('wait_minutes, created_at, expires_at')
          .eq('id', matchedListing.id)
          .single();
        if(!listing) return;

        // Υπολόγισε πόσος χρόνος απομένει από τώρα μέχρι το expires_at
        const expiresAt = new Date(listing.expires_at).getTime();
        const msLeft = expiresAt - Date.now();
        if(msLeft <= 0) return; // Έχει ήδη λήξει

        noShowTimer = setTimeout(async () => {
          // Ελέγχουμε αν ο Seeker έχει ήδη πατήσει "Έφτασα"
          if(seekerReadyRef.current) return;

          try {
            const { data: authData } = await supabase.auth.getUser();
            const au = authData?.user;
            if(!au) return;
            const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
            if(!profile) return;

            // Βρες το deal
            const { data: deal } = await supabase.from('deals')
              .select('id,status,giver_id,region,price')
              .eq('listing_id', matchedListing.id)
              .eq('seeker_id', profile.id)
              .in('status', ['matched','seeker_ready'])
              .maybeSingle();
            if(!deal) return;

            // Ακύρωση deal ως no-show
            await supabase.from('deals').update({
              status: 'cancelled_no_show',
              cancelled_at: new Date().toISOString(),
            }).eq('id', deal.id);

            // Listing → inactive
            await supabase.from('listings').update({ status: 'inactive' }).eq('id', matchedListing.id);

            // Ποινή Seeker
            const twoWeeksAgo = new Date(Date.now() - 14*24*60*60*1000).toISOString();
            const { data: recent } = await supabase.from('penalties')
              .select('id').eq('user_id', profile.id).gte('created_at', twoWeeksAgo);
            const level = Math.min((recent?.length || 0) + 1, 3);
            const banUntil = level === 3
              ? new Date(Date.now() + 21*24*60*60*1000).toISOString()
              : null;

            await supabase.from('penalties').insert({
              user_id: profile.id,
              deal_id: deal.id,
              type: 'no_show',
              penalty_level: level,
              ban_type: level === 3 ? 'seeker' : null,
              ban_until: banUntil,
            });

            if(banUntil) {
              await supabase.from('users').update({ ban_take_until: banUntil }).eq('id', profile.id);
            }

            const msg = level === 1
              ? '⚠️ Λίστα 1 — Δεν εμφανίστηκες μετά την πληρωμή. Προσοχή!'
              : level === 2
              ? '⚠️ Λίστα 2 — 2η φορά no-show. Την επόμενη θα έχεις ban!'
              : '🚫 Ban Seeker 3 εβδομάδων — επαναλαμβανόμενο no-show.';

            await supabase.from('notifications').insert([
              { user_id: profile.id, type: 'penalty', message: msg, is_read: false },
              // Voucher 50% στον Giver ως αποζημίωση
              { user_id: deal.giver_id, type: 'compensation',
                message: '🎁 Ο Seeker δεν εμφανίστηκε. Λαμβάνεις 50% έκπτωση στο επόμενο deal.',
                is_read: false },
            ]);

            // Voucher 50% στον Giver
            await supabase.from('vouchers').insert({
              user_id: deal.giver_id,
              deal_id: deal.id,
              type: 'no_show_compensation',
              discount_percent: 50,
              is_used: false,
              expires_at: new Date(Date.now() + 90*24*60*60*1000).toISOString(),
              description: 'Αποζημίωση no-show Seeker — 50% έκπτωση στο επόμενο deal',
            });

            // Ενημέρωση UI — πήγαινε στην αρχική
            alert('⏰ Έληξε ο χρόνος αναμονής. Το deal ακυρώθηκε και έλαβες ποινή no-show.');
            if(onDone) onDone();

          } catch(e) { console.error("No-show penalty error:", e); }
        }, msLeft);

      } catch(e) { console.error("No-show timer setup error:", e); }
    };

    setupNoShowTimer();
    return () => { if(noShowTimer) clearTimeout(noShowTimer); };
  }, [matchedListing?.id]);

  // Χρονόμετρο 1:30
  useEffect(() => {
    if(!timerActive || timeLeft <= 0) return;
    const t = setTimeout(() => setTimeLeft(tl => tl - 1), 1000);
    return () => clearTimeout(t);
  }, [timerActive, timeLeft]);

  // Auto-complete όταν λήξει ο χρόνος
  useEffect(() => {
    if(timeLeft === 0 && timerActive && status === "waiting") {
      handleConfirm();
    }
  }, [timeLeft]);

  // ── Πρόωρη αναχώρηση Giver (πριν ο Seeker πατήσει "Έφτασα") ──────────────
  const handleEarlyDepartureFn = async (resolvedDealId) => {
    if(earlyDepartureLoading) return;
    setEarlyDepartureLoading(true);
    try {
      const { supabase } = await import("./supabase_client");
      const { data: authData } = await supabase.auth.getUser();
      const au = authData?.user;
      if(!au) return;
      const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
      if(!profile) return;

      // 1. Φόρτωσε το deal
      const id = resolvedDealId || dealId;
      if(!id) return;
      const { data: deal } = await supabase.from('deals')
        .select('id,price,giver_earn,company_earn,giver_id,seeker_id,listing_id,region,stripe_payment_intent_id')
        .eq('id', id).single();
      if(!deal) return;

      // 2. Ακύρωση deal
      await supabase.from('deals').update({
        status: 'cancelled_early_departure',
        cancelled_at: new Date().toISOString(),
      }).eq('id', id);

      // 3. Listing → inactive
      if(deal.listing_id) {
        await supabase.from('listings').update({ status: 'inactive' }).eq('id', deal.listing_id);
      }

      // 4. Stripe refund — αποθηκεύουμε flag στη βάση για manual refund αν χρειαστεί
      // Όταν η Edge Function υποστηρίξει refund, αυτό γίνεται αυτόματα
      try {
        const refundRes = await fetch(EDGE_FUNCTION_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
          },
          body: JSON.stringify({
            action: 'refund',
            payment_intent_id: deal.stripe_payment_intent_id || null,
            deal_id: id,
            amount: Math.round((deal.price || 0) * 100),
          }),
        });
        if(!refundRes.ok) throw new Error('Refund not supported yet');
      } catch(e) {
        // Edge function δεν υποστηρίζει refund ακόμα → αποθήκευση για manual processing
        console.warn("Auto-refund not available, flagging for manual refund:", e.message);
        await supabase.from('deals').update({ needs_refund: true }).eq('id', id);
      }

      // 5. Voucher "μηδενική προμήθεια εταιρίας" — ο Seeker βλέπει "50% έκπτωση"
      const voucherExpiry = new Date(Date.now() + 90*24*60*60*1000).toISOString();
      await supabase.from('vouchers').insert({
        user_id: profile.id,
        deal_id: id,
        type: 'early_departure_compensation',
        discount_percent: 50,
        is_used: false,
        expires_at: voucherExpiry,
        description: 'Αποζημίωση πρόωρης αναχώρησης — επόμενο deal χωρίς προμήθεια εταιρίας',
        // Αποθηκεύουμε το company_earn ώστε να ξέρουμε πόσο να αφαιρέσουμε
        metadata: JSON.stringify({ company_earn: deal.company_earn || 0 }),
      });

      // 6. Τιμωρία Giver
      if(deal.giver_id) {
        const twoWeeksAgo = new Date(Date.now()-14*24*60*60*1000).toISOString();
        const { data: recent } = await supabase.from('penalties')
          .select('id').eq('user_id', deal.giver_id).gte('created_at', twoWeeksAgo);
        const level = Math.min((recent?.length||0)+1, 3);
        const banUntil = level===3 ? new Date(Date.now()+21*24*60*60*1000).toISOString() : null;
        await supabase.from('penalties').insert({
          user_id: deal.giver_id, deal_id: id,
          type: 'early_departure',
          penalty_level: level,
          ban_type: level===3?'giver':null,
          ban_until: banUntil,
        });
        if(banUntil) await supabase.from('users').update({ ban_give_until: banUntil }).eq('id', deal.giver_id);
        const penaltyMsg = level===1
          ? '⚠️ Λίστα 1 — Αναχώρησες πριν φτάσει ο Seeker. Προσοχή!'
          : level===2
          ? '⚠️ Λίστα 2 — 2η πρόωρη αναχώρηση. Την επόμενη θα έχεις ban!'
          : `🚫 Ban Giver 3 εβδομάδων — επαναλαμβανόμενη πρόωρη αναχώρηση.`;
        await supabase.from('notifications').insert({
          user_id: deal.giver_id, type: 'penalty', message: penaltyMsg, is_read: false,
        });
      }

      // 7. Notification στον Seeker
      await supabase.from('notifications').insert({
        user_id: profile.id, type: 'compensation',
        message: '🎁 Ο Giver αναχώρησε πριν φτάσεις. Τα χρήματά σου επιστρέφουν και έχεις 50% έκπτωση στο επόμενο deal!',
        is_read: false,
      });

      // 8. Αναζήτηση εναλλακτικής θέσης (ίδια περιοχή, εξαιρώ το τρέχον listing)
      const { data: altListings } = await supabase.from('listings')
        .select('*')
        .eq('region', deal.region || region)
        .eq('status', 'active')
        .gt('expires_at', new Date().toISOString())
        .neq('id', deal.listing_id || '')
        .order('created_at', { ascending: false })
        .limit(1);

      if(altListings && altListings.length > 0) {
        const alt = altListings[0];
        setAltListing(alt);
        // Υπολογισμός πεζής απόστασης αν έχουμε myPos και διεύθυνση
        if(myPos && alt.address && window.google?.maps) {
          try {
            const ds = new window.google.maps.DirectionsService();
            ds.route({
              origin: { lat: myPos.lat, lng: myPos.lng },
              destination: `${alt.address}, ${alt.region || region}, Αθήνα`,
              travelMode: window.google.maps.TravelMode.WALKING,
            }, (result, status) => {
              if(status === 'OK') {
                const secs = result.routes[0]?.legs[0]?.duration?.value || 0;
                setAltWalkMins(Math.max(1, Math.ceil(secs/60)));
              } else {
                setAltWalkMins(5); // fallback
              }
            });
          } catch(e) { setAltWalkMins(5); }
        }
      }
      setAltSearchDone(true);

    } catch(e) { console.error("Early departure handler error:", e); }
    setEarlyDepartureLoading(false);
  };

  // Αποδοχή εναλλακτικής θέσης — δημιουργεί νέο deal με voucher (χωρίς προμήθεια εταιρίας)
  const handleAcceptAlt = async () => {
    if(!altListing || altAccepting) return;
    setAltAccepting(true);
    try {
      const { supabase } = await import("./supabase_client");
      const { data: authData } = await supabase.auth.getUser();
      const au = authData?.user;
      if(!au) return;
      const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
      if(!profile) return;

      // Βρες το voucher early_departure_compensation
      const { data: voucher } = await supabase.from('vouchers')
        .select('id,metadata')
        .eq('user_id', profile.id)
        .eq('type', 'early_departure_compensation')
        .eq('is_used', false)
        .order('created_at', {ascending: false})
        .limit(1).maybeSingle();

      // Τιμή με έκπτωση = giver_earn μόνο (χωρίς company_earn)
      const discountedPrice = altListing.giver_earn || (altListing.price * 0.5);

      // Δημιουργία νέου deal
      const { data: newDeal, error } = await supabase.from('deals').insert({
        listing_id: altListing.id,
        giver_id: altListing.giver_id,
        seeker_id: profile.id,
        region: altListing.region,
        price: discountedPrice,           // τιμή με έκπτωση
        giver_earn: altListing.giver_earn,
        company_earn: 0,                   // μηδενική προμήθεια εταιρίας
        status: 'matched',
        used_voucher: voucher?.id || null,
      }).select().single();

      if(error) throw error;

      // Ενημέρωση listing → matched
      await supabase.from('listings').update({ status: 'matched' }).eq('id', altListing.id);

      // Σημείωσε το voucher ως χρησιμοποιημένο
      if(voucher?.id) {
        await supabase.from('vouchers').update({ is_used: true, used_at: new Date().toISOString() }).eq('id', voucher.id);
      }

      setAltDealCreated(true);
      // Μετά από 2 δευτερόλεπτα → αρχική (το deal θα ανοίξει από το banner)
      setTimeout(() => onDone(), 2000);

    } catch(e) {
      console.error("handleAcceptAlt error:", e);
      setAltAccepting(false);
    }
  };

  const getDealId = async (supabase) => {
    if(dealId) return dealId;
    if(!matchedListing?.id) return null;
    const { data: { user: au } } = await supabase.auth.getUser();
    if(!au) return null;
    const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
    if(!profile) return null;
    const { data: deal } = await supabase.from('deals').select('id')
      .eq('listing_id', matchedListing.id).eq('seeker_id', profile.id).maybeSingle();
    return deal?.id || null;
  };

  const handleConfirm = async () => {
    setStatus("confirmed");
    try {
      const { supabase } = await import("./supabase_client");
      const id = await getDealId(supabase);
      if(!id) { setTimeout(onDone, 2000); return; }

      // 1. Ολοκλήρωση deal
      const { data: deal } = await supabase
        .from('deals').select('id,price,giver_earn,giver_id,seeker_id,stripe_payment_intent_id')
        .eq('id', id).single();

      await supabase.from('deals').update({
        status: 'completed',
        completed_at: new Date().toISOString(),
        giver_lat: null, giver_lng: null,
        seeker_lat: null, seeker_lng: null
      }).eq('id', id);

      // 2. Stripe capture — χρέωση κάρτας τώρα που επιβεβαιώθηκε
      if(deal?.stripe_payment_intent_id) {
        try {
          await fetch(EDGE_FUNCTION_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'apikey': SUPABASE_ANON_KEY,
              'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
            },
            body: JSON.stringify({
              action: 'capture',
              payment_intent_id: deal.stripe_payment_intent_id,
              deal_id: id,
            }),
          });
        } catch(e) { console.error("Capture error:", e); }
      }

      // 3. Wallet update Giver — πίστωση
      if(deal?.giver_id && deal?.giver_earn) {
        const { data: gWallet } = await supabase
          .from('wallets').select('id,balance').eq('user_id', deal.giver_id).maybeSingle();
        if(gWallet) {
          await supabase.from('wallets')
            .update({ balance: (gWallet.balance || 0) + deal.giver_earn })
            .eq('id', gWallet.id);
        } else {
          await supabase.from('wallets').insert({ user_id: deal.giver_id, balance: deal.giver_earn });
        }
        await supabase.from('transactions').insert({
          user_id: deal.giver_id,
          deal_id: id,
          type: 'earn',
          amount: deal.giver_earn,
          description: `Κέρδος από deal #${id.slice(-6)}`
        });
      }

      // 4. Transaction log Seeker — χρέωση
      if(deal?.seeker_id && deal?.price) {
        await supabase.from('transactions').insert({
          user_id: deal.seeker_id,
          deal_id: id,
          type: 'payment',
          amount: deal.price,
          description: `Πληρωμή για deal #${id.slice(-6)}`
        });
      }
    } catch(e) { console.error("Confirm error:", e); }
    setTimeout(onDone, 2000);
  };

  const [giverGPS, setGiverGPS] = useState(null);
  const [giverDisputing, setGiverDisputing] = useState(false);
  const [reportTimer, setReportTimer] = useState(30*60);
  const [reportChecking, setReportChecking] = useState(false);

  // Seeker επιβεβαιώνει ότι ο Giver αναχώρησε
  const handleConfirmGiverLeft = async () => {
    await handleConfirm();
  };

  // Seeker λέει ότι ο Giver ΔΕΝ έχει φύγει
  const handleDisputeGiverLeft = async () => {
    setGiverDisputing(true);
    try {
      const { supabase } = await import("./supabase_client");
      const id = await getDealId(supabase);
      if(!id) return;

      const { data: deal } = await supabase.from('deals')
        .select('giver_id,giver_lat,giver_lng,listing_id')
        .eq('id', id).single();

      if(!deal) return;

      // GPS έλεγχος — αν ο Giver έχει απομακρυνθεί >20μ από τη θέση
      let giverHasLeft = false;
      if(deal.giver_lat && deal.giver_lng && destPos && window.google?.maps?.geometry) {
        const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
          new window.google.maps.LatLng(deal.giver_lat, deal.giver_lng),
          new window.google.maps.LatLng(destPos.lat, destPos.lng)
        );
        giverHasLeft = dist > 20;
      }

      if(giverHasLeft) {
        // Ο Giver έχει φύγει — ολοκλήρωση
        await handleConfirm();
      } else {
        // Ο Giver ΔΕΝ έχει φύγει — ειδοποίηση + προειδοποίηση
        await supabase.from('deals').update({ status: 'giver_warned' }).eq('id', id);
        await supabase.from('notifications').insert({
          user_id: deal.giver_id, type: 'warning',
          message: '⚠️ Ο Seeker αναφέρει ότι δεν έχεις φύγει! Αναχώρησε άμεσα ή θα λάβεις ποινή.',
          is_read: false
        });

        // Περίμενε 5 λεπτά — αν δεν φύγει, τιμωρία
        setTimeout(async () => {
          const { data: updatedDeal } = await supabase.from('deals')
            .select('giver_lat,giver_lng,status').eq('id', id).single();

          let stillThere = true;
          if(updatedDeal?.giver_lat && destPos && window.google?.maps?.geometry) {
            const d2 = window.google.maps.geometry.spherical.computeDistanceBetween(
              new window.google.maps.LatLng(updatedDeal.giver_lat, updatedDeal.giver_lng),
              new window.google.maps.LatLng(destPos.lat, destPos.lng)
            );
            stillThere = d2 <= 20;
          }

          if(stillThere && updatedDeal?.status !== 'completed') {
            // Τιμωρία Giver
            const twoWeeksAgo = new Date(Date.now()-14*24*60*60*1000).toISOString();
            const { data: recent } = await supabase.from('penalties')
              .select('id').eq('user_id', deal.giver_id).gte('created_at', twoWeeksAgo);
            const level = Math.min((recent?.length||0)+1, 3);
            const banUntil = level===3 ? new Date(Date.now()+21*24*60*60*1000).toISOString() : null;
            await supabase.from('penalties').insert({
              user_id: deal.giver_id, deal_id: id, type: 'refused_to_leave',
              penalty_level: level, ban_type: level===3?'giver':null, ban_until: banUntil
            });
            if(banUntil) await supabase.from('users').update({ban_give_until: banUntil}).eq('id', deal.giver_id);

            // Voucher 50% στον Seeker
            const { data: authData } = await supabase.auth.getUser();
            if(authData?.user) {
              const { data: sp } = await supabase.from('users').select('id').eq('auth_id', authData.user.id).single();
              if(sp) await supabase.from('vouchers').insert({
                user_id: sp.id, deal_id: id, type: 'giver_refused_compensation',
                discount_percent: 50, is_used: false,
                expires_at: new Date(Date.now()+90*24*60*60*1000).toISOString(),
                description: 'Αποζημίωση — ο Giver αρνήθηκε να αναχωρήσει'
              });
            }
            await supabase.from('deals').update({ status: 'cancelled_by_giver' }).eq('id', id);
            setGiverDisputing(false);
            setStatus("reported");
          } else {
            // Ο Giver τελικά έφυγε
            await handleConfirm();
          }
        }, 5*60*1000); // 5 λεπτά
      }
    } catch(e) { console.error("disputeGiverLeft error:", e); setGiverDisputing(false); }
  };

  const handleReport = async () => {
    setStatus("reported");
    setReportChecking(true);
    let resolvedDealId = null;
    try {
      const { supabase } = await import("./supabase_client");
      const id = await getDealId(supabase);
      if(!id) return;
      resolvedDealId = id;
      await supabase.from('deals').update({ status: 'disputed', disputed_at: new Date().toISOString() }).eq('id', id);

      // GPS έλεγχος κάθε 30 δευτερόλεπτα για 30 λεπτά
      const THRESHOLD = 20; // μέτρα
      const endTime = Date.now() + 30*60*1000;
      let resolved = false;

      const checkInterval = setInterval(async () => {
        if(resolved || Date.now() > endTime) {
          clearInterval(checkInterval);
          if(!resolved) {
            // Τέλος 30 λεπτών — ο Seeker δεν παρκάρισε
            // Voucher στον Seeker
            const { data: authData } = await supabase.auth.getUser();
            if(authData?.user) {
              const { data: profile } = await supabase.from('users').select('id').eq('auth_id', authData.user.id).single();
              if(profile) {
                await supabase.from('vouchers').insert({
                  user_id: profile.id, deal_id: id, type: 'dispute_compensation',
                  discount_percent: 50, is_used: false,
                  expires_at: new Date(Date.now()+90*24*60*60*1000).toISOString(),
                  description: 'Αποζημίωση αναφοράς — 50% έκπτωση στο επόμενο deal'
                });
              }
            }
            // Τιμωρία Giver
            const { data: deal } = await supabase.from('deals').select('giver_id').eq('id', id).single();
            if(deal?.giver_id) {
              const twoWeeksAgo = new Date(Date.now()-14*24*60*60*1000).toISOString();
              const { data: recentCancels } = await supabase.from('deals')
                .select('id').eq('giver_id', deal.giver_id)
                .in('status',['cancelled_by_giver','disputed']).gte('updated_at', twoWeeksAgo);
              const level = Math.min((recentCancels?.length||0)+1, 3);
              const banUntil = level===3 ? new Date(Date.now()+21*24*60*60*1000).toISOString() : null;
              await supabase.from('penalties').insert({
                user_id: deal.giver_id, deal_id: id, type: 'dispute_as_giver',
                penalty_level: level, ban_type: level===3?'giver':null, ban_until: banUntil
              });
              if(banUntil) await supabase.from('users').update({ban_give_until: banUntil}).eq('id', deal.giver_id);
              await supabase.from('notifications').insert({
                user_id: deal.giver_id, type: 'penalty',
                message: level===3?'🚫 Ban Giver 3 εβδομάδων λόγω αναφοράς!': `⚠️ Λίστα ${level} — αναφορά από Seeker.`,
                is_read: false
              });
            }
            setReportChecking(false);
          }
          return;
        }

        // Ελέγχεται αν το GPS του Seeker ταυτίζεται με τη θέση (<20μ)
        if(myPos && destPos && window.google?.maps?.geometry) {
          const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
            new window.google.maps.LatLng(myPos.lat, myPos.lng),
            new window.google.maps.LatLng(destPos.lat, destPos.lng)
          );
          if(dist <= THRESHOLD) {
            resolved = true;
            clearInterval(checkInterval);
            await supabase.from('deals').update({ status:'completed', completed_at: new Date().toISOString() }).eq('id', id);
            setStatus("confirmed");
            setReportChecking(false);
          }
        }

        // Countdown
        setReportTimer(t => Math.max(0, t-30));
      }, 30000);

    } catch(e) { console.error("handleReport error:", e); }
  };

  const mins = Math.floor(timeLeft/60);
  const secs = String(timeLeft%60).padStart(2,'0');
  const timerColor = timeLeft <= 30 ? "#EF4444" : timeLeft <= 60 ? "#F59E0B" : C.accent;

  if(status === "confirmed" || status === "completed") return (
    <div style={{textAlign:"center",padding:30}}>
      <div style={{fontSize:64,marginBottom:16}}>🎉</div>
      <div style={{color:C.accent,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:22,marginBottom:8}}>Ολοκληρώθηκε!</div>
      <div style={{color:C.muted,fontSize:13}}>Το deal καταχωρήθηκε. Καλή σταθμευση!</div>
    </div>
  );

  if(status === "reported") {
    const rMins = Math.floor(reportTimer/60);
    const rSecs = String(reportTimer%60).padStart(2,'0');
    return (
      <div style={{padding:20}}>
        <div style={{textAlign:"center",marginBottom:20}}>
          <div style={{fontSize:56,marginBottom:12}}>🔍</div>
          <div style={{color:C.warn,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:18,marginBottom:8}}>Αναφορά σε Εξέλιξη</div>
          <div style={{color:C.muted,fontSize:13,lineHeight:1.6,marginBottom:16}}>
            Ελέγχουμε αυτόματα αν το GPS σου ταυτιστεί με τη θέση εντός 30 λεπτών.
          </div>
        </div>

        {/* Countdown */}
        <div style={{background:"rgba(245,158,11,0.08)",border:"1px solid rgba(245,158,11,0.3)",borderRadius:14,padding:20,textAlign:"center",marginBottom:16}}>
          <div style={{color:C.muted,fontSize:12,marginBottom:8}}>Χρόνος ελέγχου</div>
          <div style={{color:C.warn,fontFamily:"'Syne',sans-serif",fontWeight:900,fontSize:40}}>{rMins}:{rSecs}</div>
          {reportChecking && <div style={{color:C.muted,fontSize:11,marginTop:8}}>⏳ Ελέγχεται η τοποθεσία σου...</div>}
        </div>

        <div style={{background:"rgba(0,212,170,0.06)",border:`1px solid ${C.accent}22`,borderRadius:12,padding:14}}>
          <div style={{color:C.muted,fontSize:12,lineHeight:1.7}}>
            ✅ <b style={{color:C.text}}>Αν παρκάρεις στη θέση</b> — το deal ολοκληρώνεται αυτόματα<br/>
            ❌ <b style={{color:C.text}}>Αν δεν παρκάρεις</b> — λαμβάνεις 50% έκπτωση και ο Giver τιμωρείται
          </div>
        </div>
      </div>
    );
  }

  const handleSeekerReady = async () => {
    setSeekerReady(true);
    setSpotChoice('choosing'); // Δείχνουμε επιλογές αποδοχή/αναφορά
    try {
      const { supabase } = await import("./supabase_client");
      let id = dealId;
      if(!id) {
        const { data: { user: au } } = await supabase.auth.getUser();
        if(!au) return;
        const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
        if(!profile) return;
        const { data: deal } = await supabase
          .from('deals').select('id')
          .eq('seeker_id', profile.id)
          .in('status', ['matched','seeker_ready'])
          .order('created_at', {ascending: false})
          .limit(1).maybeSingle();
        id = deal?.id;
      }
      if(id) {
        const { error } = await supabase.from('deals').update({ status: 'seeker_ready' }).eq('id', id);
        if(error) console.error("seeker_ready update error:", error);
        else { setDealId(id); }
      }
    } catch(e) { console.error("handleSeekerReady error:", e); }
  };

  // Αποδοχή θέσης — ειδοποίηση Giver να βγει
  const handleAcceptSpot = async () => {
    setSpotChoice('accepted');
    try {
      const { supabase } = await import("./supabase_client");
      const id = dealId || await getDealId(supabase);
      if(!id) return;
      // Ειδοποίηση στον Giver
      const { data: deal } = await supabase.from('deals').select('giver_id').eq('id', id).single();
      if(deal?.giver_id) {
        await supabase.from('notifications').insert({
          user_id: deal.giver_id, type: 'spot_accepted',
          message: '🚗 Ο Seeker έφτασε και αποδέχεται τη θέση! Βγες τώρα.',
          is_read: false
        });
        // Update deal status
        await supabase.from('deals').update({ status: 'spot_accepted' }).eq('id', id);
      }
    } catch(e) { console.error(e); }
  };

  // Αναφορά παράνομης θέσης
  const handleReportSpot = async () => {
    setSpotReportDone(true);
    try {
      const { supabase } = await import("./supabase_client");
      const id = dealId || await getDealId(supabase);
      if(!id) return;

      // Βρες seeker + giver
      const { data: authData } = await supabase.auth.getUser();
      const { data: profile } = await supabase.from('users').select('id').eq('auth_id', authData.user.id).single();
      const { data: deal } = await supabase.from('deals').select('giver_id').eq('id', id).single();

      // Ακύρωση deal
      await supabase.from('deals').update({ status: 'cancelled_illegal_spot' }).eq('id', id);

      // Voucher 50% στον Seeker
      await supabase.from('vouchers').insert({
        user_id: profile.id, deal_id: id, type: 'illegal_spot_compensation',
        discount_percent: 50, is_used: false,
        expires_at: new Date(Date.now()+90*24*60*60*1000).toISOString(),
        description: 'Αποζημίωση παράνομης θέσης — 50% έκπτωση στο επόμενο deal'
      });

      // Τιμωρία Giver
      if(deal?.giver_id) {
        const twoWeeksAgo = new Date(Date.now()-14*24*60*60*1000).toISOString();
        const { data: recent } = await supabase.from('penalties')
          .select('id').eq('user_id', deal.giver_id).gte('created_at', twoWeeksAgo);
        const level = Math.min((recent?.length||0)+1, 3);
        const banUntil = level===3 ? new Date(Date.now()+21*24*60*60*1000).toISOString() : null;
        await supabase.from('penalties').insert({
          user_id: deal.giver_id, deal_id: id, type: 'illegal_spot',
          penalty_level: level, ban_type: level===3?'giver':null, ban_until: banUntil
        });
        if(banUntil) await supabase.from('users').update({ban_give_until: banUntil}).eq('id', deal.giver_id);
        await supabase.from('notifications').insert({
          user_id: deal.giver_id, type: 'penalty',
          message: level===3?'🚫 Ban Giver 3 εβδομάδων — αναφορά παράνομης θέσης!':
            `⚠️ Λίστα ${level} — ο Seeker ανέφερε παράνομη θέση.`,
          is_read: false
        });
      }
    } catch(e) { console.error(e); }
  };

  return (
    <div>
      {/* ── Πρόωρη αναχώρηση Giver ── */}
      {earlyDeparture && (
        <div style={{background:C.bg,minHeight:"100%",padding:24}}>
          {earlyDepartureLoading ? (
            <div style={{textAlign:"center",paddingTop:60}}>
              <div style={{fontSize:48,marginBottom:16}}>⏳</div>
              <div style={{color:C.text,fontWeight:800,fontSize:17,marginBottom:8}}>Επεξεργασία...</div>
              <div style={{color:C.muted,fontSize:13}}>Ακυρώνουμε το deal και επιστρέφουμε τα χρήματά σου.</div>
            </div>
          ) : (
            <>
              {/* Header */}
              <div style={{textAlign:"center",marginBottom:24}}>
                <div style={{fontSize:52,marginBottom:12}}>😔</div>
                <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:20,marginBottom:8}}>
                  Ο Giver έφυγε νωρίς
                </div>
                <div style={{color:C.muted,fontSize:13,lineHeight:1.6}}>
                  Αναχώρησε πριν φτάσεις. Το deal ακυρώθηκε αυτόματα και ο Giver έλαβε ποινή.
                </div>
              </div>

              {/* Refund card */}
              <div style={{background:"rgba(0,212,170,0.08)",border:`1px solid ${C.accent}44`,borderRadius:16,padding:16,marginBottom:14}}>
                <div style={{color:C.accent,fontWeight:800,fontSize:14,marginBottom:6}}>💳 Επιστροφή χρημάτων</div>
                <div style={{color:C.muted,fontSize:12,lineHeight:1.6}}>
                  Τα χρήματα που πλήρωσες επιστρέφουν αυτόματα στην κάρτα σου εντός 3-5 εργάσιμων ημερών.
                </div>
              </div>

              {/* Voucher card */}
              <div style={{background:"rgba(168,85,247,0.08)",border:"1px solid rgba(168,85,247,0.3)",borderRadius:16,padding:16,marginBottom:20}}>
                <div style={{color:"#A855F7",fontWeight:800,fontSize:14,marginBottom:6}}>🎁 Έκπτωση 50% στο επόμενο deal</div>
                <div style={{color:C.muted,fontSize:12,lineHeight:1.6}}>
                  Ως αποζημίωση, το επόμενο deal σου έχει <b style={{color:C.text}}>50% έκπτωση</b>. Ισχύει για 90 ημέρες.
                </div>
              </div>

              {/* Εναλλακτική θέση */}
              {!altSearchDone ? (
                <div style={{textAlign:"center",color:C.muted,fontSize:13,padding:16}}>🔍 Ψάχνουμε κοντινή θέση...</div>
              ) : altListing ? (
                <div style={{background:C.card,border:`2px solid rgba(0,153,255,0.3)`,borderRadius:16,padding:16,marginBottom:16}}>
                  <div style={{color:"#0099FF",fontWeight:800,fontSize:14,marginBottom:10}}>📍 Βρήκαμε κοντινή θέση!</div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                    <span style={{color:C.text,fontWeight:700,fontSize:13}}>{altListing.region}</span>
                    <div style={{textAlign:"right"}}>
                      <span style={{color:C.muted,fontSize:11,textDecoration:"line-through",marginRight:6}}>€{altListing.price?.toFixed(2)}</span>
                      <span style={{color:"#0099FF",fontWeight:800,fontSize:15}}>€{(altListing.giver_earn || altListing.price*0.5)?.toFixed(2)}</span>
                    </div>
                  </div>
                  <div style={{background:"rgba(168,85,247,0.08)",borderRadius:8,padding:"4px 10px",marginBottom:8,display:"inline-block"}}>
                    <span style={{color:"#A855F7",fontSize:11,fontWeight:700}}>🎁 Εφαρμόζεται 50% έκπτωση</span>
                  </div>
                  {altListing.address && (
                    <div style={{color:C.muted,fontSize:11,marginBottom:8}}>📌 {altListing.address}</div>
                  )}
                  {altWalkMins && (
                    <div style={{background:"rgba(0,153,255,0.08)",borderRadius:8,padding:"6px 10px",marginBottom:12,display:"inline-block"}}>
                      <span style={{color:"#0099FF",fontSize:12,fontWeight:700}}>🚶 ~{altWalkMins} λεπτά πεζή από εσένα</span>
                    </div>
                  )}
                  {altDealCreated ? (
                    <div style={{textAlign:"center",padding:"10px 0"}}>
                      <div style={{color:C.accent,fontWeight:800,fontSize:14}}>✅ Deal δημιουργήθηκε!</div>
                      <div style={{color:C.muted,fontSize:11,marginTop:4}}>Μεταφορά στην αρχική...</div>
                    </div>
                  ) : (
                    <div style={{display:"flex",gap:10}}>
                      <button
                        onClick={()=>onDone()}
                        style={{flex:1,padding:"12px",borderRadius:12,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,cursor:"pointer",fontWeight:700,fontSize:13}}
                      >Όχι ευχαριστώ</button>
                      <button
                        onClick={handleAcceptAlt}
                        disabled={altAccepting}
                        style={{flex:2,padding:"12px",borderRadius:12,border:"none",background:altAccepting?"#2a3550":"linear-gradient(135deg,#0099FF,#1A2EAA)",color:"#fff",cursor:altAccepting?"not-allowed":"pointer",fontWeight:700,fontSize:13,boxShadow:"0 4px 16px rgba(0,153,255,0.3)"}}
                      >{altAccepting ? "⏳ Δημιουργία deal..." : "✅ Πάμε εκεί!"}</button>
                    </div>
                  )}
                </div>
              ) : (
                <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:16,padding:20,marginBottom:16,textAlign:"center"}}>
                  <div style={{fontSize:36,marginBottom:10}}>🔍</div>
                  <div style={{color:C.text,fontWeight:700,fontSize:14,marginBottom:8}}>Δεν βρέθηκε κοντινή θέση</div>
                  <div style={{color:C.muted,fontSize:12,marginBottom:16}}>Δεν υπάρχει διαθέσιμη θέση στο {region} αυτή τη στιγμή.</div>
                  <button
                    onClick={()=>onDone({ newSearch: true })}
                    style={{width:"100%",padding:"12px",borderRadius:12,border:"none",background:`linear-gradient(135deg,${C.accent},#1A2EAA)`,color:"#fff",cursor:"pointer",fontWeight:700,fontSize:13}}
                  >🔄 Νέα αναζήτηση</button>
                </div>
              )}

              <button
                onClick={()=>onDone()}
                style={{width:"100%",padding:"12px",borderRadius:12,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,cursor:"pointer",fontWeight:600,fontSize:13,marginTop:4}}
              >Επιστροφή στην αρχική</button>
            </>
          )}
        </div>
      )}

      {!earlyDeparture && !giverDeparted ? (
        <GoogleMapView
          destination={destPos}
          myPos={myPos}
          otherPos={otherPos}
          role="seeker"
          showOther={revealed}
          dealAddress={dealAddress}
          revealed={revealed}
          otherVehicle={otherVehicle}
          onHome={onDone}
          onCancel={onDone}
        >
          {!seekerReady ? (
            <button onClick={handleSeekerReady} style={{background:"#0099FF",color:"#fff",border:"none",borderRadius:12,padding:"14px",fontWeight:800,fontSize:15,cursor:"pointer",width:"100%"}}>
              📍 Έφτασα, είμαι έτοιμος!
            </button>
          ) : spotChoice === 'choosing' ? (
            <div>
              <div style={{color:"#fff",fontWeight:800,fontSize:14,marginBottom:12,textAlign:"center"}}>Πώς είναι η θέση;</div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={handleReportSpot} style={{flex:1,background:"rgba(239,68,68,0.2)",border:"1px solid rgba(239,68,68,0.5)",borderRadius:12,padding:"12px 8px",color:"#EF4444",fontWeight:800,fontSize:13,cursor:"pointer"}}>
                  🚫 Αναφορά Θέσης
                </button>
                <button onClick={handleAcceptSpot} style={{flex:1,background:C.accent,border:"none",borderRadius:12,padding:"12px 8px",color:"#fff",fontWeight:800,fontSize:13,cursor:"pointer"}}>
                  ✅ Αποδοχή Θέσης
                </button>
              </div>
            </div>
          ) : spotReportDone ? (
            <div style={{textAlign:"center"}}>
              <div style={{color:"#EF4444",fontWeight:800,fontSize:14,marginBottom:6}}>🚫 Αναφορά Υποβλήθηκε</div>
              <div style={{color:"rgba(255,255,255,0.7)",fontSize:12,lineHeight:1.5}}>Απομακρύνσου &gt;50μ από τη θέση για να λάβεις 50% έκπτωση. Ο Giver τιμωρήθηκε.</div>
            </div>
          ) : spotChoice === 'accepted' ? (
            <div style={{textAlign:"center"}}>
              <div style={{color:C.accent,fontWeight:800,fontSize:14,marginBottom:4}}>✅ Ειδοποιήθηκε ο Giver να βγει</div>
              <div style={{color:"rgba(255,255,255,0.7)",fontSize:12}}>Αναμένεις αναχώρηση...</div>
            </div>
          ) : (
            <div style={{textAlign:"center"}}>
              <div style={{color:C.accent,fontWeight:700,fontSize:14,marginBottom:4}}>✅ Ειδοποιήθηκε ο Giver</div>
              <div style={{color:"rgba(255,255,255,0.7)",fontSize:12}}>Αναμένεις αναχώρηση...</div>
            </div>
          )}
        </GoogleMapView>
      ) : !earlyDeparture && giverDeparted ? (
        <GoogleMapView
          destination={destPos}
          myPos={myPos}
          otherPos={otherPos}
          role="seeker"
          showOther={revealed}
          dealAddress={dealAddress}
          revealed={revealed}
          otherVehicle={otherVehicle}
          onHome={onDone}
          onCancel={onDone}
        >
          {giverDeparted && !giverDisputing && (
            <div>
              <div style={{color:"#fff",fontWeight:800,fontSize:14,marginBottom:12,textAlign:"center"}}>
                🚗 Ο Giver αναχώρησε — Επιβεβαίωση;
              </div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={handleDisputeGiverLeft} style={{flex:1,background:"rgba(239,68,68,0.2)",border:"1px solid rgba(239,68,68,0.5)",borderRadius:12,padding:"12px 8px",color:"#EF4444",fontWeight:800,fontSize:13,cursor:"pointer"}}>
                  ❌ Δεν έχει φύγει
                </button>
                <button onClick={handleConfirmGiverLeft} style={{flex:1,background:C.accent,border:"none",borderRadius:12,padding:"12px 8px",color:"#fff",fontWeight:800,fontSize:13,cursor:"pointer"}}>
                  ✅ Επιβεβαιώνω
                </button>
              </div>
            </div>
          )}
          {giverDisputing && (
            <div style={{textAlign:"center"}}>
              <div style={{color:"#F59E0B",fontWeight:800,fontSize:13,marginBottom:4}}>⏳ Έλεγχος GPS Giver...</div>
              <div style={{color:"rgba(255,255,255,0.7)",fontSize:12}}>Αν δεν έχει φύγει, θα λάβει ειδοποίηση και έχει 5 λεπτά να αναχωρήσει.</div>
            </div>
          )}
          {!giverDeparted && (
            <div style={{display:"flex",gap:10}}>
              <button onClick={handleReport} style={{flex:1,background:"rgba(239,68,68,0.15)",border:"1px solid rgba(239,68,68,0.4)",borderRadius:12,padding:14,color:"#EF4444",fontWeight:800,fontSize:13,cursor:"pointer"}}>
                ⚠️ Αναφορά Προβλήματος
              </button>
            </div>
          )}
        </GoogleMapView>
      ) : null}
    </div>
  );
}

// ─── SETTINGS SCREEN ──────────────────────────────────────────────────────────
function SettingsScreen({onBack,darkMode,setDarkMode,notifications,setNotifications,user,onLogout}){
  const T=useT(darkMode);
  const Toggle=({value,onChange})=><div onClick={()=>onChange(!value)} style={{width:44,height:24,borderRadius:12,background:value?C.accent:C.border,position:"relative",cursor:"pointer",transition:"all 0.2s"}}><div style={{position:"absolute",top:2,left:value?22:2,width:20,height:20,borderRadius:10,background:"#fff",transition:"all 0.2s"}}/></div>;
  return (
    <div style={{background:T.bg,minHeight:"100%"}}>
      <TopBar title="Ρυθμίσεις" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:20}}>
        <Card style={{marginBottom:16}}><div style={{color:T.text,fontWeight:800,marginBottom:14}}>Εμφάνιση</div><div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><div style={{color:T.text,fontWeight:600}}>Dark Mode</div><div style={{color:C.muted,fontSize:12}}>Σκοτεινό θέμα</div></div><Toggle value={darkMode} onChange={setDarkMode}/></div></Card>
        <Card style={{marginBottom:16}}><div style={{color:T.text,fontWeight:800,marginBottom:14}}>Ειδοποιήσεις</div>
          {[{key:"deals",label:"Deal Alerts"},{key:"security",label:"Ειδοποιήσεις Ασφαλείας",desc:"Απόπειρες σύνδεσης"},{key:"reminders",label:"Υπενθυμίσεις"}].map(n=>(
            <div key={n.key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div><div style={{color:T.text,fontWeight:600}}>{n.label}</div>{n.desc&&<div style={{color:C.muted,fontSize:11}}>{n.desc}</div>}</div>
              <Toggle value={notifications[n.key]!==false} onChange={v=>setNotifications({...notifications,[n.key]:v})}/>
            </div>
          ))}
        </Card>
        <Card style={{marginBottom:16}}>
          <div style={{color:T.text,fontWeight:800,marginBottom:14}}>Λογαριασμός & Ασφάλεια</div>
          <div style={{color:C.muted,fontSize:13,marginBottom:12}}>Username: <span style={{color:T.text,fontWeight:700}}>@{user.username}</span></div>
          <Btn variant="ghost" style={{width:"100%",marginBottom:10}}>Αλλαγή Username</Btn>
          <Btn variant="ghost" style={{width:"100%",marginBottom:10}}>Αλλαγή Κωδικού</Btn>
          <Btn variant="ghost" style={{width:"100%",color:"#EF4444",borderColor:"rgba(239,68,68,0.3)"}} onClick={onLogout}>🚪 Αποσύνδεση</Btn>
        </Card>
        <Card>
          <div style={{color:T.text,fontWeight:800,marginBottom:8}}>Κατάσταση Ποινών</div>
          <Badge color={C.accent}>Καθαρό Ιστορικό 🟢</Badge>
          <div style={{color:C.muted,fontSize:11,marginTop:8}}>3 παραβάσεις σε 2 εβδομάδες = αποκλεισμός 3 εβδομάδων.</div>
        </Card>
      </div>
    </div>
  );
}

const TOPARKING_SYSTEM_PROMPT = `Είσαι ο βοηθός υποστήριξης της ToParking, μιας εφαρμογής εύρεσης parking στην Αθήνα.

ΚΑΝΟΝΕΣ:
1. Απαντάς ΜΟΝΟ σε θέματα που αφορούν την ToParking (deals, οχήματα, πληρωμές, τιμωρίες, περιοχές, λογαριασμός)
2. ΔΕΝ αποκαλύπτεις πληροφορίες για την εταιρία, τον κώδικα, ή εσωτερικές διαδικασίες
3. ΔΕΝ κάνεις οτιδήποτε που μπορεί να βλάψει την εταιρία ή τους χρήστες
4. Αν κάποιος ρωτήσει κάτι άσχετο ή ευαίσθητο, απάντα: "Αυτό το θέμα το χειρίζεται η ομάδα υποστήριξής μας. Το αίτημά σου καταγράφηκε."
5. Απαντάς στα Ελληνικά, φιλικά και σύντομα
6. ΔΕΝ αναφέρεις τιμές, ποσοστά ή οικονομικά στοιχεία της εταιρίας

ΓΝΩΣΕΙΣ ΓΙΑ PAYPARK:
- Η ToParking είναι marketplace parking στην Αθήνα
- Giver: χρήστης που δίνει τη θέση του όταν φεύγει
- Seeker: χρήστης που αναζητά θέση parking
- Deals: συμφωνίες μεταξύ Giver και Seeker
- Αγγελίες λήγουν σε 15 λεπτά αν δεν γίνει match
- Σύστημα τιμωρίας: 3 ακυρώσεις σε 2 εβδομάδες = ban 3 εβδομάδων
- Η τοποθεσία αποκαλύπτεται μόνο στα 500μ
- Αντιστοιχία οχημάτων γίνεται βάσει μήκους`;

function ChatScreen({onBack,darkMode}){
  const [submitted, setSubmitted] = useState(false);
  const [input, setInput] = useState("");
  const [category, setCategory] = useState("");
  const [sending, setSending] = useState(false);

  const CATEGORIES = [
    {id:"deal", label:"🤝 Πρόβλημα με Deal"},
    {id:"payment", label:"💳 Οικονομικό Θέμα"},
    {id:"vehicle", label:"🚗 Θέμα Οχήματος"},
    {id:"account", label:"👤 Θέμα Λογαριασμού"},
    {id:"illegal", label:"🚫 Παράνομη Θέση"},
    {id:"other", label:"💬 Άλλο"},
  ];

  const send = async () => {
    if(!input.trim() || !category || sending) return;
    setSending(true);
    try {
      const { supabase } = await import("./supabase_client");
      const { data: authData } = await supabase.auth.getUser();
      const au = authData?.user;
      if(au) {
        const { data: profile } = await supabase.from("users").select("id").eq("auth_id", au.id).maybeSingle();
        if(profile) {
          await supabase.from("support_messages").insert({
            user_id: profile.id,
            message: "[" + category.toUpperCase() + "] " + sanitize(input.trim()),
            is_read: false,
            needs_human: true
          });
        }
      }
      setSubmitted(true);
    } catch(e) { console.error(e); }
    setSending(false);
  };

  if(submitted) return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Υποστήριξη" onBack={onBack} darkMode={darkMode}/>
      <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:40,textAlign:"center",minHeight:"70vh"}}>
        <div style={{fontSize:64,marginBottom:16}}>✅</div>
        <div style={{color:C.accent,fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:20,marginBottom:12}}>Αίτημα Στάλθηκε!</div>
        <div style={{color:C.muted,fontSize:14,lineHeight:1.7,marginBottom:24}}>
          Η ομάδα μας έλαβε το μήνυμά σου και θα επικοινωνήσει σύντομα μαζί σου.
        </div>
        <button onClick={()=>{setSubmitted(false);setInput("");setCategory("");}}
          style={{background:"transparent",border:"1px solid "+C.border,borderRadius:10,padding:"10px 20px",color:C.muted,cursor:"pointer",fontSize:13}}>
          Νέο Αίτημα
        </button>
      </div>
    </div>
  );

  return (
    <div style={{background:C.bg,minHeight:"100%"}}>
      <TopBar title="Υποστήριξη" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:20}}>
        <div style={{background:"linear-gradient(135deg,rgba(0,212,170,0.15),rgba(0,153,255,0.1))",border:"1px solid "+C.accent+"33",borderRadius:16,padding:20,marginBottom:20,textAlign:"center"}}>
          <img src="/ToParking.png" alt="ToParking" style={{width:56,height:56,objectFit:"contain",marginBottom:8}}/>
          <div style={{color:C.text,fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:16,marginBottom:6}}>Υποστήριξη ToParking</div>
          <div style={{color:C.muted,fontSize:12,lineHeight:1.6}}>Στείλε μας το αίτημα ή παράπονό σου και θα επικοινωνήσουμε μαζί σου.</div>
        </div>

        <div style={{marginBottom:16}}>
          <div style={{color:C.text,fontWeight:700,fontSize:14,marginBottom:10}}>Κατηγορία αιτήματος</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            {CATEGORIES.map(cat=>(
              <button key={cat.id} onClick={()=>setCategory(cat.id)}
                style={{padding:"10px 12px",borderRadius:10,border:"1px solid "+(category===cat.id?C.accent:C.border),background:category===cat.id?"rgba(0,212,170,0.1)":C.card,color:category===cat.id?C.accent:C.muted,cursor:"pointer",fontSize:12,fontWeight:600,textAlign:"left"}}>
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        <div style={{marginBottom:20}}>
          <div style={{color:C.text,fontWeight:700,fontSize:14,marginBottom:8}}>Μήνυμα</div>
          <textarea value={input} onChange={e=>setInput(e.target.value.slice(0,500))}
            placeholder="Περιέγραψε το πρόβλημα ή αίτημά σου..." rows={5}
            style={{width:"100%",padding:"12px 14px",borderRadius:12,border:"1px solid "+C.border,background:C.card,color:C.text,fontSize:13,outline:"none",resize:"none",boxSizing:"border-box",lineHeight:1.6}}/>
          <div style={{color:C.muted,fontSize:11,marginTop:4}}>{input.length}/500</div>
        </div>

        <div style={{background:"rgba(0,153,255,0.06)",border:"1px solid rgba(0,153,255,0.2)",borderRadius:10,padding:12,marginBottom:20}}>
          <div style={{color:C.muted,fontSize:11,lineHeight:1.7}}>📧 Θα λάβεις απάντηση στο email του λογαριασμού σου το συντομότερο δυνατόν.</div>
        </div>

        <button onClick={send} disabled={!input.trim()||!category||sending}
          style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:(!input.trim()||!category)?C.border:C.accent,color:"#fff",fontFamily:"Syne,sans-serif",fontWeight:800,fontSize:15,cursor:(!input.trim()||!category)?"default":"pointer"}}>
          {sending?"⏳ Αποστολή...":"Αποστολή Αιτήματος →"}
        </button>
      </div>
    </div>
  );
}

// ─── MOCK DEAL HISTORY DATA ───────────────────────────────────────────────────
const MOCK_DEALS = [
  {id:1, type:"giver",   region:"Κολωνάκι",   date:"Σήμερα, 10:22",   amount:4.00,  status:"completed", discount:null},
  {id:2, type:"seeker",  region:"Σύνταγμα",   date:"Χθες, 18:45",     amount:-7.81, status:"completed", discount:null},
  {id:3, type:"giver",   region:"Μοναστηράκι",date:"12 Ιουν, 09:10",  amount:3.00,  status:"completed", discount:null},
  {id:4, type:"seeker",  region:"Ακρόπολη",   date:"10 Ιουν, 14:33",  amount:-5.29, status:"cancelled", discount:"50% έκπτωση σε επόμενο deal"},
  {id:5, type:"giver",   region:"Μαρούσι",    date:"8 Ιουν, 11:05",   amount:2.25,  status:"completed", discount:null},
  {id:6, type:"seeker",  region:"Κηφισιά",    date:"5 Ιουν, 16:20",   amount:-5.29, status:"late",      discount:null, penalty:"+15% χρεώθηκε"},
  {id:7, type:"giver",   region:"Ομόνοια",    date:"2 Ιουν, 08:55",   amount:2.50,  status:"completed", discount:null},
];

function ProfileScreen({onBack,user,darkMode}){
  const T=useT(darkMode);
  const [histTab, setHistTab]=useState("all");
  const [expandDeal, setExpandDeal]=useState(null);
  const [deals, setDeals]=useState([]);
  const [userId, setUserId]=useState(null);

  const [penalties, setPenalties] = useState([]);
  const [banInfo, setBanInfo] = useState(null);

  useEffect(()=>{
    import("./supabase_client").then(async({supabase})=>{
      const { data:{user:au} } = await supabase.auth.getUser();
      if(!au) return;
      const { data:profile } = await supabase.from('users').select('id,ban_give_until,ban_take_until').eq('auth_id',au.id).single();
      if(!profile) return;
      setUserId(profile.id);

      // Deals
      const { data:d } = await supabase
        .from('deals').select('*')
        .or(`giver_id.eq.${profile.id},seeker_id.eq.${profile.id}`)
        .order('created_at',{ascending:false});
      if(d) setDeals(d.map(deal=>({
        id: deal.id,
        type: deal.giver_id===profile.id ? 'giver' : 'seeker',
        region: deal.region,
        date: new Date(deal.created_at).toLocaleDateString('el-GR'),
        amount: deal.giver_id===profile.id ? deal.giver_earn||0 : -(deal.price||0),
        status: deal.status||'completed',
        discount: null,
      })));

      // Penalties
      const { data:p } = await supabase
        .from('penalties').select('*')
        .eq('user_id', profile.id)
        .order('created_at',{ascending:false});
      if(p) setPenalties(p);

      // Ban info
      const bans = [];
      if(profile.ban_give_until && new Date(profile.ban_give_until) > new Date())
        bans.push(`Giver ban έως ${new Date(profile.ban_give_until).toLocaleDateString('el-GR')}`);
      if(profile.ban_take_until && new Date(profile.ban_take_until) > new Date())
        bans.push(`Seeker ban έως ${new Date(profile.ban_take_until).toLocaleDateString('el-GR')}`);
      if(bans.length) setBanInfo(bans);
    });
  },[]);

  const filtered = histTab==="all" ? deals
    : histTab==="giver" ? deals.filter(d=>d.type==="giver")
    : deals.filter(d=>d.type==="seeker");

  const totalEarned = deals.filter(d=>d.type==="giver"&&d.status==="completed").reduce((s,d)=>s+d.amount,0);
  const totalSpent  = Math.abs(deals.filter(d=>d.type==="seeker").reduce((s,d)=>s+d.amount,0));

  const statusInfo = (s) => ({
    completed: {label:"Ολοκληρώθηκε", color:C.accent,   icon:"✅"},
    cancelled:  {label:"Ακυρώθηκε",   color:C.danger,   icon:"❌"},
    late:       {label:"Καθυστέρηση", color:C.warn,     icon:"⏰"},
  }[s]||{label:s,color:C.muted,icon:"•"});

  return (
    <div style={{background:T.bg,minHeight:"100%"}}>
      <TopBar title="Προφίλ" onBack={onBack} darkMode={darkMode}/>
      <div style={{padding:20}}>

        {/* Avatar + username */}
        <div style={{textAlign:"center",marginBottom:20}}>
          <div style={{width:72,height:72,borderRadius:36,background:`linear-gradient(135deg,${C.accent},#1A2EAA)`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:32,margin:"0 auto 12px"}}>👤</div>
          <div style={{color:T.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:20}}>@{user.username}</div>
          <Badge style={{marginTop:6}}>Αθήνα 📍</Badge>
        </div>

        {/* Stats grid */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
          {[
            {label:"Deals",        value:String(deals.length), icon:"🤝", color:C.accent},
            {label:"Παραβάσεις",   value:`${penalties.length} / 3`, icon:"⚖️", color: penalties.length>=2?"#EF4444":penalties.length===1?"#F59E0B":C.accent},
            {label:"Κέρδη",        value:`€${totalEarned.toFixed(2)}`,icon:"💰",color:"#10B981"},
            {label:"Δαπάνες",      value:`€${totalSpent.toFixed(2)}`, icon:"💳",color:"#1A2EAA"},
          ].map(s=>(
            <Card key={s.label} style={{padding:14,textAlign:"center"}}>
              <div style={{fontSize:22,marginBottom:4}}>{s.icon}</div>
              <div style={{color:s.color,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:17}}>{s.value}</div>
              <div style={{color:C.muted,fontSize:11,marginTop:2}}>{s.label}</div>
            </Card>
          ))}
        </div>
        {/* Ban info */}
        {banInfo && banInfo.map((b,i)=>(
          <div key={i} style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",marginBottom:8,display:"flex",gap:8,alignItems:"center"}}>
            <span style={{fontSize:16}}>🚫</span>
            <span style={{color:"#EF4444",fontSize:12,fontWeight:700}}>{b}</span>
          </div>
        ))}
        {/* Penalties list */}
        {penalties.length > 0 && (
          <div style={{marginBottom:16}}>
            <div style={{color:T.text,fontWeight:800,fontSize:14,marginBottom:8}}>⚖️ Ιστορικό Παραβάσεων</div>
            {penalties.map((p,i)=>(
              <div key={i} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 14px",marginBottom:6,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{color:p.penalty_level===3?"#EF4444":p.penalty_level===2?"#F59E0B":"#A855F7",fontWeight:700,fontSize:13}}>
                    Λίστα {p.penalty_level} — {p.type==='cancelled_as_giver'?'Ακύρωση ως Giver':p.type==='cancelled_as_seeker'?'Ακύρωση ως Seeker':p.type==='illegal_spot'?'Παράνομη Θέση':p.type==='dispute_as_giver'?'Αναφορά Θέσης':p.type||'Παράβαση'}
                  </div>
                  <div style={{color:C.muted,fontSize:11,marginTop:2}}>{new Date(p.created_at).toLocaleDateString('el-GR')}</div>
                </div>
                <div style={{background:p.penalty_level===3?"rgba(239,68,68,0.15)":p.penalty_level===2?"rgba(245,158,11,0.15)":"rgba(168,85,247,0.15)",borderRadius:8,padding:"4px 10px"}}>
                  <span style={{color:p.penalty_level===3?"#EF4444":p.penalty_level===2?"#F59E0B":"#A855F7",fontSize:12,fontWeight:800}}>#{p.penalty_level}</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Privacy note */}
        <div style={{background:"rgba(239,68,68,0.08)",border:`1px solid ${C.danger}22`,borderRadius:12,padding:12,marginBottom:20}}>
          <div style={{color:C.danger,fontWeight:700,marginBottom:3,fontSize:12}}>🔒 Ιδιωτικότητα</div>
          <div style={{color:C.muted,fontSize:11,lineHeight:1.5}}>Τα προσωπικά σου στοιχεία <b style={{color:T.text}}>ποτέ δεν είναι ορατά</b> σε άλλους χρήστες.</div>
        </div>

        {/* ── ΙΣΤΟΡΙΚΟ DEALS ── */}
        <div style={{color:T.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:16,marginBottom:12}}>📋 Ιστορικό Deals</div>

        {/* Filter tabs */}
        <div style={{display:"flex",background:C.surface,borderRadius:10,padding:3,marginBottom:14,border:`1px solid ${C.border}`}}>
          {[{k:"all",l:"Όλα"},{ k:"giver",l:"🅿️ Έδωσα"},{k:"seeker",l:"🔍 Πήρα"}].map(t=>(
            <button key={t.k} onClick={()=>setHistTab(t.k)} style={{flex:1,padding:"8px 0",borderRadius:8,border:"none",cursor:"pointer",background:histTab===t.k?C.accent:"transparent",color:histTab===t.k?"#fff":C.muted,fontWeight:700,fontSize:12,fontFamily:"'DM Sans',sans-serif",transition:"all 0.2s"}}>
              {t.l}
            </button>
          ))}
        </div>

        {/* Deal list */}
        {filtered.map(deal=>{
          const si = statusInfo(deal.status);
          const isExp = expandDeal===deal.id;
          return (
            <div key={deal.id} onClick={()=>setExpandDeal(isExp?null:deal.id)}
              style={{background:T.card,borderRadius:14,border:`1px solid ${isExp?C.accent:T.border}`,padding:"12px 14px",marginBottom:10,cursor:"pointer",transition:"all 0.2s"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:38,height:38,borderRadius:10,background:deal.type==="giver"?`${C.accent}22`:"rgba(0,153,255,0.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>
                    {deal.type==="giver"?"🅿️":"🔍"}
                  </div>
                  <div>
                    <div style={{color:T.text,fontWeight:700,fontSize:13}}>
                      {deal.type==="giver"?"Έδωσα θέση":"Πήρα θέση"} · {deal.region}
                    </div>
                    <div style={{color:C.muted,fontSize:11,marginTop:1}}>{deal.date}</div>
                  </div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{color:deal.amount>0?C.accent:C.danger,fontWeight:800,fontSize:15}}>
                    {deal.amount>0?"+":""}€{Math.abs(deal.amount).toFixed(2)}
                  </div>
                  <div style={{fontSize:10,marginTop:2}}>{si.icon}</div>
                </div>
              </div>

              {/* Expanded detail */}
              {isExp&&<div style={{marginTop:12,paddingTop:12,borderTop:`1px solid ${T.border}`}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                  <span style={{color:C.muted,fontSize:12}}>Κατάσταση</span>
                  <span style={{color:si.color,fontWeight:700,fontSize:12}}>{si.icon} {si.label}</span>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                  <span style={{color:C.muted,fontSize:12}}>Ρόλος</span>
                  <span style={{color:T.text,fontSize:12,fontWeight:600}}>{deal.type==="giver"?"Giver (έδωσα)":"Seeker (πήρα)"}</span>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:deal.discount||deal.penalty?6:0}}>
                  <span style={{color:C.muted,fontSize:12}}>Ποσό</span>
                  <span style={{color:deal.amount>0?C.accent:C.danger,fontSize:12,fontWeight:700}}>
                    {deal.amount>0?"+":""}€{Math.abs(deal.amount).toFixed(2)}
                  </span>
                </div>
                {deal.discount&&<div style={{background:`${C.accent}15`,border:`1px solid ${C.accent}33`,borderRadius:8,padding:"6px 10px",marginTop:6}}>
                  <div style={{color:C.accent,fontSize:11,fontWeight:700}}>🎁 {deal.discount}</div>
                </div>}
                {deal.penalty&&<div style={{background:`${C.warn}15`,border:`1px solid ${C.warn}33`,borderRadius:8,padding:"6px 10px",marginTop:6}}>
                  <div style={{color:C.warn,fontSize:11,fontWeight:700}}>⚠️ {deal.penalty}</div>
                </div>}
              </div>}
            </div>
          );
        })}

        {filtered.length===0&&<div style={{textAlign:"center",padding:30,color:C.muted}}>
          <div style={{fontSize:36,marginBottom:8}}>📭</div>
          <div style={{fontSize:13}}>Δεν υπάρχουν deals σε αυτή την κατηγορία</div>
        </div>}
      </div>
    </div>
  );
}

// ─── ONBOARDING TUTORIAL ──────────────────────────────────────────────────────
const ONBOARDING_SLIDES = [
  {
    icon:"🅿️",
    title:"Καλώς ήρθες!",
    desc:"ToParking είναι μία έξυπνη εφαρμογή που μετατρέπει την αναζήτηση parking σε κέρδος για όλους.",
    color:C.accent,
    detail:"Βρες θέση parking ή κέρδισε χρήματα δίνοντας τη δική σου.",
  },
  {
    icon:"💰",
    title:"Δώσε Θέση & Κέρδισε",
    desc:"Όταν φεύγεις από κάπου, ανέβασε τη θέση σου και κέρδισε έως €4 σε λίγα λεπτά.",
    color:"#10B981",
    detail:"Ο άλλος χρήστης πληρώνει και εσύ λαμβάνεις το 50% αμέσως στο πορτοφόλι σου.",
  },
  {
    icon:"🔍",
    title:"Βρες Θέση Εύκολα",
    desc:"Αναζήτησε parking στην περιοχή σου και πλοηγήσου σε πραγματικό χρόνο.",
    color:"#1A2EAA",
    detail:"Η ακριβής τοποθεσία αποκαλύπτεται μόνο όταν είσαι 500μ. μακριά — πλήρης ιδιωτικότητα.",
  },
  {
    icon:"🛡️",
    title:"Ασφάλεια & Ιδιωτικότητα",
    desc:"Κανένα προσωπικό στοιχείο δεν μοιράζεται μεταξύ χρηστών.",
    color:"#A855F7",
    detail:"Email, τηλέφωνο και ονοματεπώνυμο παραμένουν πάντα ιδιωτικά. Οι άλλοι βλέπουν ΜΟΝΟ το username σου.",
  },
  {
    icon:"🚗",
    title:"Πρόσθεσε το Όχημά σου!",
    desc:"Για να κάνεις deals χρειάζεται να έχεις καταχωρημένο τουλάχιστον ένα όχημα.",
    color:"#F59E0B",
    detail:"Πήγαινε στην οθόνη 'Οχήματα' και πρόσθεσε μάρκα, μοντέλο και χρώμα. Αποκαλύπτεται μόνο στα 500μ.",
    cta:"vehicles",
    ctaLabel:"→ Πρόσθεσε Όχημα τώρα",
  },
  {
    icon:"⚡",
    title:"Έτοιμος να ξεκινήσεις!",
    desc:"Το ToParking σε περιμένει. Ξεκίνα σήμερα και βγάλε χρήματα από κάτι που κάνεις ήδη.",
    color:C.accent,
    detail:null,
  },
];

function OnboardingOverlay({onDone, onNavigate}){
  const [slide, setSlide]=useState(0);
  const [dontShowAgain, setDontShowAgain]=useState(false);
  const isLast = slide===ONBOARDING_SLIDES.length-1;
  const s = ONBOARDING_SLIDES[slide];

  const handleDone = () => {
    if(dontShowAgain) {
      // Αποθήκευση προτίμησης — δεν θα εμφανιστεί ξανά
      localStorage.setItem('toparking_hide_onboarding', '1');
    }
    onDone();
  };

  return (
    <div style={{position:"fixed",inset:0,zIndex:500,background:"rgba(0,0,0,0.92)",display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div style={{width:"100%",maxWidth:430,background:C.card,borderRadius:"28px 28px 0 0",padding:"32px 28px 40px",border:`1px solid ${C.border}`,borderBottom:"none"}}>

        {/* Skip */}
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:24}}>
          <button onClick={handleDone} style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:13,fontFamily:"'DM Sans',sans-serif"}}>
            Παράλειψη
          </button>
        </div>

        {/* Icon */}
        <div style={{textAlign:"center",marginBottom:24}}>
          <div style={{width:90,height:90,borderRadius:24,background:`${s.color}20`,border:`2px solid ${s.color}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:44,margin:"0 auto 20px",boxShadow:`0 0 32px ${s.color}30`}}>
            {s.icon}
          </div>
          <div style={{color:C.text,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:20,marginBottom:10,lineHeight:1.3}}>
            {s.title}
          </div>
          <div style={{color:C.muted,fontSize:14,lineHeight:1.6,marginBottom:s.detail?12:0}}>
            {s.desc}
          </div>
          {s.detail&&<div style={{background:`${s.color}12`,border:`1px solid ${s.color}30`,borderRadius:10,padding:"10px 14px",marginTop:8}}>
            <div style={{color:s.color,fontSize:12,lineHeight:1.6}}>{s.detail}</div>
          </div>}
        </div>

        {/* Dots */}
        <div style={{display:"flex",justifyContent:"center",gap:8,marginBottom:24}}>
          {ONBOARDING_SLIDES.map((_,i)=>(
            <div key={i} onClick={()=>setSlide(i)} style={{width:i===slide?24:8,height:8,borderRadius:4,background:i===slide?s.color:C.border,transition:"all 0.3s",cursor:"pointer"}}/>
          ))}
        </div>

        {/* Don't show again — εμφανίζεται μόνο στην τελευταία slide */}
        {isLast && (
          <div onClick={()=>setDontShowAgain(v=>!v)}
            style={{display:"flex",alignItems:"center",gap:10,marginBottom:16,cursor:"pointer",padding:"8px 0"}}>
            <div style={{width:20,height:20,borderRadius:6,border:`2px solid ${dontShowAgain?s.color:C.border}`,background:dontShowAgain?s.color:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all 0.2s"}}>
              {dontShowAgain && <span style={{color:"#fff",fontSize:12,fontWeight:800}}>✓</span>}
            </div>
            <span style={{color:C.muted,fontSize:13}}>Να μην εμφανιστεί ξανά</span>
          </div>
        )}

        {/* Button */}
        <button onClick={()=>isLast?handleDone():setSlide(s=>s+1)}
          style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:`linear-gradient(135deg,${s.color},${s.color}CC)`,color:"#fff",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:16,cursor:"pointer",boxShadow:`0 4px 20px ${s.color}40`}}>
          {isLast?"Ξεκίνα τώρα! →":"Επόμενο →"}
        </button>
        {s.cta&&onNavigate&&(
          <button onClick={()=>{handleDone();onNavigate(s.cta);}}
            style={{width:"100%",padding:"10px",borderRadius:14,border:`1px solid ${s.color}44`,background:"transparent",color:s.color,fontWeight:700,fontSize:13,cursor:"pointer",marginTop:10}}>
            {s.ctaLabel}
          </button>
        )}
      </div>
    </div>
  );
}


// ─── VEHICLE LENGTH DATABASE ─────────────────────────────────────────────────
const VEHICLE_LENGTHS = {
  "Toyota Yaris":3.94,"Toyota Corolla":4.37,"Toyota Auris":4.27,"Toyota Camry":4.88,"Toyota RAV4":4.60,
  "Toyota C-HR":4.36,"Toyota Aygo":3.46,"Toyota Prius":4.48,"Toyota Land Cruiser":4.95,
  "Volkswagen Polo":4.05,"Volkswagen Golf":4.28,"Volkswagen Passat":4.77,"Volkswagen Tiguan":4.49,
  "Volkswagen T-Roc":4.23,"Volkswagen up!":3.54,"Volkswagen Caddy":4.50,
  "BMW 1 Series":4.32,"BMW 2 Series":4.36,"BMW 3 Series":4.71,"BMW 5 Series":4.94,
  "BMW X1":4.45,"BMW X3":4.71,"BMW X5":4.92,
  "Mercedes A-Class":4.42,"Mercedes C-Class":4.69,"Mercedes E-Class":4.92,
  "Mercedes GLA":4.41,"Mercedes GLC":4.65,"Mercedes Vito":5.14,
  "Ford Fiesta":4.07,"Ford Focus":4.36,"Ford Mondeo":4.87,"Ford Kuga":4.52,
  "Ford EcoSport":4.26,"Ford Transit":5.53,
  "Hyundai i10":3.67,"Hyundai i20":4.04,"Hyundai i30":4.34,"Hyundai Tucson":4.48,
  "Hyundai Santa Fe":4.77,"Hyundai Coupe":4.35,"Hyundai Coupe GK":4.35,
  "Hyundai Ioniq":4.47,"Hyundai Kona":4.17,
  "Kia Picanto":3.60,"Kia Rio":4.07,"Kia Ceed":4.31,"Kia Sportage":4.52,
  "Kia Sorento":4.79,"Kia Stinger":4.83,
  "Seat Ibiza":4.06,"Seat Leon":4.37,"Seat Ateca":4.37,"Seat Arona":4.14,
  "Cupra Formentor":4.45,
  "Opel Corsa":4.06,"Opel Astra":4.37,"Opel Insignia":4.90,"Opel Crossland":4.21,
  "Opel Grandland":4.48,"Opel Mokka":4.15,
  "Peugeot 208":4.06,"Peugeot 308":4.37,"Peugeot 508":4.75,"Peugeot 2008":4.16,
  "Peugeot 3008":4.45,"Peugeot 5008":4.64,
  "Renault Clio":4.05,"Renault Megane":4.36,"Renault Captur":4.23,"Renault Kadjar":4.45,
  "Renault Zoe":4.09,"Renault Twingo":3.62,
  "Fiat 500":3.55,"Fiat Panda":3.64,"Fiat Tipo":4.37,"Fiat 500X":4.25,
  "Fiat Bravo":4.34,"Fiat Punto":3.84,
  "Nissan Micra":3.99,"Nissan Juke":4.21,"Nissan Qashqai":4.43,"Nissan X-Trail":4.64,
  "Nissan Leaf":4.49,"Nissan Note":4.10,
  "Honda Jazz":4.04,"Honda Civic":4.55,"Honda CR-V":4.60,"Honda HR-V":4.29,"Honda Accord":4.89,
  "Audi A1":4.03,"Audi A3":4.34,"Audi A4":4.72,"Audi A6":4.94,
  "Audi Q3":4.46,"Audi Q5":4.66,"Audi TT":4.18,
  "Suzuki Swift":3.84,"Suzuki Vitara":4.17,"Suzuki Jimny":3.64,
  "Suzuki S-Cross":4.30,"Suzuki Alto":3.49,"Suzuki Ignis":3.70,
  "Smart ForTwo":2.69,"Smart ForFour":3.50,
  "Skoda Fabia":4.11,"Skoda Octavia":4.69,"Skoda Superb":4.87,
  "Skoda Karoq":4.38,"Skoda Kodiaq":4.70,"Skoda Scala":4.36,
  "Citroën C1":3.47,"Citroën C3":4.00,"Citroën C4":4.36,
  "Citroën C5 Aircross":4.50,"Citroën Berlingo":4.40,
  "Dacia Sandero":4.09,"Dacia Logan":4.37,"Dacia Duster":4.34,"Dacia Spring":3.73,
  "Mazda 2":4.06,"Mazda 3":4.46,"Mazda 6":4.80,"Mazda CX-3":4.28,
  "Mazda CX-5":4.55,"Mazda MX-5":3.92,
  "Yamaha N-Max":1.94,"Honda PCX":1.92,"Vespa GTS":1.84,
  "Yamaha TMAX":2.20,"Honda CB500":2.05,"Kawasaki Z650":2.05,
};

// Βρες μήκος οχήματος — πρώτα από βάση, μετά από Claude API
async function getVehicleLength(brand, model) {
  const key1 = `${brand} ${model}`;
  const key2 = brand + " " + model.split(" ")[0]; // fallback partial match
  if(VEHICLE_LENGTHS[key1]) return VEHICLE_LENGTHS[key1];
  if(VEHICLE_LENGTHS[key2]) return VEHICLE_LENGTHS[key2];
  // Fuzzy match
  const keys = Object.keys(VEHICLE_LENGTHS);
  const fuzzy = keys.find(k => k.toLowerCase().includes(model.toLowerCase()) || model.toLowerCase().includes(k.split(" ").slice(1).join(" ").toLowerCase()));
  if(fuzzy) return VEHICLE_LENGTHS[fuzzy];
  // Claude API fallback
  try {
    const res = await fetch("https://api.anthropic.com/v1/messages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        model: "claude-sonnet-4-20250514",
        max_tokens: 100,
        messages: [{ role: "user", content: `What is the length in meters of a ${brand} ${model}? Reply with only the number, e.g. 4.35` }]
      })
    });
    const data = await res.json();
    const text = data.content?.[0]?.text || "";
    const num = parseFloat(text.match(/\d+\.?\d*/)?.[0]);
    if(!isNaN(num) && num > 1 && num < 8) return num;
  } catch(e) {}
  return null; // άγνωστο
}

function VehiclesScreen({onBack,darkMode,userId}){
  const [adding,setAdding]=useState(false);
  const [vehicles,setVehicles]=useState([]);
  const [loading,setLoading]=useState(true);
  const [saving,setSaving]=useState(false);
  const [form,setForm]=useState({type:"",brand:"",model:"",color:"",year:""});
  const T=useT(darkMode);
  const BRANDS=["Toyota","BMW","Mercedes","Volkswagen","Ford","Honda","Audi","Fiat","Peugeot","Renault","Opel","Hyundai","Kia","Nissan","Suzuki","Yamaha","Kawasaki","Ducati","Vespa"];
  const TYPES=["Αυτοκίνητο","Βαν","Μοτοσυκλέτα","Scooter","SUV","Φορτηγό"];
  const COLORS=["Λευκό","Μαύρο","Ασημί","Γκρι","Κόκκινο","Μπλε","Πράσινο","Κίτρινο","Πορτοκαλί","Καφέ"];

  useEffect(()=>{
    setVehicles([]);
    setLoading(true);
    const load = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        // Forced refresh του session για να πάρουμε τον τρέχοντα χρήστη
        const { data: sessionData } = await supabase.auth.refreshSession();
        const au = sessionData?.session?.user || (await supabase.auth.getUser()).data?.user;
        if(!au) { setLoading(false); return; }
        console.log("VehiclesScreen loading for:", au.email);
        const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
        if(!profile) { setLoading(false); return; }
        console.log("Loading vehicles for user_id:", profile.id);
        const { data, error } = await supabase.from('vehicles').select('*').eq('user_id', profile.id).order('created_at');
        if(error) console.error("Vehicles load error:", error);
        console.log("Vehicles loaded:", data?.length, data?.map(v=>v.brand+' '+v.model));
        setVehicles(data || []);
      } catch(e) { console.error(e); }
      setLoading(false);
    };
    load();
  },[userId]);

  const handleSave = async () => {
    if(!form.type||!form.brand||!form.model) return;
    setSaving(true);
    try {
      const { supabase } = await import("./supabase_client");
      const { data: authData } = await supabase.auth.getUser();
      const au = authData?.user; if(!au) return;
      const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
      if(!profile) return;
      // Αυτόματος υπολογισμός μήκους
      const length = await getVehicleLength(form.brand, form.model);
      const { data, error } = await supabase.from('vehicles').insert({
        user_id: profile.id,
        type: form.type, brand: form.brand, model: form.model,
        color: form.color, year: form.year,
        length_m: length
      }).select().single();
      if(!error && data) {
        setVehicles(v=>[...v, data]);
        setForm({type:"",brand:"",model:"",color:"",year:""});
        setAdding(false);
      }
    } catch(e) { console.error(e); }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    try {
      const { supabase } = await import("./supabase_client");
      await supabase.from('vehicles').delete().eq('id', id);
      setVehicles(v=>v.filter(x=>x.id!==id));
    } catch(e) { console.error(e); }
  };

  return (
    <div style={{background:T.bg,minHeight:"100%"}}>
      <TopBar title="Οχήματά μου" onBack={onBack} darkMode={darkMode} rightEl={<button onClick={()=>setAdding(true)} style={{background:C.accent,border:"none",color:"#fff",borderRadius:8,padding:"6px 14px",cursor:"pointer",fontWeight:700,fontSize:13}}>+ Προσθήκη</button>}/>
      <div style={{padding:20}}>
        <div style={{background:"rgba(0,212,170,0.08)",border:`1px solid ${C.accent}33`,borderRadius:12,padding:12,marginBottom:16}}>
          <div style={{color:C.muted,fontSize:11,lineHeight:1.5}}>🚗 Τα στοιχεία του οχήματος αποκαλύπτονται στον άλλο χρήστη ΜΟΝΟ όταν είναι &lt;500μ μακριά. <b style={{color:C.text}}>Κανένα προσωπικό στοιχείο δεν κοινοποιείται.</b></div>
        </div>
        {loading && <div style={{textAlign:"center",padding:40,color:C.muted}}>⏳ Φόρτωση...</div>}
        {!loading && vehicles.length===0&&!adding&&<div style={{textAlign:"center",padding:40,color:C.muted}}>
          <div style={{fontSize:48}}>🚗</div>
          <div style={{marginTop:12,marginBottom:16}}>Δεν έχεις οχήματα.</div>
          <div style={{background:"rgba(245,158,11,0.1)",border:"1px solid rgba(245,158,11,0.3)",borderRadius:10,padding:12}}>
            <div style={{color:"#F59E0B",fontSize:12}}>⚠️ Χρειάζεσαι τουλάχιστον ένα όχημα για να κάνεις deals!</div>
          </div>
        </div>}
        {vehicles.map(v=><Card key={v.id} style={{marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <div style={{fontSize:28}}>{v.type==="Μοτοσυκλέτα"||v.type==="Scooter"?"🏍️":v.type==="Βαν"?"🚐":"🚗"}</div>
            <div>
              <div style={{color:T.text,fontWeight:700}}>{v.brand} {v.model}</div>
              <div style={{color:C.muted,fontSize:12}}>{v.color} · {v.year} · {v.type}</div>
              {v.length_m && <div style={{color:C.accent,fontSize:11,marginTop:2,fontWeight:700}}>📏 {v.length_m}μ</div>}
              {!v.length_m && <div style={{color:C.muted,fontSize:11,marginTop:2}}>📏 Μήκος άγνωστο</div>}
            </div>
          </div>
          <button onClick={()=>handleDelete(v.id)} style={{background:"none",border:"none",color:C.danger,cursor:"pointer",fontSize:18}}>🗑</button>
        </Card>)}
        {adding&&<Card style={{marginTop:8}}>
          <div style={{color:T.text,fontWeight:800,marginBottom:14}}>Νέο Όχημα</div>
          <Input label="Τύπος" value={form.type} onChange={v=>setForm({...form,type:v})} options={TYPES}/>
          <Input label="Μάρκα" value={form.brand} onChange={v=>setForm({...form,brand:v})} options={BRANDS}/>
          <Input label="Μοντέλο" value={form.model} onChange={v=>setForm({...form,model:v})} placeholder="π.χ. Corolla"/>
          <Input label="Χρώμα" value={form.color} onChange={v=>setForm({...form,color:v})} options={COLORS}/>
          <Input label="Χρονολογία" value={form.year} onChange={v=>setForm({...form,year:v})} placeholder="π.χ. 2019" type="number"/>
          <div style={{display:"flex",gap:10}}>
            <Btn variant="secondary" style={{flex:1}} onClick={()=>setAdding(false)}>Άκυρο</Btn>
            <Btn style={{flex:1}} disabled={!form.type||!form.brand||!form.model||saving} onClick={handleSave}>{saving?"⏳...":"Αποθήκευση"}</Btn>
          </div>
        </Card>}
      </div>
    </div>
  );
}

// ─── APP ──────────────────────────────────────────────────────────────────────
// ─── GOOGLE MAPS LOADER ─────────────────────────────────────────────────────
const GMAP_KEY = "AIzaSyBnX74NinwaerLkvwFPoqIBldRYebVHSnA";
let gmapsLoaded = false;
function loadGoogleMaps() {
  return new Promise((resolve) => {
    if(window.google?.maps) { resolve(); return; }
    if(gmapsLoaded) { const wait = setInterval(()=>{ if(window.google?.maps){ clearInterval(wait); resolve(); }},100); return; }
    gmapsLoaded = true;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GMAP_KEY}&libraries=geometry`;
    script.async = true;
    script.onload = resolve;
    document.head.appendChild(script);
  });
}

// ─── STRIPE LOADER ───────────────────────────────────────────────────────────


function useGPSTracker(dealId, role) {
  const [myPos, setMyPos] = useState(null);
  const [otherPos, setOtherPos] = useState(null);
  const [distance, setDistance] = useState(null);
  const myPosRef = useRef(null);

  useEffect(() => {
    if(!dealId) return;
    let watchId = null;
    let pollInterval = null;
    let alive = true;

    const startTracking = async () => {
      let sb;
      try { const m = await import("./supabase_client"); sb = m.supabase; } catch(e) { return; }

      if(navigator.geolocation) {
        watchId = navigator.geolocation.watchPosition(async (pos) => {
          if(!alive) return;
          const { latitude: lat, longitude: lng } = pos.coords;
          const newPos = { lat, lng };
          setMyPos(newPos);
          myPosRef.current = newPos;
          const field = role === 'giver' ? 'giver_lat' : 'seeker_lat';
          const field2 = role === 'giver' ? 'giver_lng' : 'seeker_lng';
          await sb.from('deals').update({ [field]: lat, [field2]: lng }).eq('id', dealId);
        }, null, { enableHighAccuracy: true, maximumAge: 3000, timeout: 10000 });
      }

      pollInterval = setInterval(async () => {
        if(!alive) return;
        const { data } = await sb.from('deals').select('giver_lat,giver_lng,seeker_lat,seeker_lng').eq('id', dealId).single();
        if(!data) return;
        const otherLat = role === 'giver' ? data.seeker_lat : data.giver_lat;
        const otherLng = role === 'giver' ? data.seeker_lng : data.giver_lng;
        if(otherLat && otherLng) {
          const op = { lat: otherLat, lng: otherLng };
          setOtherPos(op);
          if(window.google?.maps?.geometry && myPosRef.current) {
            const d = window.google.maps.geometry.spherical.computeDistanceBetween(
              new window.google.maps.LatLng(myPosRef.current.lat, myPosRef.current.lng),
              new window.google.maps.LatLng(otherLat, otherLng)
            );
            setDistance(Math.round(d));
          }
        }
      }, 4000);
    };

    startTracking();
    return () => {
      alive = false;
      if(watchId !== null) navigator.geolocation.clearWatch(watchId);
      if(pollInterval) clearInterval(pollInterval);
    };
  }, [dealId, role]);

  return { myPos, otherPos, distance };
}

function GoogleMapView({ destination, myPos, otherPos, role, showOther, dealAddress, revealed, otherVehicle, onHome, onCancel, children }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef({});
  const circleRef = useRef(null);
  const directionsRendererRef = useRef(null);
  const [mapReady, setMapReady] = useState(false);
  const [navInfo, setNavInfo] = useState(null);
  const [stepIdx, setStepIdx] = useState(0);
  const [isCentered, setIsCentered] = useState(true);
  const [showStepsList, setShowStepsList] = useState(false);
  const revealedRef = useRef(revealed);
  const myPosRef = useRef(myPos);
  revealedRef.current = revealed;
  myPosRef.current = myPos;

  // Τυχαία μετατόπιση κέντρου κύκλου — παράγεται ΜΙΑΦΟΡΑ και μένει σταθερή.
  // Έτσι ακόμα και με zoom το κέντρο ΔΕΝ αποκαλύπτει την πραγματική θέση.
  const fakeOffsetRef = useRef(null);
  if(!fakeOffsetRef.current && destination) {
    const angle = Math.random() * 360;
    const dist  = 150 + Math.random() * 200; // 150–350μ offset
    const dLat  = (dist * Math.cos((angle * Math.PI) / 180)) / 111320;
    const dLng  = (dist * Math.sin((angle * Math.PI) / 180)) / (111320 * Math.cos((destination.lat * Math.PI) / 180));
    fakeOffsetRef.current = { lat: dLat, lng: dLng };
  }

  useEffect(() => { loadGoogleMaps().then(() => setMapReady(true)); }, []);

  // ── Αρχικοποίηση χάρτη ──────────────────────────────────────────
  useEffect(() => {
    if(!mapReady || !mapRef.current || mapInstanceRef.current) return;
    const map = new window.google.maps.Map(mapRef.current, {
      zoom: 16,
      center: myPos || destination || { lat: 37.9838, lng: 23.7275 },
      styles: [
        {elementType:"geometry",stylers:[{color:"#1a1f2e"}]},
        {elementType:"labels.icon",stylers:[{visibility:"off"}]},
        {elementType:"labels.text.fill",stylers:[{color:"#8ec3b9"}]},
        {elementType:"labels.text.stroke",stylers:[{color:"#1a1f2e"}]},
        {featureType:"road",elementType:"geometry",stylers:[{color:"#2d3a4a"}]},
        {featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#38485c"}]},
        {featureType:"road.highway",elementType:"geometry",stylers:[{color:"#3c5068"}]},
        {featureType:"road.highway",elementType:"labels.text.fill",stylers:[{color:"#b0bec5"}]},
        {featureType:"transit",stylers:[{visibility:"off"}]},
        {featureType:"water",elementType:"geometry",stylers:[{color:"#0e1626"}]},
        {featureType:"poi",stylers:[{visibility:"off"}]},
        {featureType:"poi.park",elementType:"geometry",stylers:[{color:"#1c2b1e"}]},
      ],
      disableDefaultUI: true,
      gestureHandling: "greedy",
      clickableIcons: false,
    });
    mapInstanceRef.current = map;

    // Recenter tracking — αν ο χρήστης μετακινήσει τον χάρτη χειροκίνητα
    map.addListener('dragstart', () => setIsCentered(false));

    const renderer = new window.google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: { strokeColor: "#0099FF", strokeWeight: 5, strokeOpacity: 0.85 }
    });
    renderer.setMap(map);
    directionsRendererRef.current = renderer;
  }, [mapReady]);

  // ── Markers & Route update (όταν αλλάζουν θέσεις/revealed) ─────
  useEffect(() => {
    if(!mapReady || !mapInstanceRef.current) return;
    const map = mapInstanceRef.current;
    const G = window.google.maps;

    // ── Marker εμού (με ακτίνα accuracy — Google Maps style) ──────
    if(myPos) {
      if(markersRef.current.me) {
        markersRef.current.me.setPosition(myPos);
      } else {
        // Outer glow
        markersRef.current.meGlow = new G.Marker({
          position: myPos, map, zIndex: 10,
          icon: { path: G.SymbolPath.CIRCLE, scale: 18,
            fillColor: role==='seeker'?"#0099FF":"#00D4AA", fillOpacity: 0.18,
            strokeColor: "transparent", strokeWeight: 0 }
        });
        // Main dot
        markersRef.current.me = new G.Marker({
          position: myPos, map, zIndex: 11, title: "Εσύ",
          icon: { path: G.SymbolPath.CIRCLE, scale: 10,
            fillColor: role==='seeker'?"#0099FF":"#00D4AA", fillOpacity: 1,
            strokeColor: "#fff", strokeWeight: 3 }
        });
        // Label
        markersRef.current.meLabel = new G.InfoWindow({
          content: `<div style="font-size:11px;font-weight:700;color:#fff;background:${role==='seeker'?"#0099FF":"#00D4AA"};padding:2px 7px;border-radius:8px;white-space:nowrap;">📍 Εσύ</div>`,
          disableAutoPan: true,
        });
        markersRef.current.meLabel.open(map, markersRef.current.me);
      }
      if(markersRef.current.meGlow) markersRef.current.meGlow.setPosition(myPos);
      if(isCentered) map.panTo(myPos);
    }

    // ── Privacy circle (κρυφή θέση) ───────────────────────────────
    // ΣΗΜΑΝΤΙΚΟ: το κέντρο του κύκλου και το marker είναι ΤΥΧΑΙΑ ΜΕΤΑΤΟΠΙΣΜΕΝΑ
    // από την πραγματική θέση, ώστε ακόμα και με zoom να μην αποκαλύπτεται πού είναι.
    if(destination && !revealed) {
      const off = fakeOffsetRef.current || { lat: 0, lng: 0 };
      const fakeCenter = { lat: destination.lat + off.lat, lng: destination.lng + off.lng };

      if(!circleRef.current) {
        circleRef.current = new G.Circle({
          center: fakeCenter,   // ← ψεύτικο κέντρο, όχι η πραγματική θέση
          radius: 500, map, zIndex: 5,
          strokeColor: "#F59E0B", strokeOpacity: 0.9, strokeWeight: 2.5,
          fillColor: "#F59E0B", fillOpacity: 0.12,
        });
      }
      if(!markersRef.current.hidden) {
        // Το marker επίσης στο ΤΥΧΑΙΟ κέντρο — όχι στην πραγματική θέση
        markersRef.current.hidden = new G.Marker({
          position: fakeCenter, map, zIndex: 6,
          icon: {
            path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
            fillColor:"#F59E0B", fillOpacity:0.55, strokeColor:"#F59E0B", strokeWeight:1,
            scale:1.3, anchor: new G.Point(12,22)
          },
          title: "Κρυφή θέση parking"
        });
        markersRef.current.hiddenLabel = new G.InfoWindow({
          content: `<div style="font-size:11px;font-weight:700;color:#fff;background:#F59E0B;padding:2px 8px;border-radius:8px;">🔒 Κρυφή θέση</div>`,
          disableAutoPan: true,
        });
        markersRef.current.hiddenLabel.open(map, markersRef.current.hidden);
      }
    }

    // ── Αποκάλυψη θέσης ───────────────────────────────────────────
    if(destination && revealed) {
      if(circleRef.current) { circleRef.current.setMap(null); circleRef.current = null; }
      if(markersRef.current.hidden) { markersRef.current.hidden.setMap(null); delete markersRef.current.hidden; }
      if(markersRef.current.hiddenLabel) { markersRef.current.hiddenLabel.close(); delete markersRef.current.hiddenLabel; }
      if(!markersRef.current.dest) {
        markersRef.current.dest = new G.Marker({
          position: destination, map, zIndex: 12,
          icon: { path:"M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
            fillColor:"#00D4AA", fillOpacity:1, strokeColor:"#fff", strokeWeight:1.5,
            scale:1.8, anchor: new G.Point(12,22) },
          title: dealAddress || "Θέση Parking",
          animation: G.Animation.BOUNCE
        });
        markersRef.current.destLabel = new G.InfoWindow({
          content: `<div style="font-size:11px;font-weight:700;color:#fff;background:#00D4AA;padding:2px 8px;border-radius:8px;white-space:nowrap;">🅿️ ${dealAddress||'Θέση parking'}</div>`,
          disableAutoPan: true,
        });
        markersRef.current.destLabel.open(map, markersRef.current.dest);
        // Zoom in στην αποκαλυφθείσα θέση
        map.panTo(destination);
        map.setZoom(18);
        setTimeout(() => markersRef.current.dest?.setAnimation(null), 3000);
      }
    }

    // ── Marker άλλου χρήστη ───────────────────────────────────────
    if(otherPos && showOther) {
      const otherColor = role==='seeker' ? "#00D4AA" : "#0099FF";
      const otherLabel = role==='seeker' ? "🚗 Giver" : "🔍 Seeker";
      if(markersRef.current.other) {
        markersRef.current.other.setPosition(otherPos);
        if(markersRef.current.otherGlow) markersRef.current.otherGlow.setPosition(otherPos);
      } else {
        markersRef.current.otherGlow = new G.Marker({
          position: otherPos, map, zIndex: 8,
          icon: { path: G.SymbolPath.CIRCLE, scale: 16,
            fillColor: otherColor, fillOpacity: 0.18,
            strokeColor:"transparent", strokeWeight:0 }
        });
        markersRef.current.other = new G.Marker({
          position: otherPos, map, zIndex: 9,
          icon: { path: G.SymbolPath.CIRCLE, scale: 9,
            fillColor: otherColor, fillOpacity:1,
            strokeColor:"#fff", strokeWeight:2.5 }
        });
        markersRef.current.otherLabel = new G.InfoWindow({
          content: `<div style="font-size:11px;font-weight:700;color:#fff;background:${otherColor};padding:2px 7px;border-radius:8px;white-space:nowrap;">${otherLabel}</div>`,
          disableAutoPan: true,
        });
        markersRef.current.otherLabel.open(map, markersRef.current.other);
      }
    } else if(markersRef.current.other && !showOther) {
      markersRef.current.other.setMap(null);
      if(markersRef.current.otherGlow) markersRef.current.otherGlow.setMap(null);
      if(markersRef.current.otherLabel) markersRef.current.otherLabel.close();
      delete markersRef.current.other;
      delete markersRef.current.otherGlow;
      delete markersRef.current.otherLabel;
    }

    // ── Route + ETA (μόνο για Seeker) ─────────────────────────────
    if(role==='seeker' && myPos && destination && directionsRendererRef.current) {
      const ds = new G.DirectionsService();
      let navTarget = destination;

      // Αν δεν αποκαλύφθηκε → πλοήγηση στην άκρη του κύκλου 500μ
      if(!revealedRef.current && G.geometry) {
        const heading = G.geometry.spherical.computeHeading(
          new G.LatLng(destination.lat, destination.lng),
          new G.LatLng(myPos.lat, myPos.lng)
        );
        const edgePoint = G.geometry.spherical.computeOffset(
          new G.LatLng(destination.lat, destination.lng), 500, heading
        );
        navTarget = { lat: edgePoint.lat(), lng: edgePoint.lng() };
      }

      ds.route(
        { origin: myPos, destination: navTarget, travelMode: G.TravelMode.DRIVING, provideRouteAlternatives: false },
        (result, status) => {
          if(status !== 'OK') return;
          directionsRendererRef.current.setDirections(result);
          const leg = result.routes[0]?.legs[0];
          if(!leg) return;
          const allSteps = leg.steps.map(s => ({
            text: s.instructions.replace(/<[^>]*>/g,''),
            distance: s.distance?.text || '',
          }));
          const etaMin = Math.ceil((leg.duration?.value || 0) / 60);
          const distText = leg.distance?.text || '';
          setNavInfo(prev => ({
            allSteps,
            stepIdx: prev?.stepIdx || 0,
            eta: etaMin,
            distance: distText,
          }));
        }
      );
    }
  }, [mapReady, myPos, otherPos, destination, showOther, revealed, isCentered]);

  // ── Βήμα turn-by-turn: αυτόματη πρόοδος βάσει εγγύτητας ────────
  useEffect(() => {
    if(!navInfo?.allSteps || !myPos || !mapInstanceRef.current) return;
    // Χρήση geometry για να υπολογίσουμε πόσο κοντά είμαστε στο επόμενο waypoint
    // Για απλότητα, εμφανίζουμε το επόμενο βήμα κάθε 30 δευτερόλεπτα αυτόματα
    // (Η πλήρης υλοποίηση απαιτεί waypoint coordinates από το DirectionsResult)
  }, [myPos, navInfo]);

  const currentNavStep = navInfo?.allSteps?.[stepIdx];
  const totalSteps = navInfo?.allSteps?.length || 0;

  const getArrow = (text='') => {
    const t = text.toLowerCase();
    if(t.includes('δεξ')||t.includes('right')) return '↱';
    if(t.includes('αριστ')||t.includes('left')) return '↰';
    if(t.includes('στρίψ')||t.includes('turn')) return '↻';
    if(t.includes('συνέχ')||t.includes('continue')) return '↑';
    if(t.includes('φτάσ')||t.includes('arriv')||t.includes('destination')) return '🅿️';
    return '↑';
  };

  const handleRecenter = () => {
    if(myPosRef.current && mapInstanceRef.current) {
      mapInstanceRef.current.panTo(myPosRef.current);
      mapInstanceRef.current.setZoom(17);
      setIsCentered(true);
    }
  };

  return (
    <div style={{position:"fixed",inset:0,zIndex:200,background:"#1a1f2e"}}>
      {/* Χάρτης fullscreen */}
      {!mapReady && (
        <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:12,color:"#8ec3b9",fontSize:13}}>
          <div style={{fontSize:32}}>🗺️</div>
          <div>Φόρτωση χάρτη...</div>
        </div>
      )}
      <div ref={mapRef} style={{position:"absolute",inset:0,display:mapReady?"block":"none"}}/>

      {/* ── Turn-by-turn banner (πάνω) ── */}
      {currentNavStep && role==='seeker' && (
        <div style={{position:"absolute",top:0,left:0,right:0,zIndex:20,boxShadow:"0 4px 24px rgba(0,0,0,0.5)"}}>
          {/* Κύρια οδηγία */}
          <div
            style={{background:"#0099FF",padding:"14px 16px",display:"flex",alignItems:"center",gap:12,cursor:"pointer"}}
            onClick={()=>setShowStepsList(s=>!s)}
          >
            <div style={{width:50,height:50,borderRadius:12,background:"rgba(255,255,255,0.22)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:26,fontWeight:900}}>
              {getArrow(currentNavStep.text)}
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{color:"#fff",fontSize:14,fontWeight:800,lineHeight:1.35,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                {currentNavStep.text}
              </div>
              <div style={{color:"rgba(255,255,255,0.75)",fontSize:11,marginTop:3,display:"flex",gap:10,alignItems:"center"}}>
                {navInfo?.eta != null && <span>⏱ {navInfo.eta} λεπτά</span>}
                {navInfo?.distance && <span>· 📏 {navInfo.distance}</span>}
                {!revealed && <span>· 🔒 Θέση κρυφή</span>}
              </div>
            </div>
            {/* Βήμα counter + expand */}
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:2,flexShrink:0}}>
              <div style={{color:"#fff",fontSize:10,fontWeight:700,opacity:0.8}}>{stepIdx+1}/{totalSteps}</div>
              <div style={{color:"rgba(255,255,255,0.6)",fontSize:14}}>{showStepsList?'▲':'▼'}</div>
            </div>
          </div>

          {/* Λίστα όλων των βημάτων (expandable) */}
          {showStepsList && (
            <div style={{background:"rgba(10,15,30,0.97)",borderTop:"1px solid rgba(0,153,255,0.3)",maxHeight:220,overflowY:"auto"}}>
              {navInfo.allSteps.map((s,i)=>(
                <div
                  key={i}
                  onClick={()=>{setStepIdx(i);setShowStepsList(false);}}
                  style={{
                    padding:"10px 16px",display:"flex",alignItems:"center",gap:12,cursor:"pointer",
                    background:i===stepIdx?"rgba(0,153,255,0.15)":"transparent",
                    borderBottom:"1px solid rgba(255,255,255,0.05)",
                  }}
                >
                  <div style={{width:28,height:28,borderRadius:8,background:i===stepIdx?"#0099FF":"rgba(255,255,255,0.08)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0}}>
                    {getArrow(s.text)}
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{color:i===stepIdx?"#0099FF":"#cdd8e3",fontSize:12,fontWeight:i===stepIdx?700:400,lineHeight:1.4}}>{s.text}</div>
                    {s.distance&&<div style={{color:"#6b7c8d",fontSize:10,marginTop:1}}>{s.distance}</div>}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Πρόοδος βημάτων */}
          <div style={{background:"rgba(0,0,0,0.5)",padding:"4px 16px",display:"flex",gap:3}}>
            {navInfo.allSteps.map((_,i)=>(
              <div key={i} onClick={()=>setStepIdx(i)} style={{flex:1,height:3,borderRadius:4,background:i<=stepIdx?"#0099FF":"rgba(255,255,255,0.2)",cursor:"pointer",transition:"background 0.3s"}}/>
            ))}
          </div>
        </div>
      )}

      {/* ── Controls (δεξιά) ── */}
      <div style={{position:"absolute",top: currentNavStep&&role==='seeker' ? 110 : 16,right:16,display:"flex",flexDirection:"column",gap:10,zIndex:15}}>
        {/* Recenter button */}
        {!isCentered && (
          <button
            onClick={handleRecenter}
            style={{width:44,height:44,borderRadius:22,background:"rgba(0,0,0,0.85)",border:"1.5px solid rgba(0,153,255,0.5)",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(10px)",fontSize:18,boxShadow:"0 2px 12px rgba(0,0,0,0.4)"}}
            title="Επιστροφή στη θέση μου"
          >🎯</button>
        )}
        {/* Zoom in/out */}
        <button
          onClick={()=>mapInstanceRef.current?.setZoom((mapInstanceRef.current.getZoom()||16)+1)}
          style={{width:44,height:44,borderRadius:22,background:"rgba(0,0,0,0.75)",border:"none",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(10px)",color:"#fff",fontSize:22,fontWeight:300}}
        >+</button>
        <button
          onClick={()=>mapInstanceRef.current?.setZoom((mapInstanceRef.current.getZoom()||16)-1)}
          style={{width:44,height:44,borderRadius:22,background:"rgba(0,0,0,0.75)",border:"none",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(10px)",color:"#fff",fontSize:22,fontWeight:300}}
        >−</button>
        {onHome && (
          <button onClick={onHome} style={{width:44,height:44,borderRadius:22,background:"rgba(0,0,0,0.75)",border:"none",color:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(10px)"}}>🏠</button>
        )}
        {onCancel && (
          <button onClick={onCancel} style={{width:44,height:44,borderRadius:22,background:"rgba(239,68,68,0.85)",border:"none",color:"#fff",fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(10px)"}}>✕</button>
        )}
      </div>

      {/* ── Bottom panel ── */}
      <div style={{position:"absolute",bottom:0,left:0,right:0,zIndex:10}}>
        {/* Revealed: διεύθυνση */}
        {revealed && dealAddress && (
          <div style={{background:"rgba(0,212,170,0.97)",padding:"12px 16px",display:"flex",alignItems:"center",gap:12,backdropFilter:"blur(8px)",boxShadow:"0 -4px 20px rgba(0,212,170,0.3)"}}>
            <div style={{width:40,height:40,borderRadius:12,background:"rgba(255,255,255,0.25)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>🅿️</div>
            <div style={{flex:1}}>
              <div style={{color:"#fff",fontSize:14,fontWeight:800,lineHeight:1.3}}>{dealAddress}</div>
              <div style={{color:"rgba(255,255,255,0.8)",fontSize:11,marginTop:2}}>✅ Η θέση αποκαλύφθηκε — πήγαινε εκεί!</div>
            </div>
          </div>
        )}
        {/* Revealed: όχημα */}
        {revealed && otherVehicle && (
          <div style={{background:"rgba(168,85,247,0.95)",padding:"10px 16px",display:"flex",alignItems:"center",gap:10,backdropFilter:"blur(8px)"}}>
            <span style={{fontSize:18}}>🚗</span>
            <span style={{color:"#fff",fontSize:13,fontWeight:700}}>{otherVehicle}</span>
          </div>
        )}
        {/* Action buttons (children) */}
        {children && (
          <div style={{background:"rgba(10,15,30,0.97)",padding:"16px",backdropFilter:"blur(12px)",borderTop:"1px solid rgba(255,255,255,0.07)"}}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── RESET PASSWORD SCREEN ───────────────────────────────────────────────────
function ResetPasswordScreen({onDone, hash}){
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [sessionReady, setSessionReady] = useState(false);

  // Διάβασε token από το hash που πέρασε το App (πριν καθαριστεί το URL)
  useEffect(()=>{
    const setupSession = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const hashToUse = hash || window.location.hash;
        if(hashToUse) {
          const params = new URLSearchParams(hashToUse.substring(1));
          const accessToken = params.get('access_token');
          const refreshToken = params.get('refresh_token');
          if(accessToken && refreshToken) {
            const { error } = await supabase.auth.setSession({
              access_token: accessToken,
              refresh_token: refreshToken,
            });
            if(error) { setError("Ο σύνδεσμος έχει λήξει. Ζήτησε νέο."); return; }
            setSessionReady(true);
            return;
          }
        }
        // Fallback: έλεγχος αν υπάρχει ήδη session
        const { data } = await supabase.auth.getSession();
        if(data?.session) { setSessionReady(true); return; }
        setError("Ο σύνδεσμος δεν είναι έγκυρος ή έχει λήξει. Ζήτησε νέο.");
      } catch(e) { setError(e.message); }
    };
    setupSession();
  },[hash]);

  const isStrong = newPwd.length >= 8;
  const matches = newPwd === confirmPwd;

  const handleSave = async () => {
    if(!isStrong || !matches || !sessionReady) return;
    setLoading(true);
    setError(null);
    try {
      const { supabase } = await import("./supabase_client");
      const { error } = await supabase.auth.updateUser({ password: newPwd });
      if(error) { setError(error.message); setLoading(false); return; }
      setSuccess(true);
      setTimeout(onDone, 2500);
    } catch(e) { setError(e.message); }
    setLoading(false);
  };

  return (
    <div style={{minHeight:"100%",background:C.bg,display:"flex",flexDirection:"column"}}>
      <div style={{padding:"20px 20px 10px",borderBottom:`1px solid ${C.border}`,background:C.surface,display:"flex",alignItems:"center",gap:12}}>
        <span style={{fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:17,color:C.text}}>🔒 Νέος Κωδικός</span>
      </div>
      <div style={{padding:24,flex:1}}>
        {success ? (
          <div style={{textAlign:"center",padding:"40px 0"}}>
            <div style={{fontSize:64,marginBottom:16}}>✅</div>
            <div style={{color:C.accent,fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:20,marginBottom:8}}>Επιτυχία!</div>
            <div style={{color:C.muted,fontSize:13}}>Ο κωδικός σου άλλαξε. Συνδέσου τώρα.</div>
          </div>
        ) : <>
          <div style={{color:C.muted,fontSize:13,marginBottom:24,lineHeight:1.6}}>
            Ορίσε νέο κωδικό για τον λογαριασμό σου.
          </div>

          <div style={{marginBottom:14}}>
            <div style={{fontSize:12,color:C.muted,marginBottom:5,fontWeight:600}}>Νέος Κωδικός</div>
            <input
              type="password"
              value={newPwd}
              onChange={e=>setNewPwd(e.target.value)}
              placeholder="Τουλάχιστον 8 χαρακτήρες"
              style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1px solid ${newPwd&&!isStrong?C.danger:C.border}`,background:C.surface,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}
            />
          </div>

          <div style={{marginBottom:20}}>
            <div style={{fontSize:12,color:C.muted,marginBottom:5,fontWeight:600}}>Επιβεβαίωση Κωδικού</div>
            <input
              type="password"
              value={confirmPwd}
              onChange={e=>setConfirmPwd(e.target.value)}
              placeholder="Επανάλαβε τον κωδικό"
              style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1px solid ${confirmPwd&&!matches?C.danger:C.border}`,background:C.surface,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}
            />
          </div>

          <div style={{marginBottom:20}}>
            {[
              {label:"Τουλάχιστον 8 χαρακτήρες", ok: newPwd.length>=8},
              {label:"Οι κωδικοί ταιριάζουν", ok: confirmPwd.length>0 && matches},
            ].map((r,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                <div style={{width:16,height:16,borderRadius:8,background:r.ok?C.accent:C.border,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  {r.ok && <span style={{color:"#fff",fontSize:10,fontWeight:800}}>✓</span>}
                </div>
                <span style={{color:r.ok?C.text:C.muted,fontSize:12}}>{r.label}</span>
              </div>
            ))}
          </div>

          {error && (
            <div style={{background:"rgba(239,68,68,0.1)",border:`1px solid ${C.danger}44`,borderRadius:10,padding:12,marginBottom:16}}>
              <div style={{color:C.danger,fontSize:13}}>❌ {error}</div>
              {error.includes("λήξει") && (
                <button onClick={onDone} style={{background:"none",border:"none",color:C.accent,cursor:"pointer",fontSize:12,marginTop:6,fontWeight:700}}>
                  → Πήγαινε στη Σύνδεση
                </button>
              )}
            </div>
          )}

          <button
            onClick={handleSave}
            disabled={!isStrong||!matches||loading||!sessionReady}
            style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:isStrong&&matches&&sessionReady?`linear-gradient(135deg,${C.accent},#1A2EAA)`:C.border,color:"#fff",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:15,cursor:isStrong&&matches&&sessionReady?"pointer":"not-allowed"}}>
            {loading?"⏳ Αποθήκευση...":"Αποθήκευση Νέου Κωδικού →"}
          </button>
        </>}
      </div>
    </div>
  );
}

export default function App(){
  // Διάβασμα hash ΑΜΕΣΩΣ κατά την αρχικοποίηση — πριν οποιοδήποτε render
  const initialHash = window.location.hash;
  const isRecovery = initialHash.includes('type=recovery') || 
                     (initialHash.includes('access_token') && initialHash.includes('recovery'));
  
  // Καθαρισμός URL αμέσως αν είναι recovery link
  if(isRecovery) {
    window.history.replaceState(null, '', window.location.pathname);
  }

  // ── MAINTENANCE MODE ──
  // Για να μπεις εσύ: toparking.app?preview=true
  const isPreview = new URLSearchParams(window.location.search).get('preview') === 'true';
  const MAINTENANCE = true; // ← άλλαξε σε false για launch

  if(MAINTENANCE && !isPreview && !isRecovery) {
    return (
      <div style={{fontFamily:"'DM Sans',sans-serif",background:"#0A0E1A",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
        <div style={{textAlign:"center",maxWidth:380}}>
          {/* Logo */}
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10,marginBottom:32}}>
            <img src="/ToParking.png" alt="ToParking" style={{width:56,height:56,objectFit:"contain"}}/>
            <span style={{fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:28,color:"#1A2EAA",letterSpacing:-0.5}}>ToParking</span>
          </div>

          {/* Main message */}
          <div style={{fontSize:48,marginBottom:16}}>🚀</div>
          <h1 style={{color:"#F0F4FF",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:26,marginBottom:12,lineHeight:1.3}}>
            Σύντομα κοντά σας!
          </h1>
          <p style={{color:"#6B7A99",fontSize:15,lineHeight:1.7,marginBottom:32}}>
            Ετοιμάζουμε κάτι ξεχωριστό για την έξυπνη στάθμευση στην πόλη. Σύντομα θα είμαστε έτοιμοι!
          </p>

          <div style={{color:"#6B7A99",fontSize:11,marginTop:24}}>
            © 2025 ToParking · Αθήνα, Ελλάδα
          </div>
        </div>
      </div>
    );
  }

  const [screen,setScreen]=useState("auth");
  const [user,setUser]=useState(null);
  const [vehicles,setVehicles]=useState([{id:1,type:"Αυτοκίνητο",brand:"Toyota",model:"Corolla",color:"Ασημί",year:"2019"}]);
  const [darkMode,setDarkMode]=useState(true);
  const [notifications,setNotifications]=useState({deals:true,security:true,reminders:true});
  const [showOnboarding,setShowOnboarding]=useState(false);
  const [activeDeal,setActiveDeal]=useState(null);
  const [isResetPassword, setIsResetPassword]=useState(isRecovery);
  const [resetHash] = useState(isRecovery ? initialHash : "");
  const T=useT(darkMode);

  // Session timeout — αυτόματη αποσύνδεση μετά από 30 λεπτά αδράνειας
  useEffect(()=>{
    if(!user) return;
    let timeout;
    const resetTimeout = () => {
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
        const { supabase } = await import("./supabase_client");
        await supabase.auth.signOut();
        setUser(null);
        setScreen("auth");
      }, 30 * 60 * 1000); // 30 λεπτά
    };
    const events = ['mousedown','keydown','touchstart','scroll'];
    events.forEach(e => window.addEventListener(e, resetTimeout));
    resetTimeout();
    return () => {
      clearTimeout(timeout);
      events.forEach(e => window.removeEventListener(e, resetTimeout));
    };
  },[user]);

  // Heartbeat — ενημερώνει last_seen κάθε 30 δευτερόλεπτα
  useEffect(()=>{
    if(!user) return;
    let alive = true;
    const sendHeartbeat = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const { data: authData } = await supabase.auth.getUser();
        const au = authData?.user; if(!au) return;
        await supabase.from('users').update({ last_seen: new Date().toISOString() }).eq('auth_id', au.id);
      } catch(e) {}
    };
    sendHeartbeat();
    const interval = setInterval(()=>{ if(alive) sendHeartbeat(); }, 30000);
    return () => { alive = false; clearInterval(interval); };
  },[user]);

  // Poll για active deals — τρέχει μόνο αφού γίνει login
  useEffect(()=>{
    if(!user) return;
    let alive = true;
    const checkDeal = async () => {
      try {
        const { supabase } = await import("./supabase_client");
        const { data: authData } = await supabase.auth.getUser();
        const au = authData?.user;
        if(!au) return;
        const { data: profile } = await supabase.from('users').select('id').eq('auth_id', au.id).single();
        if(!profile || !alive) return;
        const twoHoursAgo = new Date(Date.now() - 2*60*60*1000).toISOString();
        const now = new Date().toISOString();
        // Ελέγχουμε πρώτα για active deals
        const { data: deal } = await supabase
          .from('deals')
          .select('id,status,seeker_id,giver_id,listing_id,listings(region)')
          .or(`seeker_id.eq.${profile.id},giver_id.eq.${profile.id}`)
          .in('status',['matched','seeker_ready','giver_departed','spot_accepted'])
          .gte('created_at', twoHoursAgo)
          .order('created_at',{ascending:false})
          .limit(1).maybeSingle();
        if(!alive) return;
        if(deal && deal.listings?.region) {
          setActiveDeal({...deal, role: deal.seeker_id===profile.id ? 'seeker' : 'giver'});
          return;
        }
        // Αν δεν υπάρχει ενεργό deal, ελέγχουμε για active listing
        // Πρώτα βεβαιωνόμαστε ότι δεν υπάρχει completed deal για αυτό το listing
        const { data: listing } = await supabase
          .from('listings')
          .select('id,region,status,giver_id,price,giver_earn')
          .eq('giver_id', profile.id)
          .eq('status','active')
          .gt('expires_at', now)
          .order('created_at',{ascending:false})
          .limit(1).maybeSingle();
        if(!alive) return;
        if(listing) {
          // Ελέγχουμε αν υπάρχει completed/cancelled deal για αυτό το listing
          const { data: closedDeal } = await supabase
            .from('deals')
            .select('id,status')
            .eq('listing_id', listing.id)
            .in('status', ['completed','cancelled','giver_cancelled','seeker_cancelled'])
            .limit(1).maybeSingle();
          if(closedDeal) {
            // Το deal ολοκληρώθηκε — κάνε το listing inactive
            await supabase.from('listings').update({ status: 'inactive' }).eq('id', listing.id);
            setActiveDeal(null);
            return;
          }
          setActiveDeal({
            id: null,
            listing_id: listing.id,
            listingId: listing.id,
            status: 'waiting',
            role: 'giver',
            listings: { region: listing.region },
            isListing: true,
          });
        } else {
          setActiveDeal(null);
        }
      } catch(e) { /* silence */ }
    };
    checkDeal();
    const interval = setInterval(checkDeal, 8000);
    return () => { alive=false; clearInterval(interval); };
  },[user]);

  const handleResumeDeal = () => {
    if(!activeDeal) return;
    // Listing χωρίς deal → Giver επιστρέφει στο GiveSpace να περιμένει
    // Deal → Giver στο giveSpace, Seeker στο takeSpace
    setScreen(activeDeal.role === 'giver' ? 'giveSpace' : 'takeSpace');
  };

  useEffect(()=>{
    const link=document.createElement("link");
    link.rel="stylesheet";
    link.href="https://fonts.googleapis.com/css2?family=Syne:wght@700;800;900&family=DM+Sans:wght@400;500;600&display=swap";
    document.head.appendChild(link);
    if(!document.getElementById("toparking-styles")) {
      const style = document.createElement("style");
      style.id = "toparking-styles";
      style.textContent = `@keyframes pulse { 0%,100%{box-shadow:0 0 0 0 rgba(0,212,170,0.4)} 50%{box-shadow:0 0 0 8px rgba(0,212,170,0)} }`;
      document.head.appendChild(style);
    }
  },[]);

  const back=()=>setScreen("main");
  const screens={
    auth:<AuthScreen onAuth={u=>{setUser(u);setScreen("main");const hideOnboarding=localStorage.getItem('toparking_hide_onboarding');if(!hideOnboarding){setTimeout(()=>setShowOnboarding(true),500);}}} />,
    main:<MainScreen user={user||{}} onNavigate={setScreen} darkMode={darkMode} activeDeal={activeDeal} onResumeDeal={handleResumeDeal}/>,
    giveSpace:<GiveSpaceScreen onBack={back} darkMode={darkMode} user={user||{}} resumeDealId={activeDeal?.role==='giver'&&!activeDeal.isListing?activeDeal.id:null} resumeListingId={activeDeal?.isListing?activeDeal.listing_id:null}/>,
    takeSpace:<TakeSpaceScreen onBack={back} darkMode={darkMode} user={user||{}} resumeDeal={activeDeal?.role==='seeker'?activeDeal:null}/>,
    vehicles:<VehiclesScreen key={user?.email||user?.userId||user?.username} onBack={back} darkMode={darkMode} userId={user?.userId}/>,
    wallet:<WalletScreen onBack={back} darkMode={darkMode}/>,
    settings:<SettingsScreen onBack={back} darkMode={darkMode} setDarkMode={setDarkMode} notifications={notifications} setNotifications={setNotifications} user={user||{}} onLogout={async()=>{ const {supabase}=await import("./supabase_client"); await supabase.auth.signOut(); setUser(null); setScreen("auth"); }}/>,
    chat:<ChatScreen onBack={back} darkMode={darkMode}/>,
    profile:<ProfileScreen key={user?.userId||user?.username} onBack={back} user={user||{}} darkMode={darkMode}/>,
    navDemo:<NavDemoScreen onBack={back}/>,
  };

  return (
    <div style={{fontFamily:"'DM Sans',sans-serif",background:"#000",minHeight:"100vh",display:"flex",justifyContent:"center",alignItems:"flex-start",padding:"20px 0"}}>
      <div style={{width:390,minHeight:720,background:T.bg,borderRadius:40,overflow:"hidden",boxShadow:"0 30px 80px rgba(0,0,0,0.8),0 0 0 1px rgba(255,255,255,0.05)",position:"relative"}}>
        {isResetPassword ? (
          <div style={{overflowY:"auto",maxHeight:"85vh"}}>
            <ResetPasswordScreen hash={resetHash} onDone={()=>{ setIsResetPassword(false); setScreen("auth"); }}/>
          </div>
        ) : (
          <>
            <div style={{overflowY:"auto",maxHeight:"85vh"}}>{screens[screen]||screens.main}</div>
        {screen!=="auth"&&<div style={{position:"sticky",bottom:0,background:T.surface,borderTop:`1px solid ${T.border}`,display:"flex",padding:"10px 0 4px"}}>
          {[{icon:"🏠",label:"Αρχική",s:"main"},{icon:"🅿️",label:"Δώσε",s:"giveSpace"},{icon:"🔍",label:"Βρες",s:"takeSpace"},{icon:"🗺️",label:"Demo",s:"navDemo"},{icon:"💳",label:"Πορτοφόλι",s:"wallet"}].map(({icon,label,s})=>(
            <button key={s} onClick={()=>setScreen(s)} style={{flex:1,background:"none",border:"none",cursor:"pointer",color:screen===s?C.accent:C.muted,display:"flex",flexDirection:"column",alignItems:"center",gap:2,padding:"4px 0"}}>
              <span style={{fontSize:20}}>{icon}</span><span style={{fontSize:9,fontWeight:700}}>{label}</span>
            </button>
          ))}
        </div>}
        {/* Help button — εμφανίζεται παντού εκτός auth */}
        {screen!=="auth"&&<button onClick={()=>setShowOnboarding(true)}
          style={{position:"absolute",bottom:180,left:16,width:40,height:40,borderRadius:20,background:`linear-gradient(135deg,${C.accent},#1A2EAA)`,border:"none",cursor:"pointer",fontSize:18,boxShadow:`0 4px 16px ${C.glow}`,zIndex:20}}>
          ?
        </button>}
        {/* Onboarding overlay */}
        {showOnboarding&&<OnboardingOverlay onDone={()=>setShowOnboarding(false)}/>}
          </>
        )}
      </div>
    </div>
  );
}
